const words = [
  {
    "name": "men's dress shirts",
    "slug": "mens-dress-shirts"
  },
  {
    "name": "men's casual shirts",
    "slug": "mens-casual-shirts"
  },
  {
    "name": "men's formal shirts",
    "slug": "mens-formal-shirts"
  },
  {
    "name": "men's work shirts",
    "slug": "mens-work-shirts"
  },
  {
    "name": "men's slim shirts",
    "slug": "mens-slim-shirts"
  },
  {
    "name": "men's office shirts",
    "slug": "mens-office-shirts"
  },
  {
    "name": "men's summer shirts",
    "slug": "mens-summer-shirts"
  },
  {
    "name": "men's party shirts",
    "slug": "mens-party-shirts"
  },
  {
    "name": "men's wedding shirts",
    "slug": "mens-wedding-shirts"
  },
  {
    "name": "men's travel shirts",
    "slug": "mens-travel-shirts"
  },
  {
    "name": "men's evening shirts",
    "slug": "mens-evening-shirts"
  },
  {
    "name": "men's business shirts",
    "slug": "mens-business-shirts"
  },
  {
    "name": "men's fashion shirts",
    "slug": "mens-fashion-shirts"
  },
  {
    "name": "men's designer shirts",
    "slug": "mens-designer-shirts"
  },
  {
    "name": "men's classic shirts",
    "slug": "mens-classic-shirts"
  },
  {
    "name": "men's modern shirts",
    "slug": "mens-modern-shirts"
  },
  {
    "name": "men's fitted shirts",
    "slug": "mens-fitted-shirts"
  },
  {
    "name": "men's tailored shirts",
    "slug": "mens-tailored-shirts"
  },
  {
    "name": "men's loose shirts",
    "slug": "mens-loose-shirts"
  },
  {
    "name": "men's stretch shirts",
    "slug": "mens-stretch-shirts"
  },
  {
    "name": "men's lightweight shirts",
    "slug": "mens-lightweight-shirts"
  },
  {
    "name": "men's regular shirts",
    "slug": "mens-regular-shirts"
  },
  {
    "name": "men's travel shirts",
    "slug": "mens-travel-shirts"
  },
  {
    "name": "men's performance shirts",
    "slug": "mens-performance-shirts"
  },
  {
    "name": "men's wrinkle-free shirts",
    "slug": "mens-wrinkle-free-shirts"
  },
  {
    "name": "men's breathable shirts",
    "slug": "mens-breathable-shirts"
  },
  {
    "name": "men's moisture-wicking shirts",
    "slug": "mens-moisture-wicking-shirts"
  },
  {
    "name": "men's quick-dry shirts",
    "slug": "mens-quick-dry-shirts"
  },
  {
    "name": "men's thermal shirts",
    "slug": "mens-thermal-shirts"
  },
  {
    "name": "men's insulated shirts",
    "slug": "mens-insulated-shirts"
  },
  {
    "name": "men's anti-odor shirts",
    "slug": "mens-anti-odor-shirts"
  },
  {
    "name": "men's seamless shirts",
    "slug": "mens-seamless-shirts"
  },
  {
    "name": "men's easy-care shirts",
    "slug": "mens-easy-care-shirts"
  },
  {
    "name": "men's non-iron shirts",
    "slug": "mens-non-iron-shirts"
  },
  {
    "name": "men's long shirts",
    "slug": "mens-long-shirts"
  },
  {
    "name": "men's short shirts",
    "slug": "mens-short-shirts"
  },
  {
    "name": "men's versatile shirts",
    "slug": "mens-versatile-shirts"
  },
  {
    "name": "men's business casual shirts",
    "slug": "mens-business-casual-shirts"
  },
  {
    "name": "men's stylish shirts",
    "slug": "mens-stylish-shirts"
  },
  {
    "name": "men's wardrobe shirts",
    "slug": "mens-wardrobe-shirts"
  },
  {
    "name": "men's black shirts",
    "slug": "mens-black-shirts"
  },
  {
    "name": "white dress shirts",
    "slug": "white-dress-shirts"
  },
  {
    "name": "navy blue shirts",
    "slug": "navy-blue-shirts"
  },
  {
    "name": "grey formal shirts",
    "slug": "grey-formal-shirts"
  },
  {
    "name": "beige casual shirts",
    "slug": "beige-casual-shirts"
  },
  {
    "name": "black office shirts",
    "slug": "black-office-shirts"
  },
  {
    "name": "white slim shirts",
    "slug": "white-slim-shirts"
  },
  {
    "name": "navy work shirts",
    "slug": "navy-work-shirts"
  },
  {
    "name": "grey dress shirts",
    "slug": "grey-dress-shirts"
  },
  {
    "name": "beige summer shirts",
    "slug": "beige-summer-shirts"
  },
  {
    "name": "black formal shirts",
    "slug": "black-formal-shirts"
  },
  {
    "name": "white casual shirts",
    "slug": "white-casual-shirts"
  },
  {
    "name": "navy slim shirts",
    "slug": "navy-slim-shirts"
  },
  {
    "name": "grey office shirts",
    "slug": "grey-office-shirts"
  },
  {
    "name": "beige work shirts",
    "slug": "beige-work-shirts"
  },
  {
    "name": "black dress shirts",
    "slug": "black-dress-shirts"
  },
  {
    "name": "white office shirts",
    "slug": "white-office-shirts"
  },
  {
    "name": "navy casual shirts",
    "slug": "navy-casual-shirts"
  },
  {
    "name": "grey slim shirts",
    "slug": "grey-slim-shirts"
  },
  {
    "name": "beige formal shirts",
    "slug": "beige-formal-shirts"
  },
  {
    "name": "black casual shirts",
    "slug": "black-casual-shirts"
  },
  {
    "name": "white work shirts",
    "slug": "white-work-shirts"
  },
  {
    "name": "navy formal shirts",
    "slug": "navy-formal-shirts"
  },
  {
    "name": "grey casual shirts",
    "slug": "grey-casual-shirts"
  },
  {
    "name": "beige office shirts",
    "slug": "beige-office-shirts"
  },
  {
    "name": "black slim shirts",
    "slug": "black-slim-shirts"
  },
  {
    "name": "white dress shirts",
    "slug": "white-dress-shirts"
  },
  {
    "name": "navy office shirts",
    "slug": "navy-office-shirts"
  },
  {
    "name": "grey work shirts",
    "slug": "grey-work-shirts"
  },
  {
    "name": "beige casual shirts",
    "slug": "beige-casual-shirts"
  },
  {
    "name": "black formal shirts",
    "slug": "black-formal-shirts"
  },
  {
    "name": "white slim shirts",
    "slug": "white-slim-shirts"
  },
  {
    "name": "navy work shirts",
    "slug": "navy-work-shirts"
  },
  {
    "name": "grey dress shirts",
    "slug": "grey-dress-shirts"
  },
  {
    "name": "beige summer shirts",
    "slug": "beige-summer-shirts"
  },
  {
    "name": "black office shirts",
    "slug": "black-office-shirts"
  },
  {
    "name": "white casual shirts",
    "slug": "white-casual-shirts"
  },
  {
    "name": "navy slim shirts",
    "slug": "navy-slim-shirts"
  },
  {
    "name": "grey formal shirts",
    "slug": "grey-formal-shirts"
  },
  {
    "name": "beige work shirts",
    "slug": "beige-work-shirts"
  },
  {
    "name": "black dress shirts",
    "slug": "black-dress-shirts"
  },
  {
    "name": "white office shirts",
    "slug": "white-office-shirts"
  },
  {
    "name": "navy casual shirts",
    "slug": "navy-casual-shirts"
  },
  {
    "name": "grey slim shirts",
    "slug": "grey-slim-shirts"
  },
  {
    "name": "beige formal shirts",
    "slug": "beige-formal-shirts"
  },
  {
    "name": "black casual shirts",
    "slug": "black-casual-shirts"
  },
  {
    "name": "white work shirts",
    "slug": "white-work-shirts"
  },
  {
    "name": "navy formal shirts",
    "slug": "navy-formal-shirts"
  },
  {
    "name": "grey casual shirts",
    "slug": "grey-casual-shirts"
  },
  {
    "name": "beige office shirts",
    "slug": "beige-office-shirts"
  },
  {
    "name": "men's short sleeve dress shirts",
    "slug": "mens-short-sleeve-dress-shirts"
  },
  {
    "name": "men's long sleeve casual shirts",
    "slug": "mens-long-sleeve-casual-shirts"
  },
  {
    "name": "men's slim fit formal shirts",
    "slug": "mens-slim-fit-formal-shirts"
  },
  {
    "name": "men's tailored fit work shirts",
    "slug": "mens-tailored-fit-work-shirts"
  },
  {
    "name": "men's regular fit office shirts",
    "slug": "mens-regular-fit-office-shirts"
  },
  {
    "name": "men's classic fit summer shirts",
    "slug": "mens-classic-fit-summer-shirts"
  },
  {
    "name": "men's modern fit party shirts",
    "slug": "mens-modern-fit-party-shirts"
  },
  {
    "name": "men's relaxed fit wedding shirts",
    "slug": "mens-relaxed-fit-wedding-shirts"
  },
  {
    "name": "men's athletic fit travel shirts",
    "slug": "mens-athletic-fit-travel-shirts"
  },
  {
    "name": "men's performance fabric work shirts",
    "slug": "mens-performance-fabric-work-shirts"
  },
  {
    "name": "men's lightweight everyday wear shirts",
    "slug": "mens-lightweight-everyday-wear-shirts"
  },
  {
    "name": "men's moisture-wicking office shirts",
    "slug": "mens-moisture-wicking-office-shirts"
  },
  {
    "name": "men's wrinkle-free travel shirts",
    "slug": "mens-wrinkle-free-travel-shirts"
  },
  {
    "name": "men's quick-dry performance shirts",
    "slug": "mens-quick-dry-performance-shirts"
  },
  {
    "name": "men's breathable fabric casual shirts",
    "slug": "mens-breathable-fabric-casual-shirts"
  },
  {
    "name": "men's stretch fit formal shirts",
    "slug": "mens-stretch-fit-formal-shirts"
  },
  {
    "name": "men's easy-care business shirts",
    "slug": "mens-easy-care-business-shirts"
  },
  {
    "name": "men's versatile everyday shirts",
    "slug": "mens-versatile-everyday-shirts"
  },
  {
    "name": "men's non-iron dress shirts",
    "slug": "mens-non-iron-dress-shirts"
  },
  {
    "name": "men's muscle fit gym shirts",
    "slug": "mens-muscle-fit-gym-shirts"
  },
  {
    "name": "men's slim fit office shirts",
    "slug": "mens-slim-fit-office-shirts"
  },
  {
    "name": "men's long sleeve formal shirts",
    "slug": "mens-long-sleeve-formal-shirts"
  },
  {
    "name": "men's short sleeve casual shirts",
    "slug": "mens-short-sleeve-casual-shirts"
  },
  {
    "name": "men's performance athletic fit shirts",
    "slug": "mens-performance-athletic-fit-shirts"
  },
  {
    "name": "men's UV-protection work shirts",
    "slug": "mens-uv-protection-work-shirts"
  },
  {
    "name": "men's business casual button shirts",
    "slug": "mens-business-casual-button-shirts"
  },
  {
    "name": "men's tailored long sleeve shirts",
    "slug": "mens-tailored-long-sleeve-shirts"
  },
  {
    "name": "men's comfortable fit dress shirts",
    "slug": "mens-comfortable-fit-dress-shirts"
  },
  {
    "name": "men's travel-ready casual shirts",
    "slug": "mens-travel-ready-casual-shirts"
  },
  {
    "name": "men's durable workwear button shirts",
    "slug": "mens-durable-workwear-button-shirts"
  },
  {
    "name": "men's lightweight wrinkle-free shirts",
    "slug": "mens-lightweight-wrinkle-free-shirts"
  },
  {
    "name": "men's slim fit tailored shirts",
    "slug": "mens-slim-fit-tailored-shirts"
  },
  {
    "name": "men's long sleeve button shirts",
    "slug": "mens-long-sleeve-button-shirts"
  },
  {
    "name": "men's breathable long sleeve shirts",
    "slug": "mens-breathable-long-sleeve-shirts"
  },
  {
    "name": "men's versatile office wear shirts",
    "slug": "mens-versatile-office-wear-shirts"
  },
  {
    "name": "men's casual button-down shirts",
    "slug": "mens-casual-button-down-shirts"
  },
  {
    "name": "men's wrinkle-resistant travel shirts",
    "slug": "mens-wrinkle-resistant-travel-shirts"
  },
  {
    "name": "men's everyday workwear formal shirts",
    "slug": "mens-everyday-workwear-formal-shirts"
  },
  {
    "name": "men's fitted casual button shirts",
    "slug": "mens-fitted-casual-button-shirts"
  },
  {
    "name": "men's office-ready tailored shirts",
    "slug": "mens-office-ready-tailored-shirts"
  },
  {
    "name": "men's relaxed fit work shirts",
    "slug": "mens-relaxed-fit-work-shirts"
  },
  {
    "name": "men's stretch fit casual shirts",
    "slug": "mens-stretch-fit-casual-shirts"
  },
  {
    "name": "men's performance-enhancing athletic shirts",
    "slug": "mens-performance-enhancing-athletic-shirts"
  },
  {
    "name": "men's long sleeve business shirts",
    "slug": "mens-long-sleeve-business-shirts"
  },
  {
    "name": "men's tailored fit dress shirts",
    "slug": "mens-tailored-fit-dress-shirts"
  },
  {
    "name": "men's easy-care wrinkle-free shirts",
    "slug": "mens-easy-care-wrinkle-free-shirts"
  },
  {
    "name": "men's moisture-wicking gym shirts",
    "slug": "mens-moisture-wicking-gym-shirts"
  },
  {
    "name": "men's performance office wear shirts",
    "slug": "mens-performance-office-wear-shirts"
  },
  {
    "name": "men's slim fit business shirts",
    "slug": "mens-slim-fit-business-shirts"
  },
  {
    "name": "men's black dress shirts",
    "slug": "mens-black-dress-shirts"
  },
  {
    "name": "white slim fit shirts",
    "slug": "white-slim-fit-shirts"
  },
  {
    "name": "navy blue formal shirts",
    "slug": "navy-blue-formal-shirts"
  },
  {
    "name": "grey casual button-down shirts",
    "slug": "grey-casual-button-down-shirts"
  },
  {
    "name": "beige short sleeve shirts",
    "slug": "beige-short-sleeve-shirts"
  },
  {
    "name": "black long sleeve shirts",
    "slug": "black-long-sleeve-shirts"
  },
  {
    "name": "white button-up work shirts",
    "slug": "white-button-up-work-shirts"
  },
  {
    "name": "navy blue office shirts",
    "slug": "navy-blue-office-shirts"
  },
  {
    "name": "grey slim fit shirts",
    "slug": "grey-slim-fit-shirts"
  },
  {
    "name": "beige casual button-down shirts",
    "slug": "beige-casual-button-down-shirts"
  },
  {
    "name": "black formal button-up shirts",
    "slug": "black-formal-button-up-shirts"
  },
  {
    "name": "white short sleeve shirts",
    "slug": "white-short-sleeve-shirts"
  },
  {
    "name": "navy blue casual shirts",
    "slug": "navy-blue-casual-shirts"
  },
  {
    "name": "grey long sleeve shirts",
    "slug": "grey-long-sleeve-shirts"
  },
  {
    "name": "beige button-up work shirts",
    "slug": "beige-button-up-work-shirts"
  },
  {
    "name": "black slim fit shirts",
    "slug": "black-slim-fit-shirts"
  },
  {
    "name": "white formal button-down shirts",
    "slug": "white-formal-button-down-shirts"
  },
  {
    "name": "navy blue dress shirts",
    "slug": "navy-blue-dress-shirts"
  },
  {
    "name": "grey button-up casual shirts",
    "slug": "grey-button-up-casual-shirts"
  },
  {
    "name": "beige short sleeve shirts",
    "slug": "beige-short-sleeve-shirts"
  },
  {
    "name": "black long sleeve shirts",
    "slug": "black-long-sleeve-shirts"
  },
  {
    "name": "white casual button-up shirts",
    "slug": "white-casual-button-up-shirts"
  },
  {
    "name": "navy blue formal shirts",
    "slug": "navy-blue-formal-shirts"
  },
  {
    "name": "grey slim fit shirts",
    "slug": "grey-slim-fit-shirts"
  },
  {
    "name": "beige button-down work shirts",
    "slug": "beige-button-down-work-shirts"
  },
  {
    "name": "black formal dress shirts",
    "slug": "black-formal-dress-shirts"
  },
  {
    "name": "white short sleeve shirts",
    "slug": "white-short-sleeve-shirts"
  },
  {
    "name": "navy blue office shirts",
    "slug": "navy-blue-office-shirts"
  },
  {
    "name": "grey casual button-up shirts",
    "slug": "grey-casual-button-up-shirts"
  },
  {
    "name": "beige long sleeve shirts",
    "slug": "beige-long-sleeve-shirts"
  },
  {
    "name": "black slim fit shirts",
    "slug": "black-slim-fit-shirts"
  },
  {
    "name": "white button-down work shirts",
    "slug": "white-button-down-work-shirts"
  },
  {
    "name": "navy blue casual shirts",
    "slug": "navy-blue-casual-shirts"
  },
  {
    "name": "grey formal button-up shirts",
    "slug": "grey-formal-button-up-shirts"
  },
  {
    "name": "beige short sleeve shirts",
    "slug": "beige-short-sleeve-shirts"
  },
  {
    "name": "black long sleeve shirts",
    "slug": "black-long-sleeve-shirts"
  },
  {
    "name": "white casual button-down shirts",
    "slug": "white-casual-button-down-shirts"
  },
  {
    "name": "navy blue dress shirts",
    "slug": "navy-blue-dress-shirts"
  },
  {
    "name": "grey slim fit shirts",
    "slug": "grey-slim-fit-shirts"
  },
  {
    "name": "beige button-up work shirts",
    "slug": "beige-button-up-work-shirts"
  },
  {
    "name": "black formal button-down shirts",
    "slug": "black-formal-button-down-shirts"
  },
  {
    "name": "white short sleeve shirts",
    "slug": "white-short-sleeve-shirts"
  },
  {
    "name": "navy blue office shirts",
    "slug": "navy-blue-office-shirts"
  },
  {
    "name": "grey casual button-up shirts",
    "slug": "grey-casual-button-up-shirts"
  },
  {
    "name": "beige long sleeve shirts",
    "slug": "beige-long-sleeve-shirts"
  },
  {
    "name": "black slim fit shirts",
    "slug": "black-slim-fit-shirts"
  },
  {
    "name": "white button-down work shirts",
    "slug": "white-button-down-work-shirts"
  },
  {
    "name": "navy blue casual shirts",
    "slug": "navy-blue-casual-shirts"
  },
  {
    "name": "grey formal button-down shirts",
    "slug": "grey-formal-button-down-shirts"
  },
  {
    "name": "beige short sleeve shirts",
    "slug": "beige-short-sleeve-shirts"
  },
  {
    "name": "green men's t-shirts",
    "slug": "green-mens-t-shirts"
  },
  {
    "name": "iceberg green t-shirts",
    "slug": "iceberg-green-t-shirts"
  },
  {
    "name": "blue men's t-shirts",
    "slug": "blue-mens-t-shirts"
  },
  {
    "name": "dark blue t-shirts",
    "slug": "dark-blue-t-shirts"
  },
  {
    "name": "navy blue t-shirts",
    "slug": "navy-blue-t-shirts"
  },
  {
    "name": "marine blue t-shirts",
    "slug": "marine-blue-t-shirts"
  },
  {
    "name": "cream men's t-shirts",
    "slug": "cream-mens-t-shirts"
  },
  {
    "name": "pure stone t-shirts",
    "slug": "pure-stone-t-shirts"
  },
  {
    "name": "white men's t-shirts",
    "slug": "white-mens-t-shirts"
  },
  {
    "name": "green crewneck t-shirts",
    "slug": "green-crewneck-t-shirts"
  },
  {
    "name": "blue cotton t-shirts",
    "slug": "blue-cotton-t-shirts"
  },
  {
    "name": "navy casual t-shirts",
    "slug": "navy-casual-t-shirts"
  },
  {
    "name": "white crewneck t-shirts",
    "slug": "white-crewneck-t-shirts"
  },
  {
    "name": "cream casual t-shirts",
    "slug": "cream-casual-t-shirts"
  },
  {
    "name": "dark blue tees",
    "slug": "dark-blue-tees"
  },
  {
    "name": "marine blue tees",
    "slug": "marine-blue-tees"
  },
  {
    "name": "iceberg green tees",
    "slug": "iceberg-green-tees"
  },
  {
    "name": "pure stone tees",
    "slug": "pure-stone-tees"
  },
  {
    "name": "navy blue polos",
    "slug": "navy-blue-polos"
  },
  {
    "name": "white casual tees",
    "slug": "white-casual-tees"
  },
  {
    "name": "green casual tees",
    "slug": "green-casual-tees"
  },
  {
    "name": "blue crewneck tees",
    "slug": "blue-crewneck-tees"
  },
  {
    "name": "cream cotton tees",
    "slug": "cream-cotton-tees"
  },
  {
    "name": "dark blue shirts",
    "slug": "dark-blue-shirts"
  },
  {
    "name": "marine blue polos",
    "slug": "marine-blue-polos"
  },
  {
    "name": "iceberg green shirts",
    "slug": "iceberg-green-shirts"
  },
  {
    "name": "pure stone shirts",
    "slug": "pure-stone-shirts"
  },
  {
    "name": "navy casual shirts",
    "slug": "navy-casual-shirts"
  },
  {
    "name": "white cotton tees",
    "slug": "white-cotton-tees"
  },
  {
    "name": "green cotton tees",
    "slug": "green-cotton-tees"
  },
  {
    "name": "blue casual shirts",
    "slug": "blue-casual-shirts"
  },
  {
    "name": "cream crewneck shirts",
    "slug": "cream-crewneck-shirts"
  },
  {
    "name": "dark blue polos",
    "slug": "dark-blue-polos"
  },
  {
    "name": "marine blue shirts",
    "slug": "marine-blue-shirts"
  },
  {
    "name": "iceberg green polos",
    "slug": "iceberg-green-polos"
  },
  {
    "name": "pure stone polos",
    "slug": "pure-stone-polos"
  },
  {
    "name": "navy blue shirts",
    "slug": "navy-blue-shirts"
  },
  {
    "name": "white casual shirts",
    "slug": "white-casual-shirts"
  },
  {
    "name": "green casual shirts",
    "slug": "green-casual-shirts"
  },
  {
    "name": "blue crewneck shirts",
    "slug": "blue-crewneck-shirts"
  },
  {
    "name": "cream casual shirts",
    "slug": "cream-casual-shirts"
  },
  {
    "name": "dark blue polos",
    "slug": "dark-blue-polos"
  },
  {
    "name": "marine blue polos",
    "slug": "marine-blue-polos"
  },
  {
    "name": "iceberg green tees",
    "slug": "iceberg-green-tees"
  },
  {
    "name": "pure stone polos",
    "slug": "pure-stone-polos"
  },
  {
    "name": "navy casual tees",
    "slug": "navy-casual-tees"
  },
  {
    "name": "white crewneck shirts",
    "slug": "white-crewneck-shirts"
  },
  {
    "name": "green cotton shirts",
    "slug": "green-cotton-shirts"
  },
  {
    "name": "blue casual tees",
    "slug": "blue-casual-tees"
  },
  {
    "name": "cream casual tees",
    "slug": "cream-casual-tees"
  },
  {
    "name": "men's green crewneck t-shirts",
    "slug": "mens-green-crewneck-t-shirts"
  },
  {
    "name": "iceberg green cotton t-shirts",
    "slug": "iceberg-green-cotton-t-shirts"
  },
  {
    "name": "blue men's crewneck t-shirts",
    "slug": "blue-mens-crewneck-t-shirts"
  },
  {
    "name": "dark blue casual t-shirts",
    "slug": "dark-blue-casual-t-shirts"
  },
  {
    "name": "navy blue cotton t-shirts",
    "slug": "navy-blue-cotton-t-shirts"
  },
  {
    "name": "marine blue casual t-shirts",
    "slug": "marine-blue-casual-t-shirts"
  },
  {
    "name": "cream men's crewneck t-shirts",
    "slug": "cream-mens-crewneck-t-shirts"
  },
  {
    "name": "pure stone cotton t-shirts",
    "slug": "pure-stone-cotton-t-shirts"
  },
  {
    "name": "white men's crewneck t-shirts",
    "slug": "white-mens-crewneck-t-shirts"
  },
  {
    "name": "green crewneck cotton t-shirts",
    "slug": "green-crewneck-cotton-t-shirts"
  },
  {
    "name": "blue cotton casual t-shirts",
    "slug": "blue-cotton-casual-t-shirts"
  },
  {
    "name": "navy blue casual t-shirts",
    "slug": "navy-blue-casual-t-shirts"
  },
  {
    "name": "white cotton crewneck t-shirts",
    "slug": "white-cotton-crewneck-t-shirts"
  },
  {
    "name": "cream casual cotton t-shirts",
    "slug": "cream-casual-cotton-t-shirts"
  },
  {
    "name": "dark blue crewneck t-shirts",
    "slug": "dark-blue-crewneck-t-shirts"
  },
  {
    "name": "marine blue crewneck t-shirts",
    "slug": "marine-blue-crewneck-t-shirts"
  },
  {
    "name": "iceberg green casual t-shirts",
    "slug": "iceberg-green-casual-t-shirts"
  },
  {
    "name": "pure stone casual t-shirts",
    "slug": "pure-stone-casual-t-shirts"
  },
  {
    "name": "navy blue crewneck t-shirts",
    "slug": "navy-blue-crewneck-t-shirts"
  },
  {
    "name": "white casual cotton t-shirts",
    "slug": "white-casual-cotton-t-shirts"
  },
  {
    "name": "green casual crewneck t-shirts",
    "slug": "green-casual-crewneck-t-shirts"
  },
  {
    "name": "blue crewneck cotton t-shirts",
    "slug": "blue-crewneck-cotton-t-shirts"
  },
  {
    "name": "cream cotton crewneck t-shirts",
    "slug": "cream-cotton-crewneck-t-shirts"
  },
  {
    "name": "dark blue cotton t-shirts",
    "slug": "dark-blue-cotton-t-shirts"
  },
  {
    "name": "marine blue cotton t-shirts",
    "slug": "marine-blue-cotton-t-shirts"
  },
  {
    "name": "iceberg green cotton t-shirts",
    "slug": "iceberg-green-cotton-t-shirts"
  },
  {
    "name": "pure stone crewneck t-shirts",
    "slug": "pure-stone-crewneck-t-shirts"
  },
  {
    "name": "navy blue cotton t-shirts",
    "slug": "navy-blue-cotton-t-shirts"
  },
  {
    "name": "white crewneck casual t-shirts",
    "slug": "white-crewneck-casual-t-shirts"
  },
  {
    "name": "green cotton casual t-shirts",
    "slug": "green-cotton-casual-t-shirts"
  },
  {
    "name": "blue casual crewneck t-shirts",
    "slug": "blue-casual-crewneck-t-shirts"
  },
  {
    "name": "cream crewneck casual t-shirts",
    "slug": "cream-crewneck-casual-t-shirts"
  },
  {
    "name": "dark blue casual tees",
    "slug": "dark-blue-casual-tees"
  },
  {
    "name": "marine blue cotton tees",
    "slug": "marine-blue-cotton-tees"
  },
  {
    "name": "iceberg green crewneck tees",
    "slug": "iceberg-green-crewneck-tees"
  },
  {
    "name": "pure stone casual tees",
    "slug": "pure-stone-casual-tees"
  },
  {
    "name": "navy blue casual polos",
    "slug": "navy-blue-casual-polos"
  },
  {
    "name": "white cotton casual tees",
    "slug": "white-cotton-casual-tees"
  },
  {
    "name": "green crewneck casual tees",
    "slug": "green-crewneck-casual-tees"
  },
  {
    "name": "blue cotton crewneck t-shirts",
    "slug": "blue-cotton-crewneck-t-shirts"
  },
  {
    "name": "cream casual cotton shirts",
    "slug": "cream-casual-cotton-shirts"
  },
  {
    "name": "dark blue cotton tees",
    "slug": "dark-blue-cotton-tees"
  },
  {
    "name": "marine blue crewneck shirts",
    "slug": "marine-blue-crewneck-shirts"
  },
  {
    "name": "iceberg green casual polos",
    "slug": "iceberg-green-casual-polos"
  },
  {
    "name": "pure stone casual polos",
    "slug": "pure-stone-casual-polos"
  },
  {
    "name": "navy blue crewneck polos",
    "slug": "navy-blue-crewneck-polos"
  },
  {
    "name": "white casual cotton shirts",
    "slug": "white-casual-cotton-shirts"
  },
  {
    "name": "green casual cotton polos",
    "slug": "green-casual-cotton-polos"
  },
  {
    "name": "blue casual cotton tees",
    "slug": "blue-casual-cotton-tees"
  },
  {
    "name": "cream crewneck cotton tees",
    "slug": "cream-crewneck-cotton-tees"
  },
  {
    "name": "men's crewneck t-shirts",
    "slug": "mens-crewneck-t-shirts"
  },
  {
    "name": "casual crewneck t-shirts",
    "slug": "casual-crewneck-t-shirts"
  },
  {
    "name": "men's casual tees",
    "slug": "mens-casual-tees"
  },
  {
    "name": "men's cotton t-shirts",
    "slug": "mens-cotton-t-shirts"
  },
  {
    "name": "soft cotton t-shirts",
    "slug": "soft-cotton-t-shirts"
  },
  {
    "name": "everyday men's t-shirts",
    "slug": "everyday-mens-t-shirts"
  },
  {
    "name": "classic crewneck t-shirts",
    "slug": "classic-crewneck-t-shirts"
  },
  {
    "name": "durable cotton t-shirts",
    "slug": "durable-cotton-t-shirts"
  },
  {
    "name": "breathable men's t-shirts",
    "slug": "breathable-mens-t-shirts"
  },
  {
    "name": "lightweight crewneck t-shirts",
    "slug": "lightweight-crewneck-t-shirts"
  },
  {
    "name": "men's casual t-shirts",
    "slug": "mens-casual-t-shirts"
  },
  {
    "name": "comfortable crewneck t-shirts",
    "slug": "comfortable-crewneck-t-shirts"
  },
  {
    "name": "soft everyday t-shirts",
    "slug": "soft-everyday-t-shirts"
  },
  {
    "name": "stylish men's t-shirts",
    "slug": "stylish-mens-t-shirts"
  },
  {
    "name": "versatile casual t-shirts",
    "slug": "versatile-casual-t-shirts"
  },
  {
    "name": "premium men's t-shirts",
    "slug": "premium-mens-t-shirts"
  },
  {
    "name": "casual classic t-shirts",
    "slug": "casual-classic-t-shirts"
  },
  {
    "name": "regular fit t-shirts",
    "slug": "regular-fit-t-shirts"
  },
  {
    "name": "relaxed fit t-shirts",
    "slug": "relaxed-fit-t-shirts"
  },
  {
    "name": "tailored fit t-shirts",
    "slug": "tailored-fit-t-shirts"
  },
  {
    "name": "stretch cotton t-shirts",
    "slug": "stretch-cotton-t-shirts"
  },
  {
    "name": "all-season men's t-shirts",
    "slug": "all-season-mens-t-shirts"
  },
  {
    "name": "modern fit t-shirts",
    "slug": "modern-fit-t-shirts"
  },
  {
    "name": "casual relaxed t-shirts",
    "slug": "casual-relaxed-t-shirts"
  },
  {
    "name": "men's stylish t-shirts",
    "slug": "mens-stylish-t-shirts"
  },
  {
    "name": "crewneck cotton t-shirts",
    "slug": "crewneck-cotton-t-shirts"
  },
  {
    "name": "casual everyday t-shirts",
    "slug": "casual-everyday-t-shirts"
  },
  {
    "name": "men's premium t-shirts",
    "slug": "mens-premium-t-shirts"
  },
  {
    "name": "durable everyday t-shirts",
    "slug": "durable-everyday-t-shirts"
  },
  {
    "name": "casual work t-shirts",
    "slug": "casual-work-t-shirts"
  },
  {
    "name": "soft tailored t-shirts",
    "slug": "soft-tailored-t-shirts"
  },
  {
    "name": "crewneck casual tees",
    "slug": "crewneck-casual-tees"
  },
  {
    "name": "simple cotton t-shirts",
    "slug": "simple-cotton-t-shirts"
  },
  {
    "name": "comfortable men's t-shirts",
    "slug": "comfortable-mens-t-shirts"
  },
  {
    "name": "men's classic t-shirts",
    "slug": "mens-classic-t-shirts"
  },
  {
    "name": "versatile men's t-shirts",
    "slug": "versatile-mens-t-shirts"
  },
  {
    "name": "lightweight cotton t-shirts",
    "slug": "lightweight-cotton-t-shirts"
  },
  {
    "name": "breathable casual t-shirts",
    "slug": "breathable-casual-t-shirts"
  },
  {
    "name": "men's durable t-shirts",
    "slug": "mens-durable-t-shirts"
  },
  {
    "name": "casual fit t-shirts",
    "slug": "casual-fit-t-shirts"
  },
  {
    "name": "men's relaxed t-shirts",
    "slug": "mens-relaxed-t-shirts"
  },
  {
    "name": "all-day men's t-shirts",
    "slug": "all-day-mens-t-shirts"
  },
  {
    "name": "relaxed men's t-shirts",
    "slug": "relaxed-mens-t-shirts"
  },
  {
    "name": "premium quality t-shirts",
    "slug": "premium-quality-t-shirts"
  },
  {
    "name": "everyday cotton t-shirts",
    "slug": "everyday-cotton-t-shirts"
  },
  {
    "name": "casual tailored t-shirts",
    "slug": "casual-tailored-t-shirts"
  },
  {
    "name": "crewneck fit t-shirts",
    "slug": "crewneck-fit-t-shirts"
  },
  {
    "name": "men's modern t-shirts",
    "slug": "mens-modern-t-shirts"
  },
  {
    "name": "tailored casual t-shirts",
    "slug": "tailored-casual-t-shirts"
  },
  {
    "name": "breathable crewneck t-shirts",
    "slug": "breathable-crewneck-t-shirts"
  },
  {
    "name": "men's crewneck regular fit t-shirts",
    "slug": "mens-crewneck-regular-fit-t-shirts"
  },
  {
    "name": "casual crewneck men's t-shirts",
    "slug": "casual-crewneck-mens-t-shirts"
  },
  {
    "name": "durable and comfortable men's t-shirts",
    "slug": "durable-and-comfortable-mens-t-shirts"
  },
  {
    "name": "stylish casual men's t-shirts",
    "slug": "stylish-casual-mens-t-shirts"
  },
  {
    "name": "everyday crewneck cotton t-shirts",
    "slug": "everyday-crewneck-cotton-t-shirts"
  },
  {
    "name": "premium quality casual t-shirts",
    "slug": "premium-quality-casual-t-shirts"
  },
  {
    "name": "men's lightweight classic t-shirts",
    "slug": "mens-lightweight-classic-t-shirts"
  },
  {
    "name": "all-season casual crewneck t-shirts",
    "slug": "all-season-casual-crewneck-t-shirts"
  },
  {
    "name": "tailored regular fit men's t-shirts",
    "slug": "tailored-regular-fit-mens-t-shirts"
  },
  {
    "name": "casual and versatile men's t-shirts",
    "slug": "casual-and-versatile-mens-t-shirts"
  },
  {
    "name": "crewneck soft cotton t-shirts",
    "slug": "crewneck-soft-cotton-t-shirts"
  },
  {
    "name": "modern fit casual t-shirts",
    "slug": "modern-fit-casual-t-shirts"
  },
  {
    "name": "relaxed casual men's t-shirts",
    "slug": "relaxed-casual-mens-t-shirts"
  },
  {
    "name": "simple and stylish men's t-shirts",
    "slug": "simple-and-stylish-mens-t-shirts"
  },
  {
    "name": "breathable and durable t-shirts",
    "slug": "breathable-and-durable-t-shirts"
  },
  {
    "name": "men's comfortable everyday t-shirts",
    "slug": "mens-comfortable-everyday-t-shirts"
  },
  {
    "name": "casual wear men's t-shirts",
    "slug": "casual-wear-mens-t-shirts"
  },
  {
    "name": "men's regular fit casual t-shirts",
    "slug": "mens-regular-fit-casual-t-shirts"
  },
  {
    "name": "crewneck all-day men's t-shirts",
    "slug": "crewneck-all-day-mens-t-shirts"
  },
  {
    "name": "premium cotton crewneck t-shirts",
    "slug": "premium-cotton-crewneck-t-shirts"
  },
  {
    "name": "classic crewneck tailored t-shirts",
    "slug": "classic-crewneck-tailored-t-shirts"
  },
  {
    "name": "men's casual workwear t-shirts",
    "slug": "mens-casual-workwear-t-shirts"
  },
  {
    "name": "versatile and lightweight t-shirts",
    "slug": "versatile-and-lightweight-t-shirts"
  },
  {
    "name": "regular fit casual crewneck t-shirts",
    "slug": "regular-fit-casual-crewneck-t-shirts"
  },
  {
    "name": "breathable casual cotton t-shirts",
    "slug": "breathable-casual-cotton-t-shirts"
  },
  {
    "name": "men's simple casual t-shirts",
    "slug": "mens-simple-casual-t-shirts"
  },
  {
    "name": "comfortable tailored fit t-shirts",
    "slug": "comfortable-tailored-fit-t-shirts"
  },
  {
    "name": "relaxed fit casual t-shirts",
    "slug": "relaxed-fit-casual-t-shirts"
  },
  {
    "name": "premium tailored cotton t-shirts",
    "slug": "premium-tailored-cotton-t-shirts"
  },
  {
    "name": "men's all-purpose casual t-shirts",
    "slug": "mens-all-purpose-casual-t-shirts"
  },
  {
    "name": "classic everyday casual t-shirts",
    "slug": "classic-everyday-casual-t-shirts"
  },
  {
    "name": "men's relaxed fit cotton t-shirts",
    "slug": "mens-relaxed-fit-cotton-t-shirts"
  },
  {
    "name": "durable tailored crewneck t-shirts",
    "slug": "durable-tailored-crewneck-t-shirts"
  },
  {
    "name": "simple regular fit t-shirts",
    "slug": "simple-regular-fit-t-shirts"
  },
  {
    "name": "crewneck modern fit t-shirts",
    "slug": "crewneck-modern-fit-t-shirts"
  },
  {
    "name": "lightweight and versatile t-shirts",
    "slug": "lightweight-and-versatile-t-shirts"
  },
  {
    "name": "men's stylish classic t-shirts",
    "slug": "mens-stylish-classic-t-shirts"
  },
  {
    "name": "casual crewneck regular fit t-shirts",
    "slug": "casual-crewneck-regular-fit-t-shirts"
  },
  {
    "name": "men's simple everyday t-shirts",
    "slug": "mens-simple-everyday-t-shirts"
  },
  {
    "name": "casual men's durable t-shirts",
    "slug": "casual-mens-durable-t-shirts"
  },
  {
    "name": "tailored soft cotton t-shirts",
    "slug": "tailored-soft-cotton-t-shirts"
  },
  {
    "name": "breathable and lightweight t-shirts",
    "slug": "breathable-and-lightweight-t-shirts"
  },
  {
    "name": "men's versatile everyday t-shirts",
    "slug": "mens-versatile-everyday-t-shirts"
  },
  {
    "name": "relaxed fit men's t-shirts",
    "slug": "relaxed-fit-mens-t-shirts"
  },
  {
    "name": "men's casual stylish t-shirts",
    "slug": "mens-casual-stylish-t-shirts"
  },
  {
    "name": "everyday comfortable crewneck t-shirts",
    "slug": "everyday-comfortable-crewneck-t-shirts"
  },
  {
    "name": "classic tailored casual t-shirts",
    "slug": "classic-tailored-casual-t-shirts"
  },
  {
    "name": "men's premium casual crewneck t-shirts",
    "slug": "mens-premium-casual-crewneck-t-shirts"
  },
  {
    "name": "simple lightweight casual t-shirts",
    "slug": "simple-lightweight-casual-t-shirts"
  },
  {
    "name": "regular fit breathable t-shirts",
    "slug": "regular-fit-breathable-t-shirts"
  },
  {
    "name": "black men's polo shirts",
    "slug": "black-mens-polo-shirts"
  },
  {
    "name": "white men's polo shirts",
    "slug": "white-mens-polo-shirts"
  },
  {
    "name": "pure stone polo shirts",
    "slug": "pure-stone-polo-shirts"
  },
  {
    "name": "cream men's polo shirts",
    "slug": "cream-mens-polo-shirts"
  },
  {
    "name": "blue men's polo shirts",
    "slug": "blue-mens-polo-shirts"
  },
  {
    "name": "marine blue polo shirts",
    "slug": "marine-blue-polo-shirts"
  },
  {
    "name": "green men's polo shirts",
    "slug": "green-mens-polo-shirts"
  },
  {
    "name": "army green polo shirts",
    "slug": "army-green-polo-shirts"
  },
  {
    "name": "black cotton polo shirts",
    "slug": "black-cotton-polo-shirts"
  },
  {
    "name": "white cotton polo shirts",
    "slug": "white-cotton-polo-shirts"
  },
  {
    "name": "blue cotton polo shirts",
    "slug": "blue-cotton-polo-shirts"
  },
  {
    "name": "green cotton polo shirts",
    "slug": "green-cotton-polo-shirts"
  },
  {
    "name": "black slim-fit polos",
    "slug": "black-slim-fit-polos"
  },
  {
    "name": "white slim-fit polos",
    "slug": "white-slim-fit-polos"
  },
  {
    "name": "blue slim-fit polos",
    "slug": "blue-slim-fit-polos"
  },
  {
    "name": "green slim-fit polos",
    "slug": "green-slim-fit-polos"
  },
  {
    "name": "black casual polo shirts",
    "slug": "black-casual-polo-shirts"
  },
  {
    "name": "white casual polo shirts",
    "slug": "white-casual-polo-shirts"
  },
  {
    "name": "blue casual polo shirts",
    "slug": "blue-casual-polo-shirts"
  },
  {
    "name": "green casual polo shirts",
    "slug": "green-casual-polo-shirts"
  },
  {
    "name": "black pique polo shirts",
    "slug": "black-pique-polo-shirts"
  },
  {
    "name": "white pique polo shirts",
    "slug": "white-pique-polo-shirts"
  },
  {
    "name": "blue pique polo shirts",
    "slug": "blue-pique-polo-shirts"
  },
  {
    "name": "green pique polo shirts",
    "slug": "green-pique-polo-shirts"
  },
  {
    "name": "black performance polo shirts",
    "slug": "black-performance-polo-shirts"
  },
  {
    "name": "white performance polo shirts",
    "slug": "white-performance-polo-shirts"
  },
  {
    "name": "blue performance polo shirts",
    "slug": "blue-performance-polo-shirts"
  },
  {
    "name": "green performance polo shirts",
    "slug": "green-performance-polo-shirts"
  },
  {
    "name": "black designer polo shirts",
    "slug": "black-designer-polo-shirts"
  },
  {
    "name": "white designer polo shirts",
    "slug": "white-designer-polo-shirts"
  },
  {
    "name": "blue designer polo shirts",
    "slug": "blue-designer-polo-shirts"
  },
  {
    "name": "green designer polo shirts",
    "slug": "green-designer-polo-shirts"
  },
  {
    "name": "black athletic polo shirts",
    "slug": "black-athletic-polo-shirts"
  },
  {
    "name": "white athletic polo shirts",
    "slug": "white-athletic-polo-shirts"
  },
  {
    "name": "blue athletic polo shirts",
    "slug": "blue-athletic-polo-shirts"
  },
  {
    "name": "green athletic polo shirts",
    "slug": "green-athletic-polo-shirts"
  },
  {
    "name": "black classic polo shirts",
    "slug": "black-classic-polo-shirts"
  },
  {
    "name": "white classic polo shirts",
    "slug": "white-classic-polo-shirts"
  },
  {
    "name": "blue classic polo shirts",
    "slug": "blue-classic-polo-shirts"
  },
  {
    "name": "green classic polo shirts",
    "slug": "green-classic-polo-shirts"
  },
  {
    "name": "black fitted polo shirts",
    "slug": "black-fitted-polo-shirts"
  },
  {
    "name": "white fitted polo shirts",
    "slug": "white-fitted-polo-shirts"
  },
  {
    "name": "blue fitted polo shirts",
    "slug": "blue-fitted-polo-shirts"
  },
  {
    "name": "green fitted polo shirts",
    "slug": "green-fitted-polo-shirts"
  },
  {
    "name": "casual polo shirts men",
    "slug": "casual-polo-shirts-men"
  },
  {
    "name": "cotton men's polo shirts",
    "slug": "cotton-mens-polo-shirts"
  },
  {
    "name": "soft cotton polo shirts",
    "slug": "soft-cotton-polo-shirts"
  },
  {
    "name": "tailored men's polo shirts",
    "slug": "tailored-mens-polo-shirts"
  },
  {
    "name": "wrinkle-free polo shirts",
    "slug": "wrinkle-free-polo-shirts"
  },
  {
    "name": "premium men's polo shirts",
    "slug": "premium-mens-polo-shirts"
  },
  {
    "name": "black slim-fit polos",
    "slug": "black-slim-fit-polos"
  },
  {
    "name": "white slim-fit polos",
    "slug": "white-slim-fit-polos"
  },
  {
    "name": "blue slim-fit polos",
    "slug": "blue-slim-fit-polos"
  },
  {
    "name": "green slim-fit polos",
    "slug": "green-slim-fit-polos"
  },
  {
    "name": "black casual polos",
    "slug": "black-casual-polos"
  },
  {
    "name": "white casual polos",
    "slug": "white-casual-polos"
  },
  {
    "name": "blue casual polos",
    "slug": "blue-casual-polos"
  },
  {
    "name": "green casual polos",
    "slug": "green-casual-polos"
  },
  {
    "name": "black pique polos",
    "slug": "black-pique-polos"
  },
  {
    "name": "white pique polos",
    "slug": "white-pique-polos"
  },
  {
    "name": "blue pique polos",
    "slug": "blue-pique-polos"
  },
  {
    "name": "green pique polos",
    "slug": "green-pique-polos"
  },
  {
    "name": "black performance polos",
    "slug": "black-performance-polos"
  },
  {
    "name": "white performance polos",
    "slug": "white-performance-polos"
  },
  {
    "name": "blue performance polos",
    "slug": "blue-performance-polos"
  },
  {
    "name": "green performance polos",
    "slug": "green-performance-polos"
  },
  {
    "name": "black designer polos",
    "slug": "black-designer-polos"
  },
  {
    "name": "white designer polos",
    "slug": "white-designer-polos"
  },
  {
    "name": "blue designer polos",
    "slug": "blue-designer-polos"
  },
  {
    "name": "green designer polos",
    "slug": "green-designer-polos"
  },
  {
    "name": "black athletic polos",
    "slug": "black-athletic-polos"
  },
  {
    "name": "white athletic polos",
    "slug": "white-athletic-polos"
  },
  {
    "name": "blue athletic polos",
    "slug": "blue-athletic-polos"
  },
  {
    "name": "green athletic polos",
    "slug": "green-athletic-polos"
  },
  {
    "name": "black classic polos",
    "slug": "black-classic-polos"
  },
  {
    "name": "white classic polos",
    "slug": "white-classic-polos"
  },
  {
    "name": "blue classic polos",
    "slug": "blue-classic-polos"
  },
  {
    "name": "green classic polos",
    "slug": "green-classic-polos"
  },
  {
    "name": "black fitted polos",
    "slug": "black-fitted-polos"
  },
  {
    "name": "white fitted polos",
    "slug": "white-fitted-polos"
  },
  {
    "name": "blue fitted polos",
    "slug": "blue-fitted-polos"
  },
  {
    "name": "green fitted polos",
    "slug": "green-fitted-polos"
  },
  {
    "name": "casual polos men",
    "slug": "casual-polos-men"
  },
  {
    "name": "wrinkle-free polos",
    "slug": "wrinkle-free-polos"
  },
  {
    "name": "black men's polo shirts",
    "slug": "black-mens-polo-shirts"
  },
  {
    "name": "white men's polo shirts",
    "slug": "white-mens-polo-shirts"
  },
  {
    "name": "pure stone polo shirts",
    "slug": "pure-stone-polo-shirts"
  },
  {
    "name": "cream men's polo shirts",
    "slug": "cream-mens-polo-shirts"
  },
  {
    "name": "blue men's polo shirts",
    "slug": "blue-mens-polo-shirts"
  },
  {
    "name": "marine blue polo shirts",
    "slug": "marine-blue-polo-shirts"
  },
  {
    "name": "green men's polo shirts",
    "slug": "green-mens-polo-shirts"
  },
  {
    "name": "army green polo shirts",
    "slug": "army-green-polo-shirts"
  },
  {
    "name": "black cotton polo shirts",
    "slug": "black-cotton-polo-shirts"
  },
  {
    "name": "white cotton polo shirts",
    "slug": "white-cotton-polo-shirts"
  },
  {
    "name": "blue cotton polo shirts",
    "slug": "blue-cotton-polo-shirts"
  },
  {
    "name": "green cotton polo shirts",
    "slug": "green-cotton-polo-shirts"
  },
  {
    "name": "black slim-fit polos",
    "slug": "black-slim-fit-polos"
  },
  {
    "name": "white slim-fit polos",
    "slug": "white-slim-fit-polos"
  },
  {
    "name": "blue slim-fit polos",
    "slug": "blue-slim-fit-polos"
  },
  {
    "name": "green slim-fit polos",
    "slug": "green-slim-fit-polos"
  },
  {
    "name": "black casual polo shirts",
    "slug": "black-casual-polo-shirts"
  },
  {
    "name": "white casual polo shirts",
    "slug": "white-casual-polo-shirts"
  },
  {
    "name": "blue casual polo shirts",
    "slug": "blue-casual-polo-shirts"
  },
  {
    "name": "green casual polo shirts",
    "slug": "green-casual-polo-shirts"
  },
  {
    "name": "black pique polo shirts",
    "slug": "black-pique-polo-shirts"
  },
  {
    "name": "white pique polo shirts",
    "slug": "white-pique-polo-shirts"
  },
  {
    "name": "blue pique polo shirts",
    "slug": "blue-pique-polo-shirts"
  },
  {
    "name": "green pique polo shirts",
    "slug": "green-pique-polo-shirts"
  },
  {
    "name": "black performance polo shirts",
    "slug": "black-performance-polo-shirts"
  },
  {
    "name": "white performance polo shirts",
    "slug": "white-performance-polo-shirts"
  },
  {
    "name": "blue performance polo shirts",
    "slug": "blue-performance-polo-shirts"
  },
  {
    "name": "green performance polo shirts",
    "slug": "green-performance-polo-shirts"
  },
  {
    "name": "black designer polo shirts",
    "slug": "black-designer-polo-shirts"
  },
  {
    "name": "white designer polo shirts",
    "slug": "white-designer-polo-shirts"
  },
  {
    "name": "blue designer polo shirts",
    "slug": "blue-designer-polo-shirts"
  },
  {
    "name": "green designer polo shirts",
    "slug": "green-designer-polo-shirts"
  },
  {
    "name": "black athletic polo shirts",
    "slug": "black-athletic-polo-shirts"
  },
  {
    "name": "white athletic polo shirts",
    "slug": "white-athletic-polo-shirts"
  },
  {
    "name": "blue athletic polo shirts",
    "slug": "blue-athletic-polo-shirts"
  },
  {
    "name": "green athletic polo shirts",
    "slug": "green-athletic-polo-shirts"
  },
  {
    "name": "black classic polo shirts",
    "slug": "black-classic-polo-shirts"
  },
  {
    "name": "white classic polo shirts",
    "slug": "white-classic-polo-shirts"
  },
  {
    "name": "blue classic polo shirts",
    "slug": "blue-classic-polo-shirts"
  },
  {
    "name": "green classic polo shirts",
    "slug": "green-classic-polo-shirts"
  },
  {
    "name": "black fitted polo shirts",
    "slug": "black-fitted-polo-shirts"
  },
  {
    "name": "white fitted polo shirts",
    "slug": "white-fitted-polo-shirts"
  },
  {
    "name": "blue fitted polo shirts",
    "slug": "blue-fitted-polo-shirts"
  },
  {
    "name": "green fitted polo shirts",
    "slug": "green-fitted-polo-shirts"
  },
  {
    "name": "casual polo shirts men",
    "slug": "casual-polo-shirts-men"
  },
  {
    "name": "cotton men's polo shirts",
    "slug": "cotton-mens-polo-shirts"
  },
  {
    "name": "soft cotton polo shirts",
    "slug": "soft-cotton-polo-shirts"
  },
  {
    "name": "tailored men's polo shirts",
    "slug": "tailored-mens-polo-shirts"
  },
  {
    "name": "wrinkle-free polo shirts",
    "slug": "wrinkle-free-polo-shirts"
  },
  {
    "name": "premium men's polo shirts",
    "slug": "premium-mens-polo-shirts"
  },
  {
    "name": "men's cotton polo shirts",
    "slug": "mens-cotton-polo-shirts"
  },
  {
    "name": "men's slim polo shirts",
    "slug": "mens-slim-polo-shirts"
  },
  {
    "name": "casual men's polo shirts",
    "slug": "casual-mens-polo-shirts"
  },
  {
    "name": "tailored men's polo shirts",
    "slug": "tailored-mens-polo-shirts"
  },
  {
    "name": "wrinkle-free polo shirts",
    "slug": "wrinkle-free-polo-shirts"
  },
  {
    "name": "premium men's polo shirts",
    "slug": "premium-mens-polo-shirts"
  },
  {
    "name": "men's classic polo shirts",
    "slug": "mens-classic-polo-shirts"
  },
  {
    "name": "men's fitted polo shirts",
    "slug": "mens-fitted-polo-shirts"
  },
  {
    "name": "breathable men's polo shirts",
    "slug": "breathable-mens-polo-shirts"
  },
  {
    "name": "soft cotton polo shirts",
    "slug": "soft-cotton-polo-shirts"
  },
  {
    "name": "comfortable men's polo shirts",
    "slug": "comfortable-mens-polo-shirts"
  },
  {
    "name": "durable men's polo shirts",
    "slug": "durable-mens-polo-shirts"
  },
  {
    "name": "regular fit polos",
    "slug": "regular-fit-polos"
  },
  {
    "name": "men's stretch polo shirts",
    "slug": "mens-stretch-polo-shirts"
  },
  {
    "name": "stylish men's polo shirts",
    "slug": "stylish-mens-polo-shirts"
  },
  {
    "name": "lightweight men's polo shirts",
    "slug": "lightweight-mens-polo-shirts"
  },
  {
    "name": "wrinkle-resistant polo shirts",
    "slug": "wrinkle-resistant-polo-shirts"
  },
  {
    "name": "casual everyday polos",
    "slug": "casual-everyday-polos"
  },
  {
    "name": "men's designer polo shirts",
    "slug": "mens-designer-polo-shirts"
  },
  {
    "name": "classic fit polos",
    "slug": "classic-fit-polos"
  },
  {
    "name": "men's casual polo shirts",
    "slug": "mens-casual-polo-shirts"
  },
  {
    "name": "simple men's polo shirts",
    "slug": "simple-mens-polo-shirts"
  },
  {
    "name": "versatile men's polo shirts",
    "slug": "versatile-mens-polo-shirts"
  },
  {
    "name": "easy-care polo shirts",
    "slug": "easy-care-polo-shirts"
  },
  {
    "name": "fitted casual polos",
    "slug": "fitted-casual-polos"
  },
  {
    "name": "casual wardrobe polos",
    "slug": "casual-wardrobe-polos"
  },
  {
    "name": "all-day men's polos",
    "slug": "all-day-mens-polos"
  },
  {
    "name": "soft fabric polos",
    "slug": "soft-fabric-polos"
  },
  {
    "name": "classic casual polos",
    "slug": "classic-casual-polos"
  },
  {
    "name": "men's wardrobe polos",
    "slug": "mens-wardrobe-polos"
  },
  {
    "name": "comfortable casual polos",
    "slug": "comfortable-casual-polos"
  },
  {
    "name": "men's tailored polos",
    "slug": "mens-tailored-polos"
  },
  {
    "name": "casual fit polos",
    "slug": "casual-fit-polos"
  },
  {
    "name": "classic style polos",
    "slug": "classic-style-polos"
  },
  {
    "name": "everyday casual polos",
    "slug": "everyday-casual-polos"
  },
  {
    "name": "men's office polos",
    "slug": "mens-office-polos"
  },
  {
    "name": "casual business polos",
    "slug": "casual-business-polos"
  },
  {
    "name": "premium casual polos",
    "slug": "premium-casual-polos"
  },
  {
    "name": "men's simple polos",
    "slug": "mens-simple-polos"
  },
  {
    "name": "modern fit polos",
    "slug": "modern-fit-polos"
  },
  {
    "name": "timeless men's polos",
    "slug": "timeless-mens-polos"
  },
  {
    "name": "breathable casual polos",
    "slug": "breathable-casual-polos"
  },
  {
    "name": "versatile casual polos",
    "slug": "versatile-casual-polos"
  },
  {
    "name": "tailored fit polos",
    "slug": "tailored-fit-polos"
  },
  {
    "name": "soft everyday polos",
    "slug": "soft-everyday-polos"
  },
  {
    "name": "stylish fit polos",
    "slug": "stylish-fit-polos"
  },
  {
    "name": "simple fit polos",
    "slug": "simple-fit-polos"
  },
  {
    "name": "men's summer polos",
    "slug": "mens-summer-polos"
  },
  {
    "name": "relaxed fit polos",
    "slug": "relaxed-fit-polos"
  },
  {
    "name": "smart casual polos",
    "slug": "smart-casual-polos"
  },
  {
    "name": "men's black cotton polo shirts",
    "slug": "mens-black-cotton-polo-shirts"
  },
  {
    "name": "men's white cotton polo shirts",
    "slug": "mens-white-cotton-polo-shirts"
  },
  {
    "name": "men's pure stone polo shirts",
    "slug": "mens-pure-stone-polo-shirts"
  },
  {
    "name": "men's cream cotton polo shirts",
    "slug": "mens-cream-cotton-polo-shirts"
  },
  {
    "name": "men's blue cotton polo shirts",
    "slug": "mens-blue-cotton-polo-shirts"
  },
  {
    "name": "men's marine blue polo shirts",
    "slug": "mens-marine-blue-polo-shirts"
  },
  {
    "name": "men's green cotton polo shirts",
    "slug": "mens-green-cotton-polo-shirts"
  },
  {
    "name": "men's army green polo shirts",
    "slug": "mens-army-green-polo-shirts"
  },
  {
    "name": "black slim-fit men's polo shirts",
    "slug": "black-slim-fit-mens-polo-shirts"
  },
  {
    "name": "white slim-fit men's polo shirts",
    "slug": "white-slim-fit-mens-polo-shirts"
  },
  {
    "name": "blue slim-fit men's polo shirts",
    "slug": "blue-slim-fit-mens-polo-shirts"
  },
  {
    "name": "green slim-fit men's polo shirts",
    "slug": "green-slim-fit-mens-polo-shirts"
  },
  {
    "name": "black casual men's polo shirts",
    "slug": "black-casual-mens-polo-shirts"
  },
  {
    "name": "white casual men's polo shirts",
    "slug": "white-casual-mens-polo-shirts"
  },
  {
    "name": "blue casual men's polo shirts",
    "slug": "blue-casual-mens-polo-shirts"
  },
  {
    "name": "green casual men's polo shirts",
    "slug": "green-casual-mens-polo-shirts"
  },
  {
    "name": "black pique men's polo shirts",
    "slug": "black-pique-mens-polo-shirts"
  },
  {
    "name": "white pique men's polo shirts",
    "slug": "white-pique-mens-polo-shirts"
  },
  {
    "name": "blue pique men's polo shirts",
    "slug": "blue-pique-mens-polo-shirts"
  },
  {
    "name": "green pique men's polo shirts",
    "slug": "green-pique-mens-polo-shirts"
  },
  {
    "name": "black performance men's polo shirts",
    "slug": "black-performance-mens-polo-shirts"
  },
  {
    "name": "white performance men's polo shirts",
    "slug": "white-performance-mens-polo-shirts"
  },
  {
    "name": "blue performance men's polo shirts",
    "slug": "blue-performance-mens-polo-shirts"
  },
  {
    "name": "green performance men's polo shirts",
    "slug": "green-performance-mens-polo-shirts"
  },
  {
    "name": "black designer men's polo shirts",
    "slug": "black-designer-mens-polo-shirts"
  },
  {
    "name": "white designer men's polo shirts",
    "slug": "white-designer-mens-polo-shirts"
  },
  {
    "name": "blue designer men's polo shirts",
    "slug": "blue-designer-mens-polo-shirts"
  },
  {
    "name": "green designer men's polo shirts",
    "slug": "green-designer-mens-polo-shirts"
  },
  {
    "name": "black athletic men's polo shirts",
    "slug": "black-athletic-mens-polo-shirts"
  },
  {
    "name": "white athletic men's polo shirts",
    "slug": "white-athletic-mens-polo-shirts"
  },
  {
    "name": "blue athletic men's polo shirts",
    "slug": "blue-athletic-mens-polo-shirts"
  },
  {
    "name": "green athletic men's polo shirts",
    "slug": "green-athletic-mens-polo-shirts"
  },
  {
    "name": "black classic men's polo shirts",
    "slug": "black-classic-mens-polo-shirts"
  },
  {
    "name": "white classic men's polo shirts",
    "slug": "white-classic-mens-polo-shirts"
  },
  {
    "name": "blue classic men's polo shirts",
    "slug": "blue-classic-mens-polo-shirts"
  },
  {
    "name": "green classic men's polo shirts",
    "slug": "green-classic-mens-polo-shirts"
  },
  {
    "name": "black fitted men's polo shirts",
    "slug": "black-fitted-mens-polo-shirts"
  },
  {
    "name": "white fitted men's polo shirts",
    "slug": "white-fitted-mens-polo-shirts"
  },
  {
    "name": "blue fitted men's polo shirts",
    "slug": "blue-fitted-mens-polo-shirts"
  },
  {
    "name": "green fitted men's polo shirts",
    "slug": "green-fitted-mens-polo-shirts"
  },
  {
    "name": "tailored fit casual polo shirts",
    "slug": "tailored-fit-casual-polo-shirts"
  },
  {
    "name": "wrinkle-resistant casual polo shirts",
    "slug": "wrinkle-resistant-casual-polo-shirts"
  },
  {
    "name": "men's premium casual polo shirts",
    "slug": "mens-premium-casual-polo-shirts"
  },
  {
    "name": "soft and comfortable polo shirts",
    "slug": "soft-and-comfortable-polo-shirts"
  },
  {
    "name": "breathable cotton men's polo shirts",
    "slug": "breathable-cotton-mens-polo-shirts"
  },
  {
    "name": "versatile regular-fit polo shirts",
    "slug": "versatile-regular-fit-polo-shirts"
  },
  {
    "name": "tailored casual men's polo shirts",
    "slug": "tailored-casual-mens-polo-shirts"
  },
  {
    "name": "lightweight casual polo shirts men",
    "slug": "lightweight-casual-polo-shirts-men"
  },
  {
    "name": "simple and stylish polo shirts",
    "slug": "simple-and-stylish-polo-shirts"
  },
  {
    "name": "easy-care premium cotton polos",
    "slug": "easy-care-premium-cotton-polos"
  },
  {
    "name": "men's cotton casual polo shirts",
    "slug": "mens-cotton-casual-polo-shirts"
  },
  {
    "name": "premium quality men's polo shirts",
    "slug": "premium-quality-mens-polo-shirts"
  },
  {
    "name": "tailored fit casual polo shirts",
    "slug": "tailored-fit-casual-polo-shirts"
  },
  {
    "name": "breathable and comfortable polo shirts",
    "slug": "breathable-and-comfortable-polo-shirts"
  },
  {
    "name": "versatile wardrobe casual polo shirts",
    "slug": "versatile-wardrobe-casual-polo-shirts"
  },
  {
    "name": "wrinkle-free classic men's polos",
    "slug": "wrinkle-free-classic-mens-polos"
  },
  {
    "name": "lightweight and durable polo shirts",
    "slug": "lightweight-and-durable-polo-shirts"
  },
  {
    "name": "all-day comfort men's polos",
    "slug": "all-day-comfort-mens-polos"
  },
  {
    "name": "simple and stylish men's polos",
    "slug": "simple-and-stylish-mens-polos"
  },
  {
    "name": "soft cotton tailored polo shirts",
    "slug": "soft-cotton-tailored-polo-shirts"
  },
  {
    "name": "comfortable classic fit polo shirts",
    "slug": "comfortable-classic-fit-polo-shirts"
  },
  {
    "name": "modern casual men's polo shirts",
    "slug": "modern-casual-mens-polo-shirts"
  },
  {
    "name": "men's regular fit casual polos",
    "slug": "mens-regular-fit-casual-polos"
  },
  {
    "name": "durable easy-care men's polos",
    "slug": "durable-easy-care-mens-polos"
  },
  {
    "name": "stylish and versatile men's polos",
    "slug": "stylish-and-versatile-mens-polos"
  },
  {
    "name": "wrinkle-resistant casual men's polos",
    "slug": "wrinkle-resistant-casual-mens-polos"
  },
  {
    "name": "everyday comfortable men's polo shirts",
    "slug": "everyday-comfortable-mens-polo-shirts"
  },
  {
    "name": "timeless style casual polo shirts",
    "slug": "timeless-style-casual-polo-shirts"
  },
  {
    "name": "men's breathable everyday polo shirts",
    "slug": "mens-breathable-everyday-polo-shirts"
  },
  {
    "name": "premium tailored fit men's polos",
    "slug": "premium-tailored-fit-mens-polos"
  },
  {
    "name": "comfortable office wear men's polos",
    "slug": "comfortable-office-wear-mens-polos"
  },
  {
    "name": "classic everyday casual polo shirts",
    "slug": "classic-everyday-casual-polo-shirts"
  },
  {
    "name": "men's versatile regular fit polos",
    "slug": "mens-versatile-regular-fit-polos"
  },
  {
    "name": "soft fabric casual polo shirts",
    "slug": "soft-fabric-casual-polo-shirts"
  },
  {
    "name": "modern tailored casual polo shirts",
    "slug": "modern-tailored-casual-polo-shirts"
  },
  {
    "name": "simple everyday men's polo shirts",
    "slug": "simple-everyday-mens-polo-shirts"
  },
  {
    "name": "lightweight wrinkle-resistant polo shirts",
    "slug": "lightweight-wrinkle-resistant-polo-shirts"
  },
  {
    "name": "men's stretch fabric casual polos",
    "slug": "mens-stretch-fabric-casual-polos"
  },
  {
    "name": "casual business wardrobe polo shirts",
    "slug": "casual-business-wardrobe-polo-shirts"
  },
  {
    "name": "easy-care modern men's polos",
    "slug": "easy-care-modern-mens-polos"
  },
  {
    "name": "timeless fit casual men's polos",
    "slug": "timeless-fit-casual-mens-polos"
  },
  {
    "name": "relaxed fit casual men's polos",
    "slug": "relaxed-fit-casual-mens-polos"
  },
  {
    "name": "smart casual everyday polo shirts",
    "slug": "smart-casual-everyday-polo-shirts"
  },
  {
    "name": "tailored casual fit polo shirts",
    "slug": "tailored-casual-fit-polo-shirts"
  },
  {
    "name": "breathable fabric men's polo shirts",
    "slug": "breathable-fabric-mens-polo-shirts"
  },
  {
    "name": "men's lightweight classic fit polos",
    "slug": "mens-lightweight-classic-fit-polos"
  },
  {
    "name": "casual summer wardrobe men's polos",
    "slug": "casual-summer-wardrobe-mens-polos"
  },
  {
    "name": "premium easy-care polo shirts men",
    "slug": "premium-easy-care-polo-shirts-men"
  },
  {
    "name": "everyday tailored casual polo shirts",
    "slug": "everyday-tailored-casual-polo-shirts"
  },
  {
    "name": "simple modern style polo shirts",
    "slug": "simple-modern-style-polo-shirts"
  },
  {
    "name": "soft regular fit polo shirts",
    "slug": "soft-regular-fit-polo-shirts"
  },
  {
    "name": "men's casual office wardrobe polos",
    "slug": "mens-casual-office-wardrobe-polos"
  },
  {
    "name": "classic regular fit men's polos",
    "slug": "classic-regular-fit-mens-polos"
  },
  {
    "name": "comfortable all-purpose polo shirts",
    "slug": "comfortable-all-purpose-polo-shirts"
  },
  {
    "name": "stylish everyday men's polo shirts",
    "slug": "stylish-everyday-mens-polo-shirts"
  },
  {
    "name": "durable wrinkle-free men's polos",
    "slug": "durable-wrinkle-free-mens-polos"
  },
  {
    "name": "modern business casual polo shirts",
    "slug": "modern-business-casual-polo-shirts"
  },
  {
    "name": "relaxed tailored fit polo shirts",
    "slug": "relaxed-tailored-fit-polo-shirts"
  },
  {
    "name": "versatile classic fit men's polos",
    "slug": "versatile-classic-fit-mens-polos"
  },
  {
    "name": "casual wear classic polo shirts",
    "slug": "casual-wear-classic-polo-shirts"
  },
  {
    "name": "black workout shirts",
    "slug": "black-workout-shirts"
  },
  {
    "name": "white workout shirts",
    "slug": "white-workout-shirts"
  },
  {
    "name": "grey workout shirts",
    "slug": "grey-workout-shirts"
  },
  {
    "name": "steel grey workout shirts",
    "slug": "steel-grey-workout-shirts"
  },
  {
    "name": "blue workout shirts",
    "slug": "blue-workout-shirts"
  },
  {
    "name": "navy blue workout shirts",
    "slug": "navy-blue-workout-shirts"
  },
  {
    "name": "black gym shirts",
    "slug": "black-gym-shirts"
  },
  {
    "name": "white gym shirts",
    "slug": "white-gym-shirts"
  },
  {
    "name": "grey gym shirts",
    "slug": "grey-gym-shirts"
  },
  {
    "name": "steel grey gym shirts",
    "slug": "steel-grey-gym-shirts"
  },
  {
    "name": "blue gym shirts",
    "slug": "blue-gym-shirts"
  },
  {
    "name": "navy gym shirts",
    "slug": "navy-gym-shirts"
  },
  {
    "name": "black training shirts",
    "slug": "black-training-shirts"
  },
  {
    "name": "white training shirts",
    "slug": "white-training-shirts"
  },
  {
    "name": "grey training shirts",
    "slug": "grey-training-shirts"
  },
  {
    "name": "steel grey training shirts",
    "slug": "steel-grey-training-shirts"
  },
  {
    "name": "blue training shirts",
    "slug": "blue-training-shirts"
  },
  {
    "name": "navy training shirts",
    "slug": "navy-training-shirts"
  },
  {
    "name": "black athletic shirts",
    "slug": "black-athletic-shirts"
  },
  {
    "name": "white athletic shirts",
    "slug": "white-athletic-shirts"
  },
  {
    "name": "grey athletic shirts",
    "slug": "grey-athletic-shirts"
  },
  {
    "name": "steel grey athletic shirts",
    "slug": "steel-grey-athletic-shirts"
  },
  {
    "name": "blue athletic shirts",
    "slug": "blue-athletic-shirts"
  },
  {
    "name": "navy athletic shirts",
    "slug": "navy-athletic-shirts"
  },
  {
    "name": "black performance shirts",
    "slug": "black-performance-shirts"
  },
  {
    "name": "white performance shirts",
    "slug": "white-performance-shirts"
  },
  {
    "name": "grey performance shirts",
    "slug": "grey-performance-shirts"
  },
  {
    "name": "steel grey performance shirts",
    "slug": "steel-grey-performance-shirts"
  },
  {
    "name": "blue performance shirts",
    "slug": "blue-performance-shirts"
  },
  {
    "name": "navy performance shirts",
    "slug": "navy-performance-shirts"
  },
  {
    "name": "black fitness shirts",
    "slug": "black-fitness-shirts"
  },
  {
    "name": "white fitness shirts",
    "slug": "white-fitness-shirts"
  },
  {
    "name": "grey fitness shirts",
    "slug": "grey-fitness-shirts"
  },
  {
    "name": "steel grey fitness shirts",
    "slug": "steel-grey-fitness-shirts"
  },
  {
    "name": "blue fitness shirts",
    "slug": "blue-fitness-shirts"
  },
  {
    "name": "navy fitness shirts",
    "slug": "navy-fitness-shirts"
  },
  {
    "name": "black exercise shirts",
    "slug": "black-exercise-shirts"
  },
  {
    "name": "white exercise shirts",
    "slug": "white-exercise-shirts"
  },
  {
    "name": "grey exercise shirts",
    "slug": "grey-exercise-shirts"
  },
  {
    "name": "steel grey exercise shirts",
    "slug": "steel-grey-exercise-shirts"
  },
  {
    "name": "blue exercise shirts",
    "slug": "blue-exercise-shirts"
  },
  {
    "name": "navy exercise shirts",
    "slug": "navy-exercise-shirts"
  },
  {
    "name": "black sports shirts",
    "slug": "black-sports-shirts"
  },
  {
    "name": "white sports shirts",
    "slug": "white-sports-shirts"
  },
  {
    "name": "grey sports shirts",
    "slug": "grey-sports-shirts"
  },
  {
    "name": "steel grey sports shirts",
    "slug": "steel-grey-sports-shirts"
  },
  {
    "name": "blue sports shirts",
    "slug": "blue-sports-shirts"
  },
  {
    "name": "navy sports shirts",
    "slug": "navy-sports-shirts"
  },
  {
    "name": "black gym tees",
    "slug": "black-gym-tees"
  },
  {
    "name": "white gym tees",
    "slug": "white-gym-tees"
  },
  {
    "name": "men's workout shirts",
    "slug": "mens-workout-shirts"
  },
  {
    "name": "men's gym shirts",
    "slug": "mens-gym-shirts"
  },
  {
    "name": "men's training shirts",
    "slug": "mens-training-shirts"
  },
  {
    "name": "men's athletic shirts",
    "slug": "mens-athletic-shirts"
  },
  {
    "name": "moisture-wicking workout shirts",
    "slug": "moisture-wicking-workout-shirts"
  },
  {
    "name": "breathable workout shirts",
    "slug": "breathable-workout-shirts"
  },
  {
    "name": "lightweight workout shirts",
    "slug": "lightweight-workout-shirts"
  },
  {
    "name": "quick-dry workout shirts",
    "slug": "quick-dry-workout-shirts"
  },
  {
    "name": "comfortable workout shirts",
    "slug": "comfortable-workout-shirts"
  },
  {
    "name": "stretch workout shirts",
    "slug": "stretch-workout-shirts"
  },
  {
    "name": "men's fitness shirts",
    "slug": "mens-fitness-shirts"
  },
  {
    "name": "gym training shirts",
    "slug": "gym-training-shirts"
  },
  {
    "name": "performance workout shirts",
    "slug": "performance-workout-shirts"
  },
  {
    "name": "durable workout shirts",
    "slug": "durable-workout-shirts"
  },
  {
    "name": "gym performance shirts",
    "slug": "gym-performance-shirts"
  },
  {
    "name": "seamless workout shirts",
    "slug": "seamless-workout-shirts"
  },
  {
    "name": "men's exercise shirts",
    "slug": "mens-exercise-shirts"
  },
  {
    "name": "men's active shirts",
    "slug": "mens-active-shirts"
  },
  {
    "name": "athletic training shirts",
    "slug": "athletic-training-shirts"
  },
  {
    "name": "gym wear shirts",
    "slug": "gym-wear-shirts"
  },
  {
    "name": "compression workout shirts",
    "slug": "compression-workout-shirts"
  },
  {
    "name": "sports workout shirts",
    "slug": "sports-workout-shirts"
  },
  {
    "name": "flexible workout shirts",
    "slug": "flexible-workout-shirts"
  },
  {
    "name": "men's workout tees",
    "slug": "mens-workout-tees"
  },
  {
    "name": "casual workout shirts",
    "slug": "casual-workout-shirts"
  },
  {
    "name": "relaxed workout shirts",
    "slug": "relaxed-workout-shirts"
  },
  {
    "name": "fitted workout shirts",
    "slug": "fitted-workout-shirts"
  },
  {
    "name": "workout gym shirts",
    "slug": "workout-gym-shirts"
  },
  {
    "name": "men's base layer shirts",
    "slug": "mens-base-layer-shirts"
  },
  {
    "name": "workout sweat-resistant shirts",
    "slug": "workout-sweat-resistant-shirts"
  },
  {
    "name": "men's sport shirts",
    "slug": "mens-sport-shirts"
  },
  {
    "name": "everyday workout shirts",
    "slug": "everyday-workout-shirts"
  },
  {
    "name": "classic workout shirts",
    "slug": "classic-workout-shirts"
  },
  {
    "name": "men's muscle shirts",
    "slug": "mens-muscle-shirts"
  },
  {
    "name": "loose workout shirts",
    "slug": "loose-workout-shirts"
  },
  {
    "name": "stylish workout shirts",
    "slug": "stylish-workout-shirts"
  },
  {
    "name": "men's yoga shirts",
    "slug": "mens-yoga-shirts"
  },
  {
    "name": "all-day workout shirts",
    "slug": "all-day-workout-shirts"
  },
  {
    "name": "wrinkle-free workout shirts",
    "slug": "wrinkle-free-workout-shirts"
  },
  {
    "name": "quick-dry gym shirts",
    "slug": "quick-dry-gym-shirts"
  },
  {
    "name": "active training shirts",
    "slug": "active-training-shirts"
  },
  {
    "name": "men's core workout shirts",
    "slug": "mens-core-workout-shirts"
  },
  {
    "name": "athletic wear shirts",
    "slug": "athletic-wear-shirts"
  },
  {
    "name": "men's stretch shirts",
    "slug": "mens-stretch-shirts"
  },
  {
    "name": "premium workout shirts",
    "slug": "premium-workout-shirts"
  },
  {
    "name": "modern workout shirts",
    "slug": "modern-workout-shirts"
  },
  {
    "name": "casual training shirts",
    "slug": "casual-training-shirts"
  },
  {
    "name": "advanced workout shirts",
    "slug": "advanced-workout-shirts"
  },
  {
    "name": "functional workout shirts",
    "slug": "functional-workout-shirts"
  },
  {
    "name": "reliable workout shirts",
    "slug": "reliable-workout-shirts"
  },
  {
    "name": "men's black workout shirts",
    "slug": "mens-black-workout-shirts"
  },
  {
    "name": "men's white workout shirts",
    "slug": "mens-white-workout-shirts"
  },
  {
    "name": "men's grey workout shirts",
    "slug": "mens-grey-workout-shirts"
  },
  {
    "name": "men's steel grey workout shirts",
    "slug": "mens-steel-grey-workout-shirts"
  },
  {
    "name": "men's blue workout shirts",
    "slug": "mens-blue-workout-shirts"
  },
  {
    "name": "men's navy blue workout shirts",
    "slug": "mens-navy-blue-workout-shirts"
  },
  {
    "name": "black moisture-wicking workout shirts",
    "slug": "black-moisture-wicking-workout-shirts"
  },
  {
    "name": "white moisture-wicking workout shirts",
    "slug": "white-moisture-wicking-workout-shirts"
  },
  {
    "name": "grey moisture-wicking workout shirts",
    "slug": "grey-moisture-wicking-workout-shirts"
  },
  {
    "name": "steel grey moisture-wicking workout shirts",
    "slug": "steel-grey-moisture-wicking-workout-shirts"
  },
  {
    "name": "blue moisture-wicking workout shirts",
    "slug": "blue-moisture-wicking-workout-shirts"
  },
  {
    "name": "navy blue moisture-wicking workout shirts",
    "slug": "navy-blue-moisture-wicking-workout-shirts"
  },
  {
    "name": "black quick-dry workout shirts",
    "slug": "black-quick-dry-workout-shirts"
  },
  {
    "name": "white quick-dry workout shirts",
    "slug": "white-quick-dry-workout-shirts"
  },
  {
    "name": "grey quick-dry workout shirts",
    "slug": "grey-quick-dry-workout-shirts"
  },
  {
    "name": "steel grey quick-dry workout shirts",
    "slug": "steel-grey-quick-dry-workout-shirts"
  },
  {
    "name": "blue quick-dry workout shirts",
    "slug": "blue-quick-dry-workout-shirts"
  },
  {
    "name": "navy blue quick-dry workout shirts",
    "slug": "navy-blue-quick-dry-workout-shirts"
  },
  {
    "name": "black breathable workout shirts",
    "slug": "black-breathable-workout-shirts"
  },
  {
    "name": "white breathable workout shirts",
    "slug": "white-breathable-workout-shirts"
  },
  {
    "name": "grey breathable workout shirts",
    "slug": "grey-breathable-workout-shirts"
  },
  {
    "name": "steel grey breathable workout shirts",
    "slug": "steel-grey-breathable-workout-shirts"
  },
  {
    "name": "blue breathable workout shirts",
    "slug": "blue-breathable-workout-shirts"
  },
  {
    "name": "navy blue breathable workout shirts",
    "slug": "navy-blue-breathable-workout-shirts"
  },
  {
    "name": "black lightweight workout shirts",
    "slug": "black-lightweight-workout-shirts"
  },
  {
    "name": "white lightweight workout shirts",
    "slug": "white-lightweight-workout-shirts"
  },
  {
    "name": "grey lightweight workout shirts",
    "slug": "grey-lightweight-workout-shirts"
  },
  {
    "name": "steel grey lightweight workout shirts",
    "slug": "steel-grey-lightweight-workout-shirts"
  },
  {
    "name": "blue lightweight workout shirts",
    "slug": "blue-lightweight-workout-shirts"
  },
  {
    "name": "navy blue lightweight workout shirts",
    "slug": "navy-blue-lightweight-workout-shirts"
  },
  {
    "name": "black gym training shirts",
    "slug": "black-gym-training-shirts"
  },
  {
    "name": "white gym training shirts",
    "slug": "white-gym-training-shirts"
  },
  {
    "name": "grey gym training shirts",
    "slug": "grey-gym-training-shirts"
  },
  {
    "name": "steel grey gym training shirts",
    "slug": "steel-grey-gym-training-shirts"
  },
  {
    "name": "blue gym training shirts",
    "slug": "blue-gym-training-shirts"
  },
  {
    "name": "navy blue gym training shirts",
    "slug": "navy-blue-gym-training-shirts"
  },
  {
    "name": "black athletic performance shirts",
    "slug": "black-athletic-performance-shirts"
  },
  {
    "name": "white athletic performance shirts",
    "slug": "white-athletic-performance-shirts"
  },
  {
    "name": "grey athletic performance shirts",
    "slug": "grey-athletic-performance-shirts"
  },
  {
    "name": "steel grey athletic performance shirts",
    "slug": "steel-grey-athletic-performance-shirts"
  },
  {
    "name": "blue athletic performance shirts",
    "slug": "blue-athletic-performance-shirts"
  },
  {
    "name": "navy blue athletic performance shirts",
    "slug": "navy-blue-athletic-performance-shirts"
  },
  {
    "name": "black fitness training shirts",
    "slug": "black-fitness-training-shirts"
  },
  {
    "name": "white fitness training shirts",
    "slug": "white-fitness-training-shirts"
  },
  {
    "name": "grey fitness training shirts",
    "slug": "grey-fitness-training-shirts"
  },
  {
    "name": "steel grey fitness training shirts",
    "slug": "steel-grey-fitness-training-shirts"
  },
  {
    "name": "blue fitness training shirts",
    "slug": "blue-fitness-training-shirts"
  },
  {
    "name": "navy blue fitness training shirts",
    "slug": "navy-blue-fitness-training-shirts"
  },
  {
    "name": "black exercise performance shirts",
    "slug": "black-exercise-performance-shirts"
  },
  {
    "name": "white exercise performance shirts",
    "slug": "white-exercise-performance-shirts"
  },
  {
    "name": "men's moisture-wicking workout shirts",
    "slug": "mens-moisture-wicking-workout-shirts"
  },
  {
    "name": "breathable and comfortable workout shirts",
    "slug": "breathable-and-comfortable-workout-shirts"
  },
  {
    "name": "lightweight and stretch workout shirts",
    "slug": "lightweight-and-stretch-workout-shirts"
  },
  {
    "name": "quick-dry and durable workout shirts",
    "slug": "quick-dry-and-durable-workout-shirts"
  },
  {
    "name": "seamless men's gym training shirts",
    "slug": "seamless-mens-gym-training-shirts"
  },
  {
    "name": "men's all-day workout shirts",
    "slug": "mens-all-day-workout-shirts"
  },
  {
    "name": "classic fit men's workout shirts",
    "slug": "classic-fit-mens-workout-shirts"
  },
  {
    "name": "casual and stylish workout shirts",
    "slug": "casual-and-stylish-workout-shirts"
  },
  {
    "name": "wrinkle-resistant men's workout shirts",
    "slug": "wrinkle-resistant-mens-workout-shirts"
  },
  {
    "name": "performance fabric men's workout shirts",
    "slug": "performance-fabric-mens-workout-shirts"
  },
  {
    "name": "stretch fit gym training shirts",
    "slug": "stretch-fit-gym-training-shirts"
  },
  {
    "name": "men's workout shirts for exercise",
    "slug": "mens-workout-shirts-for-exercise"
  },
  {
    "name": "premium quality workout shirts men",
    "slug": "premium-quality-workout-shirts-men"
  },
  {
    "name": "activewear for men's workout needs",
    "slug": "activewear-for-mens-workout-needs"
  },
  {
    "name": "advanced fabric men's workout shirts",
    "slug": "advanced-fabric-mens-workout-shirts"
  },
  {
    "name": "relaxed fit men's gym shirts",
    "slug": "relaxed-fit-mens-gym-shirts"
  },
  {
    "name": "stylish and durable workout shirts",
    "slug": "stylish-and-durable-workout-shirts"
  },
  {
    "name": "men's compression gym training shirts",
    "slug": "mens-compression-gym-training-shirts"
  },
  {
    "name": "everyday use men's workout shirts",
    "slug": "everyday-use-mens-workout-shirts"
  },
  {
    "name": "tailored fit men's workout shirts",
    "slug": "tailored-fit-mens-workout-shirts"
  },
  {
    "name": "functional and breathable workout shirts",
    "slug": "functional-and-breathable-workout-shirts"
  },
  {
    "name": "base layer men's workout shirts",
    "slug": "base-layer-mens-workout-shirts"
  },
  {
    "name": "modern design men's gym shirts",
    "slug": "modern-design-mens-gym-shirts"
  },
  {
    "name": "versatile gym training workout shirts",
    "slug": "versatile-gym-training-workout-shirts"
  },
  {
    "name": "sweat-resistant and durable workout shirts",
    "slug": "sweat-resistant-and-durable-workout-shirts"
  },
  {
    "name": "flexible and comfortable workout shirts",
    "slug": "flexible-and-comfortable-workout-shirts"
  },
  {
    "name": "quick-dry activewear men's shirts",
    "slug": "quick-dry-activewear-mens-shirts"
  },
  {
    "name": "long-lasting performance workout shirts",
    "slug": "long-lasting-performance-workout-shirts"
  },
  {
    "name": "everyday active training workout shirts",
    "slug": "everyday-active-training-workout-shirts"
  },
  {
    "name": "men's fitted gym training shirts",
    "slug": "mens-fitted-gym-training-shirts"
  },
  {
    "name": "functional and stylish workout shirts",
    "slug": "functional-and-stylish-workout-shirts"
  },
  {
    "name": "workout shirts for men's comfort",
    "slug": "workout-shirts-for-mens-comfort"
  },
  {
    "name": "high-performance men's active shirts",
    "slug": "high-performance-mens-active-shirts"
  },
  {
    "name": "gym wear for men's fitness",
    "slug": "gym-wear-for-mens-fitness"
  },
  {
    "name": "advanced moisture-control workout shirts",
    "slug": "advanced-moisture-control-workout-shirts"
  },
  {
    "name": "tailored casual fit gym shirts",
    "slug": "tailored-casual-fit-gym-shirts"
  },
  {
    "name": "reliable stretch fit workout shirts",
    "slug": "reliable-stretch-fit-workout-shirts"
  },
  {
    "name": "men's sportswear gym training shirts",
    "slug": "mens-sportswear-gym-training-shirts"
  },
  {
    "name": "classic workout wear for men",
    "slug": "classic-workout-wear-for-men"
  },
  {
    "name": "men's wrinkle-free workout apparel",
    "slug": "mens-wrinkle-free-workout-apparel"
  },
  {
    "name": "lightweight gym training shirts for men",
    "slug": "lightweight-gym-training-shirts-for-men"
  },
  {
    "name": "stretchable and durable workout shirts",
    "slug": "stretchable-and-durable-workout-shirts"
  },
  {
    "name": "soft fabric men's workout shirts",
    "slug": "soft-fabric-mens-workout-shirts"
  },
  {
    "name": "casual fit gym workout shirts",
    "slug": "casual-fit-gym-workout-shirts"
  },
  {
    "name": "premium sportswear for men's workout",
    "slug": "premium-sportswear-for-mens-workout"
  },
  {
    "name": "men's modern activewear gym shirts",
    "slug": "mens-modern-activewear-gym-shirts"
  },
  {
    "name": "easy-care fabric workout shirts men",
    "slug": "easy-care-fabric-workout-shirts-men"
  },
  {
    "name": "reliable men's activewear for workouts",
    "slug": "reliable-mens-activewear-for-workouts"
  },
  {
    "name": "professional-grade men's workout shirts",
    "slug": "professional-grade-mens-workout-shirts"
  },
  {
    "name": "essential gym wear for men's training",
    "slug": "essential-gym-wear-for-mens-training"
  },
  {
    "name": "black men's overshirts",
    "slug": "black-mens-overshirts"
  },
  {
    "name": "grey men's overshirts",
    "slug": "grey-mens-overshirts"
  },
  {
    "name": "light grey overshirts",
    "slug": "light-grey-overshirts"
  },
  {
    "name": "blue men's overshirts",
    "slug": "blue-mens-overshirts"
  },
  {
    "name": "navy blue overshirts",
    "slug": "navy-blue-overshirts"
  },
  {
    "name": "cream men's overshirts",
    "slug": "cream-mens-overshirts"
  },
  {
    "name": "Irish cream overshirts",
    "slug": "irish-cream-overshirts"
  },
  {
    "name": "green men's overshirts",
    "slug": "green-mens-overshirts"
  },
  {
    "name": "army green overshirts",
    "slug": "army-green-overshirts"
  },
  {
    "name": "black tailored overshirts",
    "slug": "black-tailored-overshirts"
  },
  {
    "name": "grey tailored overshirts",
    "slug": "grey-tailored-overshirts"
  },
  {
    "name": "blue tailored overshirts",
    "slug": "blue-tailored-overshirts"
  },
  {
    "name": "navy tailored overshirts",
    "slug": "navy-tailored-overshirts"
  },
  {
    "name": "cream tailored overshirts",
    "slug": "cream-tailored-overshirts"
  },
  {
    "name": "green tailored overshirts",
    "slug": "green-tailored-overshirts"
  },
  {
    "name": "black smart overshirts",
    "slug": "black-smart-overshirts"
  },
  {
    "name": "grey smart overshirts",
    "slug": "grey-smart-overshirts"
  },
  {
    "name": "blue smart overshirts",
    "slug": "blue-smart-overshirts"
  },
  {
    "name": "cream smart overshirts",
    "slug": "cream-smart-overshirts"
  },
  {
    "name": "green smart overshirts",
    "slug": "green-smart-overshirts"
  },
  {
    "name": "navy stretch overshirts",
    "slug": "navy-stretch-overshirts"
  },
  {
    "name": "black stretch overshirts",
    "slug": "black-stretch-overshirts"
  },
  {
    "name": "grey stretch overshirts",
    "slug": "grey-stretch-overshirts"
  },
  {
    "name": "green stretch overshirts",
    "slug": "green-stretch-overshirts"
  },
  {
    "name": "navy casual overshirts",
    "slug": "navy-casual-overshirts"
  },
  {
    "name": "black casual overshirts",
    "slug": "black-casual-overshirts"
  },
  {
    "name": "grey casual overshirts",
    "slug": "grey-casual-overshirts"
  },
  {
    "name": "blue casual overshirts",
    "slug": "blue-casual-overshirts"
  },
  {
    "name": "cream casual overshirts",
    "slug": "cream-casual-overshirts"
  },
  {
    "name": "green casual overshirts",
    "slug": "green-casual-overshirts"
  },
  {
    "name": "light grey tailored overshirts",
    "slug": "light-grey-tailored-overshirts"
  },
  {
    "name": "black lightweight overshirts",
    "slug": "black-lightweight-overshirts"
  },
  {
    "name": "navy lightweight overshirts",
    "slug": "navy-lightweight-overshirts"
  },
  {
    "name": "grey lightweight overshirts",
    "slug": "grey-lightweight-overshirts"
  },
  {
    "name": "blue lightweight overshirts",
    "slug": "blue-lightweight-overshirts"
  },
  {
    "name": "cream lightweight overshirts",
    "slug": "cream-lightweight-overshirts"
  },
  {
    "name": "green lightweight overshirts",
    "slug": "green-lightweight-overshirts"
  },
  {
    "name": "black structured overshirts",
    "slug": "black-structured-overshirts"
  },
  {
    "name": "grey structured overshirts",
    "slug": "grey-structured-overshirts"
  },
  {
    "name": "navy structured overshirts",
    "slug": "navy-structured-overshirts"
  },
  {
    "name": "green structured overshirts",
    "slug": "green-structured-overshirts"
  },
  {
    "name": "cream structured overshirts",
    "slug": "cream-structured-overshirts"
  },
  {
    "name": "Irish cream casual overshirts",
    "slug": "irish-cream-casual-overshirts"
  },
  {
    "name": "black breathable overshirts",
    "slug": "black-breathable-overshirts"
  },
  {
    "name": "navy breathable overshirts",
    "slug": "navy-breathable-overshirts"
  },
  {
    "name": "grey breathable overshirts",
    "slug": "grey-breathable-overshirts"
  },
  {
    "name": "green breathable overshirts",
    "slug": "green-breathable-overshirts"
  },
  {
    "name": "cream breathable overshirts",
    "slug": "cream-breathable-overshirts"
  },
  {
    "name": "blue breathable overshirts",
    "slug": "blue-breathable-overshirts"
  },
  {
    "name": "black versatile overshirts",
    "slug": "black-versatile-overshirts"
  },
  {
    "name": "tailored men's overshirts",
    "slug": "tailored-mens-overshirts"
  },
  {
    "name": "casual men's overshirts",
    "slug": "casual-mens-overshirts"
  },
  {
    "name": "structured men's overshirts",
    "slug": "structured-mens-overshirts"
  },
  {
    "name": "breathable men's overshirts",
    "slug": "breathable-mens-overshirts"
  },
  {
    "name": "stretchable men's overshirts",
    "slug": "stretchable-mens-overshirts"
  },
  {
    "name": "smart casual overshirts",
    "slug": "smart-casual-overshirts"
  },
  {
    "name": "lightweight men's overshirts",
    "slug": "lightweight-mens-overshirts"
  },
  {
    "name": "versatile men's overshirts",
    "slug": "versatile-mens-overshirts"
  },
  {
    "name": "fitted men's overshirts",
    "slug": "fitted-mens-overshirts"
  },
  {
    "name": "flexible men's overshirts",
    "slug": "flexible-mens-overshirts"
  },
  {
    "name": "modern men's overshirts",
    "slug": "modern-mens-overshirts"
  },
  {
    "name": "comfortable men's overshirts",
    "slug": "comfortable-mens-overshirts"
  },
  {
    "name": "premium men's overshirts",
    "slug": "premium-mens-overshirts"
  },
  {
    "name": "durable men's overshirts",
    "slug": "durable-mens-overshirts"
  },
  {
    "name": "everyday men's overshirts",
    "slug": "everyday-mens-overshirts"
  },
  {
    "name": "relaxed fit overshirts",
    "slug": "relaxed-fit-overshirts"
  },
  {
    "name": "stretch tailored overshirts",
    "slug": "stretch-tailored-overshirts"
  },
  {
    "name": "classic men's overshirts",
    "slug": "classic-mens-overshirts"
  },
  {
    "name": "casual fit overshirts",
    "slug": "casual-fit-overshirts"
  },
  {
    "name": "stylish men's overshirts",
    "slug": "stylish-mens-overshirts"
  },
  {
    "name": "lightweight stretch overshirts",
    "slug": "lightweight-stretch-overshirts"
  },
  {
    "name": "tailored stretch overshirts",
    "slug": "tailored-stretch-overshirts"
  },
  {
    "name": "breathable casual overshirts",
    "slug": "breathable-casual-overshirts"
  },
  {
    "name": "flexible casual overshirts",
    "slug": "flexible-casual-overshirts"
  },
  {
    "name": "modern tailored overshirts",
    "slug": "modern-tailored-overshirts"
  },
  {
    "name": "premium tailored overshirts",
    "slug": "premium-tailored-overshirts"
  },
  {
    "name": "casual structured overshirts",
    "slug": "casual-structured-overshirts"
  },
  {
    "name": "tailored casual overshirts",
    "slug": "tailored-casual-overshirts"
  },
  {
    "name": "stretch smart overshirts",
    "slug": "stretch-smart-overshirts"
  },
  {
    "name": "relaxed tailored overshirts",
    "slug": "relaxed-tailored-overshirts"
  },
  {
    "name": "structured smart overshirts",
    "slug": "structured-smart-overshirts"
  },
  {
    "name": "comfortable tailored overshirts",
    "slug": "comfortable-tailored-overshirts"
  },
  {
    "name": "lightweight casual overshirts",
    "slug": "lightweight-casual-overshirts"
  },
  {
    "name": "premium structured overshirts",
    "slug": "premium-structured-overshirts"
  },
  {
    "name": "breathable structured overshirts",
    "slug": "breathable-structured-overshirts"
  },
  {
    "name": "versatile tailored overshirts",
    "slug": "versatile-tailored-overshirts"
  },
  {
    "name": "casual flexible overshirts",
    "slug": "casual-flexible-overshirts"
  },
  {
    "name": "structured casual overshirts",
    "slug": "structured-casual-overshirts"
  },
  {
    "name": "tailored everyday overshirts",
    "slug": "tailored-everyday-overshirts"
  },
  {
    "name": "comfortable stretch overshirts",
    "slug": "comfortable-stretch-overshirts"
  },
  {
    "name": "stretch casual overshirts",
    "slug": "stretch-casual-overshirts"
  },
  {
    "name": "everyday tailored overshirts",
    "slug": "everyday-tailored-overshirts"
  },
  {
    "name": "premium casual overshirts",
    "slug": "premium-casual-overshirts"
  },
  {
    "name": "relaxed casual overshirts",
    "slug": "relaxed-casual-overshirts"
  },
  {
    "name": "structured lightweight overshirts",
    "slug": "structured-lightweight-overshirts"
  },
  {
    "name": "breathable lightweight overshirts",
    "slug": "breathable-lightweight-overshirts"
  },
  {
    "name": "fitted stretch overshirts",
    "slug": "fitted-stretch-overshirts"
  },
  {
    "name": "tailored flexible overshirts",
    "slug": "tailored-flexible-overshirts"
  },
  {
    "name": "stylish tailored overshirts",
    "slug": "stylish-tailored-overshirts"
  },
  {
    "name": "modern casual overshirts",
    "slug": "modern-casual-overshirts"
  },
  {
    "name": "black men's tailored fit overshirts",
    "slug": "black-mens-tailored-fit-overshirts"
  },
  {
    "name": "grey men's tailored fit overshirts",
    "slug": "grey-mens-tailored-fit-overshirts"
  },
  {
    "name": "navy men's tailored fit overshirts",
    "slug": "navy-mens-tailored-fit-overshirts"
  },
  {
    "name": "blue men's lightweight overshirts",
    "slug": "blue-mens-lightweight-overshirts"
  },
  {
    "name": "cream men's breathable casual overshirts",
    "slug": "cream-mens-breathable-casual-overshirts"
  },
  {
    "name": "green men's stretchable casual overshirts",
    "slug": "green-mens-stretchable-casual-overshirts"
  },
  {
    "name": "Irish cream lightweight men's overshirts",
    "slug": "irish-cream-lightweight-mens-overshirts"
  },
  {
    "name": "black casual tailored men's overshirts",
    "slug": "black-casual-tailored-mens-overshirts"
  },
  {
    "name": "grey casual structured men's overshirts",
    "slug": "grey-casual-structured-mens-overshirts"
  },
  {
    "name": "navy casual tailored men's overshirts",
    "slug": "navy-casual-tailored-mens-overshirts"
  },
  {
    "name": "blue lightweight stretch men's overshirts",
    "slug": "blue-lightweight-stretch-mens-overshirts"
  },
  {
    "name": "green structured casual men's overshirts",
    "slug": "green-structured-casual-mens-overshirts"
  },
  {
    "name": "cream tailored breathable men's overshirts",
    "slug": "cream-tailored-breathable-mens-overshirts"
  },
  {
    "name": "Irish cream structured men's overshirts",
    "slug": "irish-cream-structured-mens-overshirts"
  },
  {
    "name": "black stretchable casual men's overshirts",
    "slug": "black-stretchable-casual-mens-overshirts"
  },
  {
    "name": "navy tailored breathable men's overshirts",
    "slug": "navy-tailored-breathable-mens-overshirts"
  },
  {
    "name": "grey lightweight breathable men's overshirts",
    "slug": "grey-lightweight-breathable-mens-overshirts"
  },
  {
    "name": "blue tailored structured men's overshirts",
    "slug": "blue-tailored-structured-mens-overshirts"
  },
  {
    "name": "green casual flexible men's overshirts",
    "slug": "green-casual-flexible-mens-overshirts"
  },
  {
    "name": "cream breathable flexible men's overshirts",
    "slug": "cream-breathable-flexible-mens-overshirts"
  },
  {
    "name": "navy stretchable smart casual overshirts",
    "slug": "navy-stretchable-smart-casual-overshirts"
  },
  {
    "name": "black lightweight structured casual overshirts",
    "slug": "black-lightweight-structured-casual-overshirts"
  },
  {
    "name": "light grey tailored fit men's overshirts",
    "slug": "light-grey-tailored-fit-mens-overshirts"
  },
  {
    "name": "black tailored breathable stretch men's overshirts",
    "slug": "black-tailored-breathable-stretch-mens-overshirts"
  },
  {
    "name": "green tailored lightweight men's overshirts",
    "slug": "green-tailored-lightweight-mens-overshirts"
  },
  {
    "name": "navy tailored flexible men's overshirts",
    "slug": "navy-tailored-flexible-mens-overshirts"
  },
  {
    "name": "cream casual stretchable tailored overshirts",
    "slug": "cream-casual-stretchable-tailored-overshirts"
  },
  {
    "name": "grey tailored breathable casual overshirts",
    "slug": "grey-tailored-breathable-casual-overshirts"
  },
  {
    "name": "blue lightweight versatile men's overshirts",
    "slug": "blue-lightweight-versatile-mens-overshirts"
  },
  {
    "name": "green structured tailored casual overshirts",
    "slug": "green-structured-tailored-casual-overshirts"
  },
  {
    "name": "cream modern breathable lightweight overshirts",
    "slug": "cream-modern-breathable-lightweight-overshirts"
  },
  {
    "name": "navy stretchable tailored casual overshirts",
    "slug": "navy-stretchable-tailored-casual-overshirts"
  },
  {
    "name": "black versatile lightweight men's overshirts",
    "slug": "black-versatile-lightweight-mens-overshirts"
  },
  {
    "name": "blue breathable tailored fit overshirts",
    "slug": "blue-breathable-tailored-fit-overshirts"
  },
  {
    "name": "grey casual lightweight tailored overshirts",
    "slug": "grey-casual-lightweight-tailored-overshirts"
  },
  {
    "name": "green structured smart casual overshirts",
    "slug": "green-structured-smart-casual-overshirts"
  },
  {
    "name": "Irish cream versatile lightweight overshirts",
    "slug": "irish-cream-versatile-lightweight-overshirts"
  },
  {
    "name": "navy casual smart fit overshirts",
    "slug": "navy-casual-smart-fit-overshirts"
  },
  {
    "name": "cream tailored lightweight structured overshirts",
    "slug": "cream-tailored-lightweight-structured-overshirts"
  },
  {
    "name": "green breathable structured casual overshirts",
    "slug": "green-breathable-structured-casual-overshirts"
  },
  {
    "name": "light grey breathable structured overshirts",
    "slug": "light-grey-breathable-structured-overshirts"
  },
  {
    "name": "navy modern tailored casual overshirts",
    "slug": "navy-modern-tailored-casual-overshirts"
  },
  {
    "name": "black lightweight structured fit overshirts",
    "slug": "black-lightweight-structured-fit-overshirts"
  },
  {
    "name": "blue casual tailored smart overshirts",
    "slug": "blue-casual-tailored-smart-overshirts"
  },
  {
    "name": "grey tailored stretchable casual overshirts",
    "slug": "grey-tailored-stretchable-casual-overshirts"
  },
  {
    "name": "green modern fit casual overshirts",
    "slug": "green-modern-fit-casual-overshirts"
  },
  {
    "name": "navy versatile tailored structured overshirts",
    "slug": "navy-versatile-tailored-structured-overshirts"
  },
  {
    "name": "cream lightweight casual structured overshirts",
    "slug": "cream-lightweight-casual-structured-overshirts"
  },
  {
    "name": "black stretch breathable smart overshirts",
    "slug": "black-stretch-breathable-smart-overshirts"
  },
  {
    "name": "grey tailored casual smart overshirts",
    "slug": "grey-tailored-casual-smart-overshirts"
  },
  {
    "name": "tailored fit men's casual overshirts",
    "slug": "tailored-fit-mens-casual-overshirts"
  },
  {
    "name": "stretchable and breathable men's overshirts",
    "slug": "stretchable-and-breathable-mens-overshirts"
  },
  {
    "name": "smart casual tailored men's overshirts",
    "slug": "smart-casual-tailored-mens-overshirts"
  },
  {
    "name": "lightweight and flexible men's overshirts",
    "slug": "lightweight-and-flexible-mens-overshirts"
  },
  {
    "name": "everyday casual tailored men's overshirts",
    "slug": "everyday-casual-tailored-mens-overshirts"
  },
  {
    "name": "modern fit men's structured overshirts",
    "slug": "modern-fit-mens-structured-overshirts"
  },
  {
    "name": "breathable structured tailored men's overshirts",
    "slug": "breathable-structured-tailored-mens-overshirts"
  },
  {
    "name": "stretch casual fit men's overshirts",
    "slug": "stretch-casual-fit-mens-overshirts"
  },
  {
    "name": "premium quality tailored men's overshirts",
    "slug": "premium-quality-tailored-mens-overshirts"
  },
  {
    "name": "comfortable tailored stretch men's overshirts",
    "slug": "comfortable-tailored-stretch-mens-overshirts"
  },
  {
    "name": "relaxed structured casual men's overshirts",
    "slug": "relaxed-structured-casual-mens-overshirts"
  },
  {
    "name": "classic fit tailored men's overshirts",
    "slug": "classic-fit-tailored-mens-overshirts"
  },
  {
    "name": "versatile lightweight tailored men's overshirts",
    "slug": "versatile-lightweight-tailored-mens-overshirts"
  },
  {
    "name": "stretch tailored casual men's overshirts",
    "slug": "stretch-tailored-casual-mens-overshirts"
  },
  {
    "name": "breathable flexible casual men's overshirts",
    "slug": "breathable-flexible-casual-mens-overshirts"
  },
  {
    "name": "modern structured casual men's overshirts",
    "slug": "modern-structured-casual-mens-overshirts"
  },
  {
    "name": "premium casual stretchable men's overshirts",
    "slug": "premium-casual-stretchable-mens-overshirts"
  },
  {
    "name": "structured and stylish men's overshirts",
    "slug": "structured-and-stylish-mens-overshirts"
  },
  {
    "name": "all-day comfortable tailored overshirts",
    "slug": "all-day-comfortable-tailored-overshirts"
  },
  {
    "name": "smart casual everyday men's overshirts",
    "slug": "smart-casual-everyday-mens-overshirts"
  },
  {
    "name": "lightweight breathable casual men's overshirts",
    "slug": "lightweight-breathable-casual-mens-overshirts"
  },
  {
    "name": "relaxed tailored fit men's overshirts",
    "slug": "relaxed-tailored-fit-mens-overshirts"
  },
  {
    "name": "modern tailored stretchable men's overshirts",
    "slug": "modern-tailored-stretchable-mens-overshirts"
  },
  {
    "name": "casual wear structured men's overshirts",
    "slug": "casual-wear-structured-mens-overshirts"
  },
  {
    "name": "everyday lightweight tailored men's overshirts",
    "slug": "everyday-lightweight-tailored-mens-overshirts"
  },
  {
    "name": "comfortable stretch casual men's overshirts",
    "slug": "comfortable-stretch-casual-mens-overshirts"
  },
  {
    "name": "premium tailored versatile men's overshirts",
    "slug": "premium-tailored-versatile-mens-overshirts"
  },
  {
    "name": "casual flexible lightweight men's overshirts",
    "slug": "casual-flexible-lightweight-mens-overshirts"
  },
  {
    "name": "structured breathable flexible men's overshirts",
    "slug": "structured-breathable-flexible-mens-overshirts"
  },
  {
    "name": "versatile tailored casual men's overshirts",
    "slug": "versatile-tailored-casual-mens-overshirts"
  },
  {
    "name": "fitted stretch casual men's overshirts",
    "slug": "fitted-stretch-casual-mens-overshirts"
  },
  {
    "name": "tailored breathable modern men's overshirts",
    "slug": "tailored-breathable-modern-mens-overshirts"
  },
  {
    "name": "relaxed modern fit men's overshirts",
    "slug": "relaxed-modern-fit-mens-overshirts"
  },
  {
    "name": "tailored everyday stretch men's overshirts",
    "slug": "tailored-everyday-stretch-mens-overshirts"
  },
  {
    "name": "smart structured casual men's overshirts",
    "slug": "smart-structured-casual-mens-overshirts"
  },
  {
    "name": "stylish stretch casual men's overshirts",
    "slug": "stylish-stretch-casual-mens-overshirts"
  },
  {
    "name": "breathable lightweight structured overshirts",
    "slug": "breathable-lightweight-structured-overshirts"
  },
  {
    "name": "versatile and durable men's overshirts",
    "slug": "versatile-and-durable-mens-overshirts"
  },
  {
    "name": "tailored flexible modern men's overshirts",
    "slug": "tailored-flexible-modern-mens-overshirts"
  },
  {
    "name": "casual smart tailored men's overshirts",
    "slug": "casual-smart-tailored-mens-overshirts"
  },
  {
    "name": "comfortable lightweight tailored men's overshirts",
    "slug": "comfortable-lightweight-tailored-mens-overshirts"
  },
  {
    "name": "premium stylish tailored men's overshirts",
    "slug": "premium-stylish-tailored-mens-overshirts"
  },
  {
    "name": "casual everyday structured men's overshirts",
    "slug": "casual-everyday-structured-mens-overshirts"
  },
  {
    "name": "tailored structured versatile men's overshirts",
    "slug": "tailored-structured-versatile-mens-overshirts"
  },
  {
    "name": "breathable casual structured men's overshirts",
    "slug": "breathable-casual-structured-mens-overshirts"
  },
  {
    "name": "everyday premium stretch men's overshirts",
    "slug": "everyday-premium-stretch-mens-overshirts"
  },
  {
    "name": "lightweight modern tailored men's overshirts",
    "slug": "lightweight-modern-tailored-mens-overshirts"
  },
  {
    "name": "flexible stylish casual men's overshirts",
    "slug": "flexible-stylish-casual-mens-overshirts"
  },
  {
    "name": "stretchable durable casual men's overshirts",
    "slug": "stretchable-durable-casual-mens-overshirts"
  },
  {
    "name": "classic tailored casual men's overshirts",
    "slug": "classic-tailored-casual-mens-overshirts"
  },
  {
    "name": "black men's sweaters",
    "slug": "black-mens-sweaters"
  },
  {
    "name": "beige men's sweaters",
    "slug": "beige-mens-sweaters"
  },
  {
    "name": "blue men's sweaters",
    "slug": "blue-mens-sweaters"
  },
  {
    "name": "grey men's sweaters",
    "slug": "grey-mens-sweaters"
  },
  {
    "name": "storm grey sweaters",
    "slug": "storm-grey-sweaters"
  },
  {
    "name": "red men's sweaters",
    "slug": "red-mens-sweaters"
  },
  {
    "name": "cordovan red sweaters",
    "slug": "cordovan-red-sweaters"
  },
  {
    "name": "black crewneck sweaters",
    "slug": "black-crewneck-sweaters"
  },
  {
    "name": "beige crewneck sweaters",
    "slug": "beige-crewneck-sweaters"
  },
  {
    "name": "blue crewneck sweaters",
    "slug": "blue-crewneck-sweaters"
  },
  {
    "name": "grey crewneck sweaters",
    "slug": "grey-crewneck-sweaters"
  },
  {
    "name": "storm grey crewneck",
    "slug": "storm-grey-crewneck"
  },
  {
    "name": "red crewneck sweaters",
    "slug": "red-crewneck-sweaters"
  },
  {
    "name": "cordovan red crewneck",
    "slug": "cordovan-red-crewneck"
  },
  {
    "name": "black half-zip sweaters",
    "slug": "black-half-zip-sweaters"
  },
  {
    "name": "beige half-zip sweaters",
    "slug": "beige-half-zip-sweaters"
  },
  {
    "name": "blue half-zip sweaters",
    "slug": "blue-half-zip-sweaters"
  },
  {
    "name": "grey half-zip sweaters",
    "slug": "grey-half-zip-sweaters"
  },
  {
    "name": "storm grey half-zip",
    "slug": "storm-grey-half-zip"
  },
  {
    "name": "red half-zip sweaters",
    "slug": "red-half-zip-sweaters"
  },
  {
    "name": "cordovan red half-zip",
    "slug": "cordovan-red-half-zip"
  },
  {
    "name": "black full-zip sweaters",
    "slug": "black-full-zip-sweaters"
  },
  {
    "name": "beige full-zip sweaters",
    "slug": "beige-full-zip-sweaters"
  },
  {
    "name": "blue full-zip sweaters",
    "slug": "blue-full-zip-sweaters"
  },
  {
    "name": "grey full-zip sweaters",
    "slug": "grey-full-zip-sweaters"
  },
  {
    "name": "storm grey full-zip",
    "slug": "storm-grey-full-zip"
  },
  {
    "name": "red full-zip sweaters",
    "slug": "red-full-zip-sweaters"
  },
  {
    "name": "cordovan red full-zip",
    "slug": "cordovan-red-full-zip"
  },
  {
    "name": "black knit sweaters",
    "slug": "black-knit-sweaters"
  },
  {
    "name": "beige knit sweaters",
    "slug": "beige-knit-sweaters"
  },
  {
    "name": "blue knit sweaters",
    "slug": "blue-knit-sweaters"
  },
  {
    "name": "grey knit sweaters",
    "slug": "grey-knit-sweaters"
  },
  {
    "name": "storm grey knit",
    "slug": "storm-grey-knit"
  },
  {
    "name": "red knit sweaters",
    "slug": "red-knit-sweaters"
  },
  {
    "name": "cordovan red knit",
    "slug": "cordovan-red-knit"
  },
  {
    "name": "black pullover sweaters",
    "slug": "black-pullover-sweaters"
  },
  {
    "name": "beige pullover sweaters",
    "slug": "beige-pullover-sweaters"
  },
  {
    "name": "blue pullover sweaters",
    "slug": "blue-pullover-sweaters"
  },
  {
    "name": "grey pullover sweaters",
    "slug": "grey-pullover-sweaters"
  },
  {
    "name": "storm grey pullover",
    "slug": "storm-grey-pullover"
  },
  {
    "name": "red pullover sweaters",
    "slug": "red-pullover-sweaters"
  },
  {
    "name": "cordovan red pullover",
    "slug": "cordovan-red-pullover"
  },
  {
    "name": "black zip-up sweaters",
    "slug": "black-zip-up-sweaters"
  },
  {
    "name": "beige zip-up sweaters",
    "slug": "beige-zip-up-sweaters"
  },
  {
    "name": "blue zip-up sweaters",
    "slug": "blue-zip-up-sweaters"
  },
  {
    "name": "grey zip-up sweaters",
    "slug": "grey-zip-up-sweaters"
  },
  {
    "name": "storm grey zip-up",
    "slug": "storm-grey-zip-up"
  },
  {
    "name": "red zip-up sweaters",
    "slug": "red-zip-up-sweaters"
  },
  {
    "name": "cordovan red zip-up",
    "slug": "cordovan-red-zip-up"
  },
  {
    "name": "black casual sweaters",
    "slug": "black-casual-sweaters"
  },
  {
    "name": "beige casual sweaters",
    "slug": "beige-casual-sweaters"
  },
  {
    "name": "blue casual sweaters",
    "slug": "blue-casual-sweaters"
  },
  {
    "name": "grey casual sweaters",
    "slug": "grey-casual-sweaters"
  },
  {
    "name": "storm grey casual",
    "slug": "storm-grey-casual"
  },
  {
    "name": "red casual sweaters",
    "slug": "red-casual-sweaters"
  },
  {
    "name": "cordovan red casual",
    "slug": "cordovan-red-casual"
  },
  {
    "name": "men's casual sweaters",
    "slug": "mens-casual-sweaters"
  },
  {
    "name": "tailored men's sweaters",
    "slug": "tailored-mens-sweaters"
  },
  {
    "name": "lightweight men's sweaters",
    "slug": "lightweight-mens-sweaters"
  },
  {
    "name": "breathable men's sweaters",
    "slug": "breathable-mens-sweaters"
  },
  {
    "name": "stretchable men's sweaters",
    "slug": "stretchable-mens-sweaters"
  },
  {
    "name": "comfortable men's sweaters",
    "slug": "comfortable-mens-sweaters"
  },
  {
    "name": "premium men's sweaters",
    "slug": "premium-mens-sweaters"
  },
  {
    "name": "classic men's sweaters",
    "slug": "classic-mens-sweaters"
  },
  {
    "name": "structured men's sweaters",
    "slug": "structured-mens-sweaters"
  },
  {
    "name": "stylish men's sweaters",
    "slug": "stylish-mens-sweaters"
  },
  {
    "name": "crewneck men's sweaters",
    "slug": "crewneck-mens-sweaters"
  },
  {
    "name": "half-zip men's sweaters",
    "slug": "half-zip-mens-sweaters"
  },
  {
    "name": "full-zip men's sweaters",
    "slug": "full-zip-mens-sweaters"
  },
  {
    "name": "knit men's sweaters",
    "slug": "knit-mens-sweaters"
  },
  {
    "name": "casual crewneck sweaters",
    "slug": "casual-crewneck-sweaters"
  },
  {
    "name": "tailored crewneck sweaters",
    "slug": "tailored-crewneck-sweaters"
  },
  {
    "name": "comfortable crewneck sweaters",
    "slug": "comfortable-crewneck-sweaters"
  },
  {
    "name": "lightweight crewneck sweaters",
    "slug": "lightweight-crewneck-sweaters"
  },
  {
    "name": "structured crewneck sweaters",
    "slug": "structured-crewneck-sweaters"
  },
  {
    "name": "stylish crewneck sweaters",
    "slug": "stylish-crewneck-sweaters"
  },
  {
    "name": "casual half-zip sweaters",
    "slug": "casual-half-zip-sweaters"
  },
  {
    "name": "tailored half-zip sweaters",
    "slug": "tailored-half-zip-sweaters"
  },
  {
    "name": "lightweight half-zip sweaters",
    "slug": "lightweight-half-zip-sweaters"
  },
  {
    "name": "structured half-zip sweaters",
    "slug": "structured-half-zip-sweaters"
  },
  {
    "name": "premium half-zip sweaters",
    "slug": "premium-half-zip-sweaters"
  },
  {
    "name": "casual full-zip sweaters",
    "slug": "casual-full-zip-sweaters"
  },
  {
    "name": "tailored full-zip sweaters",
    "slug": "tailored-full-zip-sweaters"
  },
  {
    "name": "structured full-zip sweaters",
    "slug": "structured-full-zip-sweaters"
  },
  {
    "name": "premium full-zip sweaters",
    "slug": "premium-full-zip-sweaters"
  },
  {
    "name": "breathable full-zip sweaters",
    "slug": "breathable-full-zip-sweaters"
  },
  {
    "name": "lightweight full-zip sweaters",
    "slug": "lightweight-full-zip-sweaters"
  },
  {
    "name": "knit crewneck sweaters",
    "slug": "knit-crewneck-sweaters"
  },
  {
    "name": "knit half-zip sweaters",
    "slug": "knit-half-zip-sweaters"
  },
  {
    "name": "knit full-zip sweaters",
    "slug": "knit-full-zip-sweaters"
  },
  {
    "name": "casual knit sweaters",
    "slug": "casual-knit-sweaters"
  },
  {
    "name": "comfortable knit sweaters",
    "slug": "comfortable-knit-sweaters"
  },
  {
    "name": "everyday men's sweaters",
    "slug": "everyday-mens-sweaters"
  },
  {
    "name": "stylish casual sweaters",
    "slug": "stylish-casual-sweaters"
  },
  {
    "name": "structured casual sweaters",
    "slug": "structured-casual-sweaters"
  },
  {
    "name": "premium knit sweaters",
    "slug": "premium-knit-sweaters"
  },
  {
    "name": "relaxed fit sweaters",
    "slug": "relaxed-fit-sweaters"
  },
  {
    "name": "modern men's sweaters",
    "slug": "modern-mens-sweaters"
  },
  {
    "name": "flexible men's sweaters",
    "slug": "flexible-mens-sweaters"
  },
  {
    "name": "everyday crewneck sweaters",
    "slug": "everyday-crewneck-sweaters"
  },
  {
    "name": "breathable casual sweaters",
    "slug": "breathable-casual-sweaters"
  },
  {
    "name": "versatile men's sweaters",
    "slug": "versatile-mens-sweaters"
  },
  {
    "name": "all-day men's sweaters",
    "slug": "all-day-mens-sweaters"
  },
  {
    "name": "stretch casual sweaters",
    "slug": "stretch-casual-sweaters"
  },
  {
    "name": "casual zip-up sweaters",
    "slug": "casual-zip-up-sweaters"
  },
  {
    "name": "tailored zip-up sweaters",
    "slug": "tailored-zip-up-sweaters"
  },
  {
    "name": "black men's tailored fit sweaters",
    "slug": "black-mens-tailored-fit-sweaters"
  },
  {
    "name": "beige men's tailored fit sweaters",
    "slug": "beige-mens-tailored-fit-sweaters"
  },
  {
    "name": "grey men's lightweight crewneck sweaters",
    "slug": "grey-mens-lightweight-crewneck-sweaters"
  },
  {
    "name": "storm grey half-zip men's sweaters",
    "slug": "storm-grey-half-zip-mens-sweaters"
  },
  {
    "name": "blue casual crewneck men's sweaters",
    "slug": "blue-casual-crewneck-mens-sweaters"
  },
  {
    "name": "red tailored fit men's sweaters",
    "slug": "red-tailored-fit-mens-sweaters"
  },
  {
    "name": "cordovan red lightweight zip-up sweaters",
    "slug": "cordovan-red-lightweight-zip-up-sweaters"
  },
  {
    "name": "black casual zip-up men's sweaters",
    "slug": "black-casual-zip-up-mens-sweaters"
  },
  {
    "name": "beige crewneck casual men's sweaters",
    "slug": "beige-crewneck-casual-mens-sweaters"
  },
  {
    "name": "grey breathable full-zip men's sweaters",
    "slug": "grey-breathable-full-zip-mens-sweaters"
  },
  {
    "name": "storm grey lightweight men's sweaters",
    "slug": "storm-grey-lightweight-mens-sweaters"
  },
  {
    "name": "red full-zip tailored men's sweaters",
    "slug": "red-full-zip-tailored-mens-sweaters"
  },
  {
    "name": "black comfortable crewneck men's sweaters",
    "slug": "black-comfortable-crewneck-mens-sweaters"
  },
  {
    "name": "blue classic half-zip men's sweaters",
    "slug": "blue-classic-half-zip-mens-sweaters"
  },
  {
    "name": "cordovan red breathable men's sweaters",
    "slug": "cordovan-red-breathable-mens-sweaters"
  },
  {
    "name": "beige stretch casual zip-up sweaters",
    "slug": "beige-stretch-casual-zip-up-sweaters"
  },
  {
    "name": "black stretch crewneck casual sweaters",
    "slug": "black-stretch-crewneck-casual-sweaters"
  },
  {
    "name": "grey relaxed fit men's sweaters",
    "slug": "grey-relaxed-fit-mens-sweaters"
  },
  {
    "name": "storm grey structured casual sweaters",
    "slug": "storm-grey-structured-casual-sweaters"
  },
  {
    "name": "blue casual everyday men's sweaters",
    "slug": "blue-casual-everyday-mens-sweaters"
  },
  {
    "name": "red tailored casual zip-up sweaters",
    "slug": "red-tailored-casual-zip-up-sweaters"
  },
  {
    "name": "cordovan red lightweight structured sweaters",
    "slug": "cordovan-red-lightweight-structured-sweaters"
  },
  {
    "name": "beige classic casual knit sweaters",
    "slug": "beige-classic-casual-knit-sweaters"
  },
  {
    "name": "black flexible casual zip-up sweaters",
    "slug": "black-flexible-casual-zip-up-sweaters"
  },
  {
    "name": "grey tailored lightweight men's sweaters",
    "slug": "grey-tailored-lightweight-mens-sweaters"
  },
  {
    "name": "storm grey comfortable casual sweaters",
    "slug": "storm-grey-comfortable-casual-sweaters"
  },
  {
    "name": "blue premium casual men's sweaters",
    "slug": "blue-premium-casual-mens-sweaters"
  },
  {
    "name": "red lightweight tailored casual sweaters",
    "slug": "red-lightweight-tailored-casual-sweaters"
  },
  {
    "name": "cordovan red classic casual sweaters",
    "slug": "cordovan-red-classic-casual-sweaters"
  },
  {
    "name": "black breathable casual crewneck sweaters",
    "slug": "black-breathable-casual-crewneck-sweaters"
  },
  {
    "name": "grey modern lightweight zip-up sweaters",
    "slug": "grey-modern-lightweight-zip-up-sweaters"
  },
  {
    "name": "blue everyday casual men's sweaters",
    "slug": "blue-everyday-casual-mens-sweaters"
  },
  {
    "name": "storm grey flexible lightweight sweaters",
    "slug": "storm-grey-flexible-lightweight-sweaters"
  },
  {
    "name": "red comfortable tailored men's sweaters",
    "slug": "red-comfortable-tailored-mens-sweaters"
  },
  {
    "name": "cordovan red stretchable zip-up sweaters",
    "slug": "cordovan-red-stretchable-zip-up-sweaters"
  },
  {
    "name": "beige structured tailored casual sweaters",
    "slug": "beige-structured-tailored-casual-sweaters"
  },
  {
    "name": "black modern stretch casual sweaters",
    "slug": "black-modern-stretch-casual-sweaters"
  },
  {
    "name": "grey classic tailored casual sweaters",
    "slug": "grey-classic-tailored-casual-sweaters"
  },
  {
    "name": "storm grey casual structured men's sweaters",
    "slug": "storm-grey-casual-structured-mens-sweaters"
  },
  {
    "name": "blue breathable casual crewneck sweaters",
    "slug": "blue-breathable-casual-crewneck-sweaters"
  },
  {
    "name": "red premium everyday men's sweaters",
    "slug": "red-premium-everyday-mens-sweaters"
  },
  {
    "name": "cordovan red stretch casual sweaters",
    "slug": "cordovan-red-stretch-casual-sweaters"
  },
  {
    "name": "beige lightweight tailored casual sweaters",
    "slug": "beige-lightweight-tailored-casual-sweaters"
  },
  {
    "name": "black relaxed fit casual sweaters",
    "slug": "black-relaxed-fit-casual-sweaters"
  },
  {
    "name": "blue structured casual men's sweaters",
    "slug": "blue-structured-casual-mens-sweaters"
  },
  {
    "name": "grey comfortable tailored fit sweaters",
    "slug": "grey-comfortable-tailored-fit-sweaters"
  },
  {
    "name": "storm grey classic casual zip-up sweaters",
    "slug": "storm-grey-classic-casual-zip-up-sweaters"
  },
  {
    "name": "red lightweight modern casual sweaters",
    "slug": "red-lightweight-modern-casual-sweaters"
  },
  {
    "name": "beige tailored stretch casual sweaters",
    "slug": "beige-tailored-stretch-casual-sweaters"
  },
  {
    "name": "cordovan red flexible casual sweaters",
    "slug": "cordovan-red-flexible-casual-sweaters"
  },
  {
    "name": "casual crewneck tailored men's sweaters",
    "slug": "casual-crewneck-tailored-mens-sweaters"
  },
  {
    "name": "lightweight and breathable men's sweaters",
    "slug": "lightweight-and-breathable-mens-sweaters"
  },
  {
    "name": "stretchable tailored casual men's sweaters",
    "slug": "stretchable-tailored-casual-mens-sweaters"
  },
  {
    "name": "comfortable and stylish men's sweaters",
    "slug": "comfortable-and-stylish-mens-sweaters"
  },
  {
    "name": "structured casual fit men's sweaters",
    "slug": "structured-casual-fit-mens-sweaters"
  },
  {
    "name": "all-day comfort men's sweaters",
    "slug": "all-day-comfort-mens-sweaters"
  },
  {
    "name": "relaxed fit tailored men's sweaters",
    "slug": "relaxed-fit-tailored-mens-sweaters"
  },
  {
    "name": "everyday casual tailored men's sweaters",
    "slug": "everyday-casual-tailored-mens-sweaters"
  },
  {
    "name": "modern structured casual men's sweaters",
    "slug": "modern-structured-casual-mens-sweaters"
  },
  {
    "name": "tailored fit crewneck men's sweaters",
    "slug": "tailored-fit-crewneck-mens-sweaters"
  },
  {
    "name": "premium lightweight casual men's sweaters",
    "slug": "premium-lightweight-casual-mens-sweaters"
  },
  {
    "name": "breathable and comfortable crewneck sweaters",
    "slug": "breathable-and-comfortable-crewneck-sweaters"
  },
  {
    "name": "stretch fit casual knit sweaters",
    "slug": "stretch-fit-casual-knit-sweaters"
  },
  {
    "name": "premium tailored casual men's sweaters",
    "slug": "premium-tailored-casual-mens-sweaters"
  },
  {
    "name": "structured and stylish men's sweaters",
    "slug": "structured-and-stylish-mens-sweaters"
  },
  {
    "name": "relaxed fit lightweight men's sweaters",
    "slug": "relaxed-fit-lightweight-mens-sweaters"
  },
  {
    "name": "flexible and durable men's sweaters",
    "slug": "flexible-and-durable-mens-sweaters"
  },
  {
    "name": "tailored fit stretch casual sweaters",
    "slug": "tailored-fit-stretch-casual-sweaters"
  },
  {
    "name": "lightweight knit casual men's sweaters",
    "slug": "lightweight-knit-casual-mens-sweaters"
  },
  {
    "name": "structured casual fit crewneck sweaters",
    "slug": "structured-casual-fit-crewneck-sweaters"
  },
  {
    "name": "tailored breathable casual full-zip sweaters",
    "slug": "tailored-breathable-casual-full-zip-sweaters"
  },
  {
    "name": "modern casual lightweight men's sweaters",
    "slug": "modern-casual-lightweight-mens-sweaters"
  },
  {
    "name": "stylish casual fit men's sweaters",
    "slug": "stylish-casual-fit-mens-sweaters"
  },
  {
    "name": "premium tailored fit casual sweaters",
    "slug": "premium-tailored-fit-casual-sweaters"
  },
  {
    "name": "versatile and breathable men's sweaters",
    "slug": "versatile-and-breathable-mens-sweaters"
  },
  {
    "name": "relaxed and comfortable casual sweaters",
    "slug": "relaxed-and-comfortable-casual-sweaters"
  },
  {
    "name": "structured knit casual men's sweaters",
    "slug": "structured-knit-casual-mens-sweaters"
  },
  {
    "name": "lightweight and flexible crewneck sweaters",
    "slug": "lightweight-and-flexible-crewneck-sweaters"
  },
  {
    "name": "tailored casual everyday men's sweaters",
    "slug": "tailored-casual-everyday-mens-sweaters"
  },
  {
    "name": "premium flexible structured men's sweaters",
    "slug": "premium-flexible-structured-mens-sweaters"
  },
  {
    "name": "casual lightweight tailored men's sweaters",
    "slug": "casual-lightweight-tailored-mens-sweaters"
  },
  {
    "name": "breathable all-day casual sweaters",
    "slug": "breathable-all-day-casual-sweaters"
  },
  {
    "name": "stylish stretch casual knit sweaters",
    "slug": "stylish-stretch-casual-knit-sweaters"
  },
  {
    "name": "relaxed fit knit casual sweaters",
    "slug": "relaxed-fit-knit-casual-sweaters"
  },
  {
    "name": "everyday tailored structured men's sweaters",
    "slug": "everyday-tailored-structured-mens-sweaters"
  },
  {
    "name": "premium knit casual crewneck sweaters",
    "slug": "premium-knit-casual-crewneck-sweaters"
  },
  {
    "name": "lightweight flexible tailored men's sweaters",
    "slug": "lightweight-flexible-tailored-mens-sweaters"
  },
  {
    "name": "tailored everyday lightweight men's sweaters",
    "slug": "tailored-everyday-lightweight-mens-sweaters"
  },
  {
    "name": "stylish premium tailored casual sweaters",
    "slug": "stylish-premium-tailored-casual-sweaters"
  },
  {
    "name": "breathable casual lightweight men's sweaters",
    "slug": "breathable-casual-lightweight-mens-sweaters"
  },
  {
    "name": "modern tailored everyday men's sweaters",
    "slug": "modern-tailored-everyday-mens-sweaters"
  },
  {
    "name": "comfortable casual structured men's sweaters",
    "slug": "comfortable-casual-structured-mens-sweaters"
  },
  {
    "name": "all-day relaxed casual men's sweaters",
    "slug": "all-day-relaxed-casual-mens-sweaters"
  },
  {
    "name": "lightweight stretchable tailored men's sweaters",
    "slug": "lightweight-stretchable-tailored-mens-sweaters"
  },
  {
    "name": "versatile structured casual knit sweaters",
    "slug": "versatile-structured-casual-knit-sweaters"
  },
  {
    "name": "breathable knit tailored casual sweaters",
    "slug": "breathable-knit-tailored-casual-sweaters"
  },
  {
    "name": "stretch fit all-day sweaters",
    "slug": "stretch-fit-all-day-sweaters"
  },
  {
    "name": "premium everyday casual men's sweaters",
    "slug": "premium-everyday-casual-mens-sweaters"
  },
  {
    "name": "tailored structured casual fit sweaters",
    "slug": "tailored-structured-casual-fit-sweaters"
  },
  {
    "name": "relaxed casual tailored knit sweaters",
    "slug": "relaxed-casual-tailored-knit-sweaters"
  },
  {
    "name": "black men's jackets",
    "slug": "black-mens-jackets"
  },
  {
    "name": "grey men's jackets",
    "slug": "grey-mens-jackets"
  },
  {
    "name": "charcoal grey jackets",
    "slug": "charcoal-grey-jackets"
  },
  {
    "name": "black bomber jackets",
    "slug": "black-bomber-jackets"
  },
  {
    "name": "grey bomber jackets",
    "slug": "grey-bomber-jackets"
  },
  {
    "name": "charcoal bomber jackets",
    "slug": "charcoal-bomber-jackets"
  },
  {
    "name": "lightweight black jackets",
    "slug": "lightweight-black-jackets"
  },
  {
    "name": "lightweight grey jackets",
    "slug": "lightweight-grey-jackets"
  },
  {
    "name": "charcoal lightweight jackets",
    "slug": "charcoal-lightweight-jackets"
  },
  {
    "name": "black slim jackets",
    "slug": "black-slim-jackets"
  },
  {
    "name": "grey slim jackets",
    "slug": "grey-slim-jackets"
  },
  {
    "name": "charcoal slim jackets",
    "slug": "charcoal-slim-jackets"
  },
  {
    "name": "black modern jackets",
    "slug": "black-modern-jackets"
  },
  {
    "name": "grey modern jackets",
    "slug": "grey-modern-jackets"
  },
  {
    "name": "charcoal modern jackets",
    "slug": "charcoal-modern-jackets"
  },
  {
    "name": "black puffer jackets",
    "slug": "black-puffer-jackets"
  },
  {
    "name": "grey puffer jackets",
    "slug": "grey-puffer-jackets"
  },
  {
    "name": "charcoal puffer jackets",
    "slug": "charcoal-puffer-jackets"
  },
  {
    "name": "black casual jackets",
    "slug": "black-casual-jackets"
  },
  {
    "name": "grey casual jackets",
    "slug": "grey-casual-jackets"
  },
  {
    "name": "charcoal casual jackets",
    "slug": "charcoal-casual-jackets"
  },
  {
    "name": "black stylish jackets",
    "slug": "black-stylish-jackets"
  },
  {
    "name": "grey stylish jackets",
    "slug": "grey-stylish-jackets"
  },
  {
    "name": "charcoal stylish jackets",
    "slug": "charcoal-stylish-jackets"
  },
  {
    "name": "water-repellent black jackets",
    "slug": "water-repellent-black-jackets"
  },
  {
    "name": "water-repellent grey jackets",
    "slug": "water-repellent-grey-jackets"
  },
  {
    "name": "charcoal windproof jackets",
    "slug": "charcoal-windproof-jackets"
  },
  {
    "name": "black city jackets",
    "slug": "black-city-jackets"
  },
  {
    "name": "grey city jackets",
    "slug": "grey-city-jackets"
  },
  {
    "name": "charcoal city jackets",
    "slug": "charcoal-city-jackets"
  },
  {
    "name": "black essential jackets",
    "slug": "black-essential-jackets"
  },
  {
    "name": "grey essential jackets",
    "slug": "grey-essential-jackets"
  },
  {
    "name": "charcoal essential jackets",
    "slug": "charcoal-essential-jackets"
  },
  {
    "name": "black breathable jackets",
    "slug": "black-breathable-jackets"
  },
  {
    "name": "grey breathable jackets",
    "slug": "grey-breathable-jackets"
  },
  {
    "name": "charcoal breathable jackets",
    "slug": "charcoal-breathable-jackets"
  },
  {
    "name": "black spring jackets",
    "slug": "black-spring-jackets"
  },
  {
    "name": "grey spring jackets",
    "slug": "grey-spring-jackets"
  },
  {
    "name": "charcoal spring jackets",
    "slug": "charcoal-spring-jackets"
  },
  {
    "name": "black seasonal jackets",
    "slug": "black-seasonal-jackets"
  },
  {
    "name": "grey seasonal jackets",
    "slug": "grey-seasonal-jackets"
  },
  {
    "name": "charcoal seasonal jackets",
    "slug": "charcoal-seasonal-jackets"
  },
  {
    "name": "black puffer bomber",
    "slug": "black-puffer-bomber"
  },
  {
    "name": "grey puffer bomber",
    "slug": "grey-puffer-bomber"
  },
  {
    "name": "charcoal lightweight puffer",
    "slug": "charcoal-lightweight-puffer"
  },
  {
    "name": "black windproof bomber",
    "slug": "black-windproof-bomber"
  },
  {
    "name": "grey windproof bomber",
    "slug": "grey-windproof-bomber"
  },
  {
    "name": "charcoal insulated jackets",
    "slug": "charcoal-insulated-jackets"
  },
  {
    "name": "black insulated jackets",
    "slug": "black-insulated-jackets"
  },
  {
    "name": "grey insulated jackets",
    "slug": "grey-insulated-jackets"
  },
  {
    "name": "men's modern jackets",
    "slug": "mens-modern-jackets"
  },
  {
    "name": "men's slim jackets",
    "slug": "mens-slim-jackets"
  },
  {
    "name": "stylish men's jackets",
    "slug": "stylish-mens-jackets"
  },
  {
    "name": "lightweight men's jackets",
    "slug": "lightweight-mens-jackets"
  },
  {
    "name": "breathable men's jackets",
    "slug": "breathable-mens-jackets"
  },
  {
    "name": "insulated men's jackets",
    "slug": "insulated-mens-jackets"
  },
  {
    "name": "slim bomber jackets",
    "slug": "slim-bomber-jackets"
  },
  {
    "name": "modern bomber jackets",
    "slug": "modern-bomber-jackets"
  },
  {
    "name": "lightweight bomber jackets",
    "slug": "lightweight-bomber-jackets"
  },
  {
    "name": "casual bomber jackets",
    "slug": "casual-bomber-jackets"
  },
  {
    "name": "tailored men's jackets",
    "slug": "tailored-mens-jackets"
  },
  {
    "name": "essential men's jackets",
    "slug": "essential-mens-jackets"
  },
  {
    "name": "seasonal men's jackets",
    "slug": "seasonal-mens-jackets"
  },
  {
    "name": "water-repellent jackets",
    "slug": "water-repellent-jackets"
  },
  {
    "name": "windproof men's jackets",
    "slug": "windproof-mens-jackets"
  },
  {
    "name": "insulated bomber jackets",
    "slug": "insulated-bomber-jackets"
  },
  {
    "name": "spring men's jackets",
    "slug": "spring-mens-jackets"
  },
  {
    "name": "sleek men's jackets",
    "slug": "sleek-mens-jackets"
  },
  {
    "name": "slim puffer jackets",
    "slug": "slim-puffer-jackets"
  },
  {
    "name": "modern puffer jackets",
    "slug": "modern-puffer-jackets"
  },
  {
    "name": "casual puffer jackets",
    "slug": "casual-puffer-jackets"
  },
  {
    "name": "breathable bomber jackets",
    "slug": "breathable-bomber-jackets"
  },
  {
    "name": "essential bomber jackets",
    "slug": "essential-bomber-jackets"
  },
  {
    "name": "comfortable men's jackets",
    "slug": "comfortable-mens-jackets"
  },
  {
    "name": "tailored bomber jackets",
    "slug": "tailored-bomber-jackets"
  },
  {
    "name": "stylish bomber jackets",
    "slug": "stylish-bomber-jackets"
  },
  {
    "name": "lightweight casual jackets",
    "slug": "lightweight-casual-jackets"
  },
  {
    "name": "slim fit jackets",
    "slug": "slim-fit-jackets"
  },
  {
    "name": "versatile men's jackets",
    "slug": "versatile-mens-jackets"
  },
  {
    "name": "everyday men's jackets",
    "slug": "everyday-mens-jackets"
  },
  {
    "name": "sleek modern jackets",
    "slug": "sleek-modern-jackets"
  },
  {
    "name": "classic men's jackets",
    "slug": "classic-mens-jackets"
  },
  {
    "name": "functional men's jackets",
    "slug": "functional-mens-jackets"
  },
  {
    "name": "warm men's jackets",
    "slug": "warm-mens-jackets"
  },
  {
    "name": "lightweight insulated jackets",
    "slug": "lightweight-insulated-jackets"
  },
  {
    "name": "casual seasonal jackets",
    "slug": "casual-seasonal-jackets"
  },
  {
    "name": "tailored slim jackets",
    "slug": "tailored-slim-jackets"
  },
  {
    "name": "men's stylish jackets",
    "slug": "mens-stylish-jackets"
  },
  {
    "name": "breathable seasonal jackets",
    "slug": "breathable-seasonal-jackets"
  },
  {
    "name": "sleek casual jackets",
    "slug": "sleek-casual-jackets"
  },
  {
    "name": "men's travel jackets",
    "slug": "mens-travel-jackets"
  },
  {
    "name": "performance men's jackets",
    "slug": "performance-mens-jackets"
  },
  {
    "name": "tailored puffer jackets",
    "slug": "tailored-puffer-jackets"
  },
  {
    "name": "windproof puffer jackets",
    "slug": "windproof-puffer-jackets"
  },
  {
    "name": "functional bomber jackets",
    "slug": "functional-bomber-jackets"
  },
  {
    "name": "sleek seasonal jackets",
    "slug": "sleek-seasonal-jackets"
  },
  {
    "name": "men's essential jackets",
    "slug": "mens-essential-jackets"
  },
  {
    "name": "slim casual jackets",
    "slug": "slim-casual-jackets"
  },
  {
    "name": "lightweight fitted jackets",
    "slug": "lightweight-fitted-jackets"
  },
  {
    "name": "tailored casual jackets",
    "slug": "tailored-casual-jackets"
  },
  {
    "name": "black slim fit bomber jackets",
    "slug": "black-slim-fit-bomber-jackets"
  },
  {
    "name": "grey slim fit bomber jackets",
    "slug": "grey-slim-fit-bomber-jackets"
  },
  {
    "name": "charcoal lightweight slim men's jackets",
    "slug": "charcoal-lightweight-slim-mens-jackets"
  },
  {
    "name": "black water-repellent casual jackets",
    "slug": "black-water-repellent-casual-jackets"
  },
  {
    "name": "grey water-repellent casual jackets",
    "slug": "grey-water-repellent-casual-jackets"
  },
  {
    "name": "charcoal windproof modern men's jackets",
    "slug": "charcoal-windproof-modern-mens-jackets"
  },
  {
    "name": "black breathable slim fit jackets",
    "slug": "black-breathable-slim-fit-jackets"
  },
  {
    "name": "grey breathable slim fit jackets",
    "slug": "grey-breathable-slim-fit-jackets"
  },
  {
    "name": "charcoal essential lightweight bomber jackets",
    "slug": "charcoal-essential-lightweight-bomber-jackets"
  },
  {
    "name": "black lightweight insulated men's jackets",
    "slug": "black-lightweight-insulated-mens-jackets"
  },
  {
    "name": "grey lightweight insulated men's jackets",
    "slug": "grey-lightweight-insulated-mens-jackets"
  },
  {
    "name": "charcoal stylish casual puffer jackets",
    "slug": "charcoal-stylish-casual-puffer-jackets"
  },
  {
    "name": "black city essential men's jackets",
    "slug": "black-city-essential-mens-jackets"
  },
  {
    "name": "grey city essential men's jackets",
    "slug": "grey-city-essential-mens-jackets"
  },
  {
    "name": "charcoal breathable slim fit jackets",
    "slug": "charcoal-breathable-slim-fit-jackets"
  },
  {
    "name": "black modern stylish bomber jackets",
    "slug": "black-modern-stylish-bomber-jackets"
  },
  {
    "name": "grey modern stylish bomber jackets",
    "slug": "grey-modern-stylish-bomber-jackets"
  },
  {
    "name": "charcoal slim fit casual jackets",
    "slug": "charcoal-slim-fit-casual-jackets"
  },
  {
    "name": "black lightweight water-repellent bomber jackets",
    "slug": "black-lightweight-water-repellent-bomber-jackets"
  },
  {
    "name": "grey lightweight water-repellent bomber jackets",
    "slug": "grey-lightweight-water-repellent-bomber-jackets"
  },
  {
    "name": "charcoal modern insulated puffer jackets",
    "slug": "charcoal-modern-insulated-puffer-jackets"
  },
  {
    "name": "black slim fit seasonal jackets",
    "slug": "black-slim-fit-seasonal-jackets"
  },
  {
    "name": "grey slim fit seasonal jackets",
    "slug": "grey-slim-fit-seasonal-jackets"
  },
  {
    "name": "charcoal essential windproof men's jackets",
    "slug": "charcoal-essential-windproof-mens-jackets"
  },
  {
    "name": "black breathable lightweight city jackets",
    "slug": "black-breathable-lightweight-city-jackets"
  },
  {
    "name": "grey breathable lightweight city jackets",
    "slug": "grey-breathable-lightweight-city-jackets"
  },
  {
    "name": "charcoal modern lightweight bomber jackets",
    "slug": "charcoal-modern-lightweight-bomber-jackets"
  },
  {
    "name": "black insulated seasonal men's jackets",
    "slug": "black-insulated-seasonal-mens-jackets"
  },
  {
    "name": "grey insulated seasonal men's jackets",
    "slug": "grey-insulated-seasonal-mens-jackets"
  },
  {
    "name": "charcoal water-repellent insulated bomber jackets",
    "slug": "charcoal-water-repellent-insulated-bomber-jackets"
  },
  {
    "name": "black sleek modern men's jackets",
    "slug": "black-sleek-modern-mens-jackets"
  },
  {
    "name": "grey sleek modern men's jackets",
    "slug": "grey-sleek-modern-mens-jackets"
  },
  {
    "name": "charcoal breathable stylish bomber jackets",
    "slug": "charcoal-breathable-stylish-bomber-jackets"
  },
  {
    "name": "black tailored lightweight casual jackets",
    "slug": "black-tailored-lightweight-casual-jackets"
  },
  {
    "name": "grey tailored lightweight casual jackets",
    "slug": "grey-tailored-lightweight-casual-jackets"
  },
  {
    "name": "charcoal tailored lightweight casual jackets",
    "slug": "charcoal-tailored-lightweight-casual-jackets"
  },
  {
    "name": "black slim fit city jackets",
    "slug": "black-slim-fit-city-jackets"
  },
  {
    "name": "grey slim fit city jackets",
    "slug": "grey-slim-fit-city-jackets"
  },
  {
    "name": "charcoal slim fit insulated jackets",
    "slug": "charcoal-slim-fit-insulated-jackets"
  },
  {
    "name": "black spring and summer jackets",
    "slug": "black-spring-and-summer-jackets"
  },
  {
    "name": "grey spring and summer jackets",
    "slug": "grey-spring-and-summer-jackets"
  },
  {
    "name": "charcoal breathable seasonal men's jackets",
    "slug": "charcoal-breathable-seasonal-mens-jackets"
  },
  {
    "name": "black stylish slim puffer jackets",
    "slug": "black-stylish-slim-puffer-jackets"
  },
  {
    "name": "grey stylish slim puffer jackets",
    "slug": "grey-stylish-slim-puffer-jackets"
  },
  {
    "name": "charcoal slim fit bomber jackets",
    "slug": "charcoal-slim-fit-bomber-jackets"
  },
  {
    "name": "black lightweight sleek men's jackets",
    "slug": "black-lightweight-sleek-mens-jackets"
  },
  {
    "name": "grey lightweight sleek men's jackets",
    "slug": "grey-lightweight-sleek-mens-jackets"
  },
  {
    "name": "charcoal lightweight stylish bomber jackets",
    "slug": "charcoal-lightweight-stylish-bomber-jackets"
  },
  {
    "name": "black windproof breathable men's jackets",
    "slug": "black-windproof-breathable-mens-jackets"
  },
  {
    "name": "grey windproof breathable men's jackets",
    "slug": "grey-windproof-breathable-mens-jackets"
  },
  {
    "name": "men's slim fit bomber jackets",
    "slug": "mens-slim-fit-bomber-jackets"
  },
  {
    "name": "stylish and lightweight men's jackets",
    "slug": "stylish-and-lightweight-mens-jackets"
  },
  {
    "name": "breathable slim fit bomber jackets",
    "slug": "breathable-slim-fit-bomber-jackets"
  },
  {
    "name": "tailored fit lightweight bomber jackets",
    "slug": "tailored-fit-lightweight-bomber-jackets"
  },
  {
    "name": "sleek casual slim men's jackets",
    "slug": "sleek-casual-slim-mens-jackets"
  },
  {
    "name": "tailored modern fit men's jackets",
    "slug": "tailored-modern-fit-mens-jackets"
  },
  {
    "name": "lightweight insulated bomber men's jackets",
    "slug": "lightweight-insulated-bomber-mens-jackets"
  },
  {
    "name": "breathable and tailored men's jackets",
    "slug": "breathable-and-tailored-mens-jackets"
  },
  {
    "name": "slim fit seasonal men's jackets",
    "slug": "slim-fit-seasonal-mens-jackets"
  },
  {
    "name": "casual slim fit bomber jackets",
    "slug": "casual-slim-fit-bomber-jackets"
  },
  {
    "name": "stylish tailored casual men's jackets",
    "slug": "stylish-tailored-casual-mens-jackets"
  },
  {
    "name": "water-repellent insulated men's jackets",
    "slug": "water-repellent-insulated-mens-jackets"
  },
  {
    "name": "versatile slim fit men's jackets",
    "slug": "versatile-slim-fit-mens-jackets"
  },
  {
    "name": "lightweight tailored casual bomber jackets",
    "slug": "lightweight-tailored-casual-bomber-jackets"
  },
  {
    "name": "breathable and comfortable men's jackets",
    "slug": "breathable-and-comfortable-mens-jackets"
  },
  {
    "name": "functional lightweight bomber men's jackets",
    "slug": "functional-lightweight-bomber-mens-jackets"
  },
  {
    "name": "slim fit insulated bomber jackets",
    "slug": "slim-fit-insulated-bomber-jackets"
  },
  {
    "name": "all-season slim men's jackets",
    "slug": "all-season-slim-mens-jackets"
  },
  {
    "name": "lightweight seasonal tailored men's jackets",
    "slug": "lightweight-seasonal-tailored-mens-jackets"
  },
  {
    "name": "modern functional casual men's jackets",
    "slug": "modern-functional-casual-mens-jackets"
  },
  {
    "name": "sleek and stylish men's jackets",
    "slug": "sleek-and-stylish-mens-jackets"
  },
  {
    "name": "everyday tailored fit men's jackets",
    "slug": "everyday-tailored-fit-mens-jackets"
  },
  {
    "name": "slim fit tailored bomber jackets",
    "slug": "slim-fit-tailored-bomber-jackets"
  },
  {
    "name": "insulated modern fit bomber jackets",
    "slug": "insulated-modern-fit-bomber-jackets"
  },
  {
    "name": "tailored fit seasonal men's jackets",
    "slug": "tailored-fit-seasonal-mens-jackets"
  },
  {
    "name": "versatile breathable bomber men's jackets",
    "slug": "versatile-breathable-bomber-mens-jackets"
  },
  {
    "name": "comfortable and stylish bomber jackets",
    "slug": "comfortable-and-stylish-bomber-jackets"
  },
  {
    "name": "sleek tailored modern men's jackets",
    "slug": "sleek-tailored-modern-mens-jackets"
  },
  {
    "name": "breathable lightweight essential bomber jackets",
    "slug": "breathable-lightweight-essential-bomber-jackets"
  },
  {
    "name": "tailored casual slim fit jackets",
    "slug": "tailored-casual-slim-fit-jackets"
  },
  {
    "name": "functional slim tailored men's jackets",
    "slug": "functional-slim-tailored-mens-jackets"
  },
  {
    "name": "insulated breathable modern men's jackets",
    "slug": "insulated-breathable-modern-mens-jackets"
  },
  {
    "name": "water-repellent seasonal tailored jackets",
    "slug": "water-repellent-seasonal-tailored-jackets"
  },
  {
    "name": "sleek modern tailored bomber jackets",
    "slug": "sleek-modern-tailored-bomber-jackets"
  },
  {
    "name": "slim fit functional bomber jackets",
    "slug": "slim-fit-functional-bomber-jackets"
  },
  {
    "name": "tailored slim lightweight men's jackets",
    "slug": "tailored-slim-lightweight-mens-jackets"
  },
  {
    "name": "breathable modern casual men's jackets",
    "slug": "breathable-modern-casual-mens-jackets"
  },
  {
    "name": "slim tailored casual bomber jackets",
    "slug": "slim-tailored-casual-bomber-jackets"
  },
  {
    "name": "all-season lightweight tailored men's jackets",
    "slug": "all-season-lightweight-tailored-mens-jackets"
  },
  {
    "name": "stylish slim functional bomber jackets",
    "slug": "stylish-slim-functional-bomber-jackets"
  },
  {
    "name": "sleek seasonal casual bomber jackets",
    "slug": "sleek-seasonal-casual-bomber-jackets"
  },
  {
    "name": "tailored breathable slim men's jackets",
    "slug": "tailored-breathable-slim-mens-jackets"
  },
  {
    "name": "lightweight comfortable casual men's jackets",
    "slug": "lightweight-comfortable-casual-mens-jackets"
  },
  {
    "name": "modern casual tailored men's jackets",
    "slug": "modern-casual-tailored-mens-jackets"
  },
  {
    "name": "functional seasonal slim fit jackets",
    "slug": "functional-seasonal-slim-fit-jackets"
  },
  {
    "name": "versatile breathable tailored men's jackets",
    "slug": "versatile-breathable-tailored-mens-jackets"
  },
  {
    "name": "slim modern casual bomber jackets",
    "slug": "slim-modern-casual-bomber-jackets"
  },
  {
    "name": "all-day tailored men's jackets",
    "slug": "all-day-tailored-mens-jackets"
  },
  {
    "name": "sleek and versatile bomber jackets",
    "slug": "sleek-and-versatile-bomber-jackets"
  },
  {
    "name": "slim tailored lightweight men's jackets",
    "slug": "slim-tailored-lightweight-mens-jackets"
  },
  {
    "name": "black men's trousers",
    "slug": "black-mens-trousers"
  },
  {
    "name": "deep stone trousers",
    "slug": "deep-stone-trousers"
  },
  {
    "name": "blue men's trousers",
    "slug": "blue-mens-trousers"
  },
  {
    "name": "dark blue trousers",
    "slug": "dark-blue-trousers"
  },
  {
    "name": "navy blue trousers",
    "slug": "navy-blue-trousers"
  },
  {
    "name": "grey men's trousers",
    "slug": "grey-mens-trousers"
  },
  {
    "name": "light grey trousers",
    "slug": "light-grey-trousers"
  },
  {
    "name": "pearl grey trousers",
    "slug": "pearl-grey-trousers"
  },
  {
    "name": "dark grey trousers",
    "slug": "dark-grey-trousers"
  },
  {
    "name": "green men's trousers",
    "slug": "green-mens-trousers"
  },
  {
    "name": "olive green trousers",
    "slug": "olive-green-trousers"
  },
  {
    "name": "ivory men's trousers",
    "slug": "ivory-mens-trousers"
  },
  {
    "name": "cream men's trousers",
    "slug": "cream-mens-trousers"
  },
  {
    "name": "black slim trousers",
    "slug": "black-slim-trousers"
  },
  {
    "name": "grey slim trousers",
    "slug": "grey-slim-trousers"
  },
  {
    "name": "navy slim trousers",
    "slug": "navy-slim-trousers"
  },
  {
    "name": "green slim trousers",
    "slug": "green-slim-trousers"
  },
  {
    "name": "blue slim trousers",
    "slug": "blue-slim-trousers"
  },
  {
    "name": "light grey trousers",
    "slug": "light-grey-trousers"
  },
  {
    "name": "dark blue trousers",
    "slug": "dark-blue-trousers"
  },
  {
    "name": "deep stone trousers",
    "slug": "deep-stone-trousers"
  },
  {
    "name": "black tapered trousers",
    "slug": "black-tapered-trousers"
  },
  {
    "name": "grey tapered trousers",
    "slug": "grey-tapered-trousers"
  },
  {
    "name": "navy tapered trousers",
    "slug": "navy-tapered-trousers"
  },
  {
    "name": "olive green trousers",
    "slug": "olive-green-trousers"
  },
  {
    "name": "pearl grey trousers",
    "slug": "pearl-grey-trousers"
  },
  {
    "name": "tailored black trousers",
    "slug": "tailored-black-trousers"
  },
  {
    "name": "tailored grey trousers",
    "slug": "tailored-grey-trousers"
  },
  {
    "name": "tailored navy trousers",
    "slug": "tailored-navy-trousers"
  },
  {
    "name": "black modern trousers",
    "slug": "black-modern-trousers"
  },
  {
    "name": "navy modern trousers",
    "slug": "navy-modern-trousers"
  },
  {
    "name": "grey modern trousers",
    "slug": "grey-modern-trousers"
  },
  {
    "name": "dark grey trousers",
    "slug": "dark-grey-trousers"
  },
  {
    "name": "green tapered trousers",
    "slug": "green-tapered-trousers"
  },
  {
    "name": "black casual trousers",
    "slug": "black-casual-trousers"
  },
  {
    "name": "navy casual trousers",
    "slug": "navy-casual-trousers"
  },
  {
    "name": "blue casual trousers",
    "slug": "blue-casual-trousers"
  },
  {
    "name": "charcoal grey trousers",
    "slug": "charcoal-grey-trousers"
  },
  {
    "name": "navy casual trousers",
    "slug": "navy-casual-trousers"
  },
  {
    "name": "grey casual trousers",
    "slug": "grey-casual-trousers"
  },
  {
    "name": "black casual trousers",
    "slug": "black-casual-trousers"
  },
  {
    "name": "deep stone trousers",
    "slug": "deep-stone-trousers"
  },
  {
    "name": "pearl grey trousers",
    "slug": "pearl-grey-trousers"
  },
  {
    "name": "olive casual trousers",
    "slug": "olive-casual-trousers"
  },
  {
    "name": "black dress trousers",
    "slug": "black-dress-trousers"
  },
  {
    "name": "grey dress trousers",
    "slug": "grey-dress-trousers"
  },
  {
    "name": "navy dress trousers",
    "slug": "navy-dress-trousers"
  },
  {
    "name": "green tailored trousers",
    "slug": "green-tailored-trousers"
  },
  {
    "name": "ivory casual trousers",
    "slug": "ivory-casual-trousers"
  },
  {
    "name": "cream tailored trousers",
    "slug": "cream-tailored-trousers"
  },
  {
    "name": "men's slim trousers",
    "slug": "mens-slim-trousers"
  },
  {
    "name": "tailored men's trousers",
    "slug": "tailored-mens-trousers"
  },
  {
    "name": "modern men's trousers",
    "slug": "modern-mens-trousers"
  },
  {
    "name": "casual men's trousers",
    "slug": "casual-mens-trousers"
  },
  {
    "name": "stretchable men's trousers",
    "slug": "stretchable-mens-trousers"
  },
  {
    "name": "comfortable men's trousers",
    "slug": "comfortable-mens-trousers"
  },
  {
    "name": "slim tapered trousers",
    "slug": "slim-tapered-trousers"
  },
  {
    "name": "versatile men's trousers",
    "slug": "versatile-mens-trousers"
  },
  {
    "name": "wrinkle-free trousers",
    "slug": "wrinkle-free-trousers"
  },
  {
    "name": "water-resistant trousers",
    "slug": "water-resistant-trousers"
  },
  {
    "name": "tailored slim trousers",
    "slug": "tailored-slim-trousers"
  },
  {
    "name": "flexible fit trousers",
    "slug": "flexible-fit-trousers"
  },
  {
    "name": "travel-friendly trousers",
    "slug": "travel-friendly-trousers"
  },
  {
    "name": "slim ankle trousers",
    "slug": "slim-ankle-trousers"
  },
  {
    "name": "breathable men's trousers",
    "slug": "breathable-mens-trousers"
  },
  {
    "name": "stylish men's trousers",
    "slug": "stylish-mens-trousers"
  },
  {
    "name": "tapered fit trousers",
    "slug": "tapered-fit-trousers"
  },
  {
    "name": "polished men's trousers",
    "slug": "polished-mens-trousers"
  },
  {
    "name": "packable men's trousers",
    "slug": "packable-mens-trousers"
  },
  {
    "name": "sleek fit trousers",
    "slug": "sleek-fit-trousers"
  },
  {
    "name": "premium men's trousers",
    "slug": "premium-mens-trousers"
  },
  {
    "name": "smart casual trousers",
    "slug": "smart-casual-trousers"
  },
  {
    "name": "lightweight slim trousers",
    "slug": "lightweight-slim-trousers"
  },
  {
    "name": "relaxed fit trousers",
    "slug": "relaxed-fit-trousers"
  },
  {
    "name": "athletic fit trousers",
    "slug": "athletic-fit-trousers"
  },
  {
    "name": "tailored tapered trousers",
    "slug": "tailored-tapered-trousers"
  },
  {
    "name": "slim travel trousers",
    "slug": "slim-travel-trousers"
  },
  {
    "name": "casual tailored trousers",
    "slug": "casual-tailored-trousers"
  },
  {
    "name": "fitted slim trousers",
    "slug": "fitted-slim-trousers"
  },
  {
    "name": "modern tailored trousers",
    "slug": "modern-tailored-trousers"
  },
  {
    "name": "slim fit trousers",
    "slug": "slim-fit-trousers"
  },
  {
    "name": "everyday men's trousers",
    "slug": "everyday-mens-trousers"
  },
  {
    "name": "breathable slim trousers",
    "slug": "breathable-slim-trousers"
  },
  {
    "name": "stretch fabric trousers",
    "slug": "stretch-fabric-trousers"
  },
  {
    "name": "polished slim trousers",
    "slug": "polished-slim-trousers"
  },
  {
    "name": "essential men's trousers",
    "slug": "essential-mens-trousers"
  },
  {
    "name": "comfortable slim trousers",
    "slug": "comfortable-slim-trousers"
  },
  {
    "name": "versatile slim trousers",
    "slug": "versatile-slim-trousers"
  },
  {
    "name": "modern slim trousers",
    "slug": "modern-slim-trousers"
  },
  {
    "name": "wrinkle-resistant trousers",
    "slug": "wrinkle-resistant-trousers"
  },
  {
    "name": "flexible slim trousers",
    "slug": "flexible-slim-trousers"
  },
  {
    "name": "relaxed tailored trousers",
    "slug": "relaxed-tailored-trousers"
  },
  {
    "name": "performance slim trousers",
    "slug": "performance-slim-trousers"
  },
  {
    "name": "technical fabric trousers",
    "slug": "technical-fabric-trousers"
  },
  {
    "name": "packable slim trousers",
    "slug": "packable-slim-trousers"
  },
  {
    "name": "sleek modern trousers",
    "slug": "sleek-modern-trousers"
  },
  {
    "name": "tailored casual trousers",
    "slug": "tailored-casual-trousers"
  },
  {
    "name": "durable slim trousers",
    "slug": "durable-slim-trousers"
  },
  {
    "name": "breathable tapered trousers",
    "slug": "breathable-tapered-trousers"
  },
  {
    "name": "stylish slim trousers",
    "slug": "stylish-slim-trousers"
  },
  {
    "name": "black tailored slim fit trousers",
    "slug": "black-tailored-slim-fit-trousers"
  },
  {
    "name": "navy modern tapered ankle trousers",
    "slug": "navy-modern-tapered-ankle-trousers"
  },
  {
    "name": "grey stretchable slim fit trousers",
    "slug": "grey-stretchable-slim-fit-trousers"
  },
  {
    "name": "green slim tapered ankle trousers",
    "slug": "green-slim-tapered-ankle-trousers"
  },
  {
    "name": "pearl grey modern slim trousers",
    "slug": "pearl-grey-modern-slim-trousers"
  },
  {
    "name": "navy wrinkle-free travel trousers",
    "slug": "navy-wrinkle-free-travel-trousers"
  },
  {
    "name": "olive green tailored fit trousers",
    "slug": "olive-green-tailored-fit-trousers"
  },
  {
    "name": "light grey tapered slim trousers",
    "slug": "light-grey-tapered-slim-trousers"
  },
  {
    "name": "dark blue slim fit trousers",
    "slug": "dark-blue-slim-fit-trousers"
  },
  {
    "name": "navy casual stretchable slim trousers",
    "slug": "navy-casual-stretchable-slim-trousers"
  },
  {
    "name": "charcoal grey wrinkle-free trousers",
    "slug": "charcoal-grey-wrinkle-free-trousers"
  },
  {
    "name": "black water-resistant casual trousers",
    "slug": "black-water-resistant-casual-trousers"
  },
  {
    "name": "green modern tapered ankle trousers",
    "slug": "green-modern-tapered-ankle-trousers"
  },
  {
    "name": "tailored slim ivory men's trousers",
    "slug": "tailored-slim-ivory-mens-trousers"
  },
  {
    "name": "cream modern slim ankle trousers",
    "slug": "cream-modern-slim-ankle-trousers"
  },
  {
    "name": "deep stone tailored fit trousers",
    "slug": "deep-stone-tailored-fit-trousers"
  },
  {
    "name": "blue breathable tapered slim trousers",
    "slug": "blue-breathable-tapered-slim-trousers"
  },
  {
    "name": "pearl grey tailored men's trousers",
    "slug": "pearl-grey-tailored-mens-trousers"
  },
  {
    "name": "black polished modern fit trousers",
    "slug": "black-polished-modern-fit-trousers"
  },
  {
    "name": "grey casual stretch fit trousers",
    "slug": "grey-casual-stretch-fit-trousers"
  },
  {
    "name": "navy blue wrinkle-resistant trousers",
    "slug": "navy-blue-wrinkle-resistant-trousers"
  },
  {
    "name": "dark grey tailored slim trousers",
    "slug": "dark-grey-tailored-slim-trousers"
  },
  {
    "name": "navy blue lightweight men's trousers",
    "slug": "navy-blue-lightweight-mens-trousers"
  },
  {
    "name": "light grey stretchable slim trousers",
    "slug": "light-grey-stretchable-slim-trousers"
  },
  {
    "name": "olive green breathable slim trousers",
    "slug": "olive-green-breathable-slim-trousers"
  },
  {
    "name": "green tailored stretchable ankle trousers",
    "slug": "green-tailored-stretchable-ankle-trousers"
  },
  {
    "name": "ivory modern fit men's trousers",
    "slug": "ivory-modern-fit-mens-trousers"
  },
  {
    "name": "dark grey tailored fit trousers",
    "slug": "dark-grey-tailored-fit-trousers"
  },
  {
    "name": "black lightweight tailored men's trousers",
    "slug": "black-lightweight-tailored-mens-trousers"
  },
  {
    "name": "tailored slim cream men's trousers",
    "slug": "tailored-slim-cream-mens-trousers"
  },
  {
    "name": "navy wrinkle-resistant slim trousers",
    "slug": "navy-wrinkle-resistant-slim-trousers"
  },
  {
    "name": "dark blue casual fit trousers",
    "slug": "dark-blue-casual-fit-trousers"
  },
  {
    "name": "green polished tailored trousers",
    "slug": "green-polished-tailored-trousers"
  },
  {
    "name": "pearl grey casual slim trousers",
    "slug": "pearl-grey-casual-slim-trousers"
  },
  {
    "name": "olive wrinkle-resistant tailored trousers",
    "slug": "olive-wrinkle-resistant-tailored-trousers"
  },
  {
    "name": "navy casual tailored fit trousers",
    "slug": "navy-casual-tailored-fit-trousers"
  },
  {
    "name": "light grey breathable slim trousers",
    "slug": "light-grey-breathable-slim-trousers"
  },
  {
    "name": "black athletic slim fit trousers",
    "slug": "black-athletic-slim-fit-trousers"
  },
  {
    "name": "tailored polished cream men's trousers",
    "slug": "tailored-polished-cream-mens-trousers"
  },
  {
    "name": "green lightweight casual slim trousers",
    "slug": "green-lightweight-casual-slim-trousers"
  },
  {
    "name": "black tapered casual slim trousers",
    "slug": "black-tapered-casual-slim-trousers"
  },
  {
    "name": "dark grey casual tapered trousers",
    "slug": "dark-grey-casual-tapered-trousers"
  },
  {
    "name": "navy blue tailored fit trousers",
    "slug": "navy-blue-tailored-fit-trousers"
  },
  {
    "name": "deep stone wrinkle-resistant trousers",
    "slug": "deep-stone-wrinkle-resistant-trousers"
  },
  {
    "name": "pearl grey lightweight men's trousers",
    "slug": "pearl-grey-lightweight-mens-trousers"
  },
  {
    "name": "tailored olive green men's trousers",
    "slug": "tailored-olive-green-mens-trousers"
  },
  {
    "name": "black polished slim fit trousers",
    "slug": "black-polished-slim-fit-trousers"
  },
  {
    "name": "grey stretchable casual fit trousers",
    "slug": "grey-stretchable-casual-fit-trousers"
  },
  {
    "name": "navy modern slim tailored trousers",
    "slug": "navy-modern-slim-tailored-trousers"
  },
  {
    "name": "dark blue stretch tailored trousers",
    "slug": "dark-blue-stretch-tailored-trousers"
  },
  {
    "name": "tailored slim fit men's trousers",
    "slug": "tailored-slim-fit-mens-trousers"
  },
  {
    "name": "modern tapered ankle fit trousers",
    "slug": "modern-tapered-ankle-fit-trousers"
  },
  {
    "name": "breathable stretch slim fit trousers",
    "slug": "breathable-stretch-slim-fit-trousers"
  },
  {
    "name": "comfortable tailored slim fit trousers",
    "slug": "comfortable-tailored-slim-fit-trousers"
  },
  {
    "name": "polished modern tailored men's trousers",
    "slug": "polished-modern-tailored-mens-trousers"
  },
  {
    "name": "lightweight and flexible men's trousers",
    "slug": "lightweight-and-flexible-mens-trousers"
  },
  {
    "name": "wrinkle-free casual slim trousers",
    "slug": "wrinkle-free-casual-slim-trousers"
  },
  {
    "name": "tailored slim tapered ankle trousers",
    "slug": "tailored-slim-tapered-ankle-trousers"
  },
  {
    "name": "travel-friendly slim fit trousers",
    "slug": "travel-friendly-slim-fit-trousers"
  },
  {
    "name": "comfortable casual slim men's trousers",
    "slug": "comfortable-casual-slim-mens-trousers"
  },
  {
    "name": "modern tailored stretchable men's trousers",
    "slug": "modern-tailored-stretchable-mens-trousers"
  },
  {
    "name": "versatile tailored casual men's trousers",
    "slug": "versatile-tailored-casual-mens-trousers"
  },
  {
    "name": "flexible and durable men's trousers",
    "slug": "flexible-and-durable-mens-trousers"
  },
  {
    "name": "wrinkle-resistant tailored slim trousers",
    "slug": "wrinkle-resistant-tailored-slim-trousers"
  },
  {
    "name": "lightweight travel-friendly slim trousers",
    "slug": "lightweight-travel-friendly-slim-trousers"
  },
  {
    "name": "packable slim fit men's trousers",
    "slug": "packable-slim-fit-mens-trousers"
  },
  {
    "name": "polished tailored slim fit trousers",
    "slug": "polished-tailored-slim-fit-trousers"
  },
  {
    "name": "slim tapered tailored men's trousers",
    "slug": "slim-tapered-tailored-mens-trousers"
  },
  {
    "name": "breathable casual tailored fit trousers",
    "slug": "breathable-casual-tailored-fit-trousers"
  },
  {
    "name": "wrinkle-resistant slim tailored trousers",
    "slug": "wrinkle-resistant-slim-tailored-trousers"
  },
  {
    "name": "everyday stretch tailored men's trousers",
    "slug": "everyday-stretch-tailored-mens-trousers"
  },
  {
    "name": "breathable slim tailored men's trousers",
    "slug": "breathable-slim-tailored-mens-trousers"
  },
  {
    "name": "tailored casual flexible men's trousers",
    "slug": "tailored-casual-flexible-mens-trousers"
  },
  {
    "name": "relaxed slim tapered fit trousers",
    "slug": "relaxed-slim-tapered-fit-trousers"
  },
  {
    "name": "comfortable stretch tapered slim trousers",
    "slug": "comfortable-stretch-tapered-slim-trousers"
  },
  {
    "name": "wrinkle-resistant tailored casual trousers",
    "slug": "wrinkle-resistant-tailored-casual-trousers"
  },
  {
    "name": "modern slim stretch tailored trousers",
    "slug": "modern-slim-stretch-tailored-trousers"
  },
  {
    "name": "flexible lightweight slim fit trousers",
    "slug": "flexible-lightweight-slim-fit-trousers"
  },
  {
    "name": "sleek tailored casual men's trousers",
    "slug": "sleek-tailored-casual-mens-trousers"
  },
  {
    "name": "performance stretch slim fit trousers",
    "slug": "performance-stretch-slim-fit-trousers"
  },
  {
    "name": "slim fit wrinkle-free trousers",
    "slug": "slim-fit-wrinkle-free-trousers"
  },
  {
    "name": "packable tailored slim fit trousers",
    "slug": "packable-tailored-slim-fit-trousers"
  },
  {
    "name": "polished lightweight tailored men's trousers",
    "slug": "polished-lightweight-tailored-mens-trousers"
  },
  {
    "name": "comfortable flexible slim fit trousers",
    "slug": "comfortable-flexible-slim-fit-trousers"
  },
  {
    "name": "stretch casual tailored men's trousers",
    "slug": "stretch-casual-tailored-mens-trousers"
  },
  {
    "name": "modern versatile slim fit trousers",
    "slug": "modern-versatile-slim-fit-trousers"
  },
  {
    "name": "tailored casual wrinkle-free trousers",
    "slug": "tailored-casual-wrinkle-free-trousers"
  },
  {
    "name": "breathable lightweight casual trousers",
    "slug": "breathable-lightweight-casual-trousers"
  },
  {
    "name": "travel-ready tailored men's trousers",
    "slug": "travel-ready-tailored-mens-trousers"
  },
  {
    "name": "technical fabric slim fit trousers",
    "slug": "technical-fabric-slim-fit-trousers"
  },
  {
    "name": "versatile wrinkle-free men's trousers",
    "slug": "versatile-wrinkle-free-mens-trousers"
  },
  {
    "name": "tailored modern polished men's trousers",
    "slug": "tailored-modern-polished-mens-trousers"
  },
  {
    "name": "slim fit breathable casual trousers",
    "slug": "slim-fit-breathable-casual-trousers"
  },
  {
    "name": "sleek tailored versatile men's trousers",
    "slug": "sleek-tailored-versatile-mens-trousers"
  },
  {
    "name": "relaxed tailored casual slim trousers",
    "slug": "relaxed-tailored-casual-slim-trousers"
  },
  {
    "name": "everyday slim stretch tailored trousers",
    "slug": "everyday-slim-stretch-tailored-trousers"
  },
  {
    "name": "lightweight technical fabric men's trousers",
    "slug": "lightweight-technical-fabric-mens-trousers"
  },
  {
    "name": "wrinkle-free flexible slim trousers",
    "slug": "wrinkle-free-flexible-slim-trousers"
  },
  {
    "name": "tailored slim relaxed fit trousers",
    "slug": "tailored-slim-relaxed-fit-trousers"
  },
  {
    "name": "stretch breathable tailored men's trousers",
    "slug": "stretch-breathable-tailored-mens-trousers"
  },
  {
    "name": "blue denim jeans",
    "slug": "blue-denim-jeans"
  },
  {
    "name": "pale blue jeans",
    "slug": "pale-blue-jeans"
  },
  {
    "name": "navy blue jeans",
    "slug": "navy-blue-jeans"
  },
  {
    "name": "light blue jeans",
    "slug": "light-blue-jeans"
  },
  {
    "name": "grey denim jeans",
    "slug": "grey-denim-jeans"
  },
  {
    "name": "dark grey jeans",
    "slug": "dark-grey-jeans"
  },
  {
    "name": "black denim jeans",
    "slug": "black-denim-jeans"
  },
  {
    "name": "black slim jeans",
    "slug": "black-slim-jeans"
  },
  {
    "name": "blue slim jeans",
    "slug": "blue-slim-jeans"
  },
  {
    "name": "navy slim jeans",
    "slug": "navy-slim-jeans"
  },
  {
    "name": "grey slim jeans",
    "slug": "grey-slim-jeans"
  },
  {
    "name": "dark grey jeans",
    "slug": "dark-grey-jeans"
  },
  {
    "name": "light blue denim",
    "slug": "light-blue-denim"
  },
  {
    "name": "pale blue denim",
    "slug": "pale-blue-denim"
  },
  {
    "name": "navy blue denim",
    "slug": "navy-blue-denim"
  },
  {
    "name": "blue tapered jeans",
    "slug": "blue-tapered-jeans"
  },
  {
    "name": "grey tapered jeans",
    "slug": "grey-tapered-jeans"
  },
  {
    "name": "black tapered jeans",
    "slug": "black-tapered-jeans"
  },
  {
    "name": "navy tapered jeans",
    "slug": "navy-tapered-jeans"
  },
  {
    "name": "dark grey denim",
    "slug": "dark-grey-denim"
  },
  {
    "name": "light grey jeans",
    "slug": "light-grey-jeans"
  },
  {
    "name": "blue stretch jeans",
    "slug": "blue-stretch-jeans"
  },
  {
    "name": "black stretch jeans",
    "slug": "black-stretch-jeans"
  },
  {
    "name": "grey stretch jeans",
    "slug": "grey-stretch-jeans"
  },
  {
    "name": "navy stretch jeans",
    "slug": "navy-stretch-jeans"
  },
  {
    "name": "pale tapered jeans",
    "slug": "pale-tapered-jeans"
  },
  {
    "name": "light tapered jeans",
    "slug": "light-tapered-jeans"
  },
  {
    "name": "blue classic jeans",
    "slug": "blue-classic-jeans"
  },
  {
    "name": "black classic jeans",
    "slug": "black-classic-jeans"
  },
  {
    "name": "navy classic jeans",
    "slug": "navy-classic-jeans"
  },
  {
    "name": "pale blue stretch",
    "slug": "pale-blue-stretch"
  },
  {
    "name": "grey casual jeans",
    "slug": "grey-casual-jeans"
  },
  {
    "name": "navy casual jeans",
    "slug": "navy-casual-jeans"
  },
  {
    "name": "light casual jeans",
    "slug": "light-casual-jeans"
  },
  {
    "name": "dark grey stretch",
    "slug": "dark-grey-stretch"
  },
  {
    "name": "black casual jeans",
    "slug": "black-casual-jeans"
  },
  {
    "name": "light stretch denim",
    "slug": "light-stretch-denim"
  },
  {
    "name": "navy premium jeans",
    "slug": "navy-premium-jeans"
  },
  {
    "name": "blue branded jeans",
    "slug": "blue-branded-jeans"
  },
  {
    "name": "black branded jeans",
    "slug": "black-branded-jeans"
  },
  {
    "name": "grey branded jeans",
    "slug": "grey-branded-jeans"
  },
  {
    "name": "navy versatile jeans",
    "slug": "navy-versatile-jeans"
  },
  {
    "name": "pale tailored jeans",
    "slug": "pale-tailored-jeans"
  },
  {
    "name": "light tailored jeans",
    "slug": "light-tailored-jeans"
  },
  {
    "name": "black tailored jeans",
    "slug": "black-tailored-jeans"
  },
  {
    "name": "grey tailored jeans",
    "slug": "grey-tailored-jeans"
  },
  {
    "name": "blue tailored jeans",
    "slug": "blue-tailored-jeans"
  },
  {
    "name": "dark grey tapered",
    "slug": "dark-grey-tapered"
  },
  {
    "name": "pale blue slim",
    "slug": "pale-blue-slim"
  },
  {
    "name": "light blue tapered",
    "slug": "light-blue-tapered"
  },
  {
    "name": "men's slim jeans",
    "slug": "mens-slim-jeans"
  },
  {
    "name": "tapered fit jeans",
    "slug": "tapered-fit-jeans"
  },
  {
    "name": "stretch denim jeans",
    "slug": "stretch-denim-jeans"
  },
  {
    "name": "comfortable men's jeans",
    "slug": "comfortable-mens-jeans"
  },
  {
    "name": "stylish denim jeans",
    "slug": "stylish-denim-jeans"
  },
  {
    "name": "modern slim jeans",
    "slug": "modern-slim-jeans"
  },
  {
    "name": "versatile denim jeans",
    "slug": "versatile-denim-jeans"
  },
  {
    "name": "casual slim jeans",
    "slug": "casual-slim-jeans"
  },
  {
    "name": "lightweight denim jeans",
    "slug": "lightweight-denim-jeans"
  },
  {
    "name": "premium men's jeans",
    "slug": "premium-mens-jeans"
  },
  {
    "name": "tailored fit jeans",
    "slug": "tailored-fit-jeans"
  },
  {
    "name": "breathable denim jeans",
    "slug": "breathable-denim-jeans"
  },
  {
    "name": "flexible fit jeans",
    "slug": "flexible-fit-jeans"
  },
  {
    "name": "branded men's jeans",
    "slug": "branded-mens-jeans"
  },
  {
    "name": "classic men's jeans",
    "slug": "classic-mens-jeans"
  },
  {
    "name": "slim tapered jeans",
    "slug": "slim-tapered-jeans"
  },
  {
    "name": "everyday men's jeans",
    "slug": "everyday-mens-jeans"
  },
  {
    "name": "wrinkle-free jeans",
    "slug": "wrinkle-free-jeans"
  },
  {
    "name": "polished men's jeans",
    "slug": "polished-mens-jeans"
  },
  {
    "name": "comfortable slim jeans",
    "slug": "comfortable-slim-jeans"
  },
  {
    "name": "sleek fit jeans",
    "slug": "sleek-fit-jeans"
  },
  {
    "name": "stretch slim jeans",
    "slug": "stretch-slim-jeans"
  },
  {
    "name": "durable denim jeans",
    "slug": "durable-denim-jeans"
  },
  {
    "name": "casual tapered jeans",
    "slug": "casual-tapered-jeans"
  },
  {
    "name": "stretchable men's jeans",
    "slug": "stretchable-mens-jeans"
  },
  {
    "name": "modern fit jeans",
    "slug": "modern-fit-jeans"
  },
  {
    "name": "super stretch jeans",
    "slug": "super-stretch-jeans"
  },
  {
    "name": "tailored tapered jeans",
    "slug": "tailored-tapered-jeans"
  },
  {
    "name": "relaxed fit jeans",
    "slug": "relaxed-fit-jeans"
  },
  {
    "name": "stylish slim jeans",
    "slug": "stylish-slim-jeans"
  },
  {
    "name": "wrinkle-resistant jeans",
    "slug": "wrinkle-resistant-jeans"
  },
  {
    "name": "casual fit jeans",
    "slug": "casual-fit-jeans"
  },
  {
    "name": "flexible slim jeans",
    "slug": "flexible-slim-jeans"
  },
  {
    "name": "stretch tapered jeans",
    "slug": "stretch-tapered-jeans"
  },
  {
    "name": "tailored casual jeans",
    "slug": "tailored-casual-jeans"
  },
  {
    "name": "super slim jeans",
    "slug": "super-slim-jeans"
  },
  {
    "name": "modern tapered jeans",
    "slug": "modern-tapered-jeans"
  },
  {
    "name": "breathable slim jeans",
    "slug": "breathable-slim-jeans"
  },
  {
    "name": "polished slim jeans",
    "slug": "polished-slim-jeans"
  },
  {
    "name": "lightweight slim jeans",
    "slug": "lightweight-slim-jeans"
  },
  {
    "name": "sleek tapered jeans",
    "slug": "sleek-tapered-jeans"
  },
  {
    "name": "durable slim jeans",
    "slug": "durable-slim-jeans"
  },
  {
    "name": "premium slim jeans",
    "slug": "premium-slim-jeans"
  },
  {
    "name": "versatile slim jeans",
    "slug": "versatile-slim-jeans"
  },
  {
    "name": "relaxed tapered jeans",
    "slug": "relaxed-tapered-jeans"
  },
  {
    "name": "everyday slim jeans",
    "slug": "everyday-slim-jeans"
  },
  {
    "name": "casual tailored jeans",
    "slug": "casual-tailored-jeans"
  },
  {
    "name": "technical fabric jeans",
    "slug": "technical-fabric-jeans"
  },
  {
    "name": "wrinkle-resistant slim jeans",
    "slug": "wrinkle-resistant-slim-jeans"
  },
  {
    "name": "comfortable tapered jeans",
    "slug": "comfortable-tapered-jeans"
  },
  {
    "name": "blue slim fit denim jeans",
    "slug": "blue-slim-fit-denim-jeans"
  },
  {
    "name": "pale blue stretchable slim jeans",
    "slug": "pale-blue-stretchable-slim-jeans"
  },
  {
    "name": "navy slim tapered fit jeans",
    "slug": "navy-slim-tapered-fit-jeans"
  },
  {
    "name": "grey modern tailored slim jeans",
    "slug": "grey-modern-tailored-slim-jeans"
  },
  {
    "name": "black stretchable classic fit jeans",
    "slug": "black-stretchable-classic-fit-jeans"
  },
  {
    "name": "dark grey slim tapered jeans",
    "slug": "dark-grey-slim-tapered-jeans"
  },
  {
    "name": "navy premium tailored fit jeans",
    "slug": "navy-premium-tailored-fit-jeans"
  },
  {
    "name": "light blue slim tapered jeans",
    "slug": "light-blue-slim-tapered-jeans"
  },
  {
    "name": "grey branded tapered slim jeans",
    "slug": "grey-branded-tapered-slim-jeans"
  },
  {
    "name": "black versatile stretch fit jeans",
    "slug": "black-versatile-stretch-fit-jeans"
  },
  {
    "name": "pale tailored slim fit jeans",
    "slug": "pale-tailored-slim-fit-jeans"
  },
  {
    "name": "navy blue tapered ankle jeans",
    "slug": "navy-blue-tapered-ankle-jeans"
  },
  {
    "name": "grey stretchable casual fit jeans",
    "slug": "grey-stretchable-casual-fit-jeans"
  },
  {
    "name": "blue tailored stretchable men's jeans",
    "slug": "blue-tailored-stretchable-mens-jeans"
  },
  {
    "name": "dark grey casual slim fit jeans",
    "slug": "dark-grey-casual-slim-fit-jeans"
  },
  {
    "name": "light grey tapered men's jeans",
    "slug": "light-grey-tapered-mens-jeans"
  },
  {
    "name": "pale blue tailored stretch jeans",
    "slug": "pale-blue-tailored-stretch-jeans"
  },
  {
    "name": "black casual branded men's jeans",
    "slug": "black-casual-branded-mens-jeans"
  },
  {
    "name": "navy stretch tapered ankle jeans",
    "slug": "navy-stretch-tapered-ankle-jeans"
  },
  {
    "name": "blue slim casual fit jeans",
    "slug": "blue-slim-casual-fit-jeans"
  },
  {
    "name": "grey versatile tailored fit jeans",
    "slug": "grey-versatile-tailored-fit-jeans"
  },
  {
    "name": "dark grey stretch fit jeans",
    "slug": "dark-grey-stretch-fit-jeans"
  },
  {
    "name": "black tailored casual slim jeans",
    "slug": "black-tailored-casual-slim-jeans"
  },
  {
    "name": "navy slim tapered ankle jeans",
    "slug": "navy-slim-tapered-ankle-jeans"
  },
  {
    "name": "pale casual modern slim jeans",
    "slug": "pale-casual-modern-slim-jeans"
  },
  {
    "name": "grey tailored classic fit jeans",
    "slug": "grey-tailored-classic-fit-jeans"
  },
  {
    "name": "blue casual stretchable slim jeans",
    "slug": "blue-casual-stretchable-slim-jeans"
  },
  {
    "name": "light branded tailored fit jeans",
    "slug": "light-branded-tailored-fit-jeans"
  },
  {
    "name": "black slim classic stretch jeans",
    "slug": "black-slim-classic-stretch-jeans"
  },
  {
    "name": "navy lightweight casual slim jeans",
    "slug": "navy-lightweight-casual-slim-jeans"
  },
  {
    "name": "blue lightweight stretch men's jeans",
    "slug": "blue-lightweight-stretch-mens-jeans"
  },
  {
    "name": "pale stretch slim casual jeans",
    "slug": "pale-stretch-slim-casual-jeans"
  },
  {
    "name": "black stretch tailored ankle jeans",
    "slug": "black-stretch-tailored-ankle-jeans"
  },
  {
    "name": "navy tailored lightweight men's jeans",
    "slug": "navy-tailored-lightweight-mens-jeans"
  },
  {
    "name": "grey casual slim tapered jeans",
    "slug": "grey-casual-slim-tapered-jeans"
  },
  {
    "name": "light tailored slim men's jeans",
    "slug": "light-tailored-slim-mens-jeans"
  },
  {
    "name": "blue stretchable casual fit jeans",
    "slug": "blue-stretchable-casual-fit-jeans"
  },
  {
    "name": "black modern stretch slim jeans",
    "slug": "black-modern-stretch-slim-jeans"
  },
  {
    "name": "pale branded stretch fit jeans",
    "slug": "pale-branded-stretch-fit-jeans"
  },
  {
    "name": "dark grey tailored slim fit jeans",
    "slug": "dark-grey-tailored-slim-fit-jeans"
  },
  {
    "name": "navy casual tailored slim jeans",
    "slug": "navy-casual-tailored-slim-jeans"
  },
  {
    "name": "light classic tailored fit jeans",
    "slug": "light-classic-tailored-fit-jeans"
  },
  {
    "name": "grey classic stretch fit jeans",
    "slug": "grey-classic-stretch-fit-jeans"
  },
  {
    "name": "blue premium stretch men's jeans",
    "slug": "blue-premium-stretch-mens-jeans"
  },
  {
    "name": "navy branded classic slim jeans",
    "slug": "navy-branded-classic-slim-jeans"
  },
  {
    "name": "black tailored casual stretch jeans",
    "slug": "black-tailored-casual-stretch-jeans"
  },
  {
    "name": "grey lightweight tailored slim jeans",
    "slug": "grey-lightweight-tailored-slim-jeans"
  },
  {
    "name": "light casual classic men's jeans",
    "slug": "light-casual-classic-mens-jeans"
  },
  {
    "name": "blue slim premium tapered jeans",
    "slug": "blue-slim-premium-tapered-jeans"
  },
  {
    "name": "dark grey lightweight slim jeans",
    "slug": "dark-grey-lightweight-slim-jeans"
  },
  {
    "name": "slim fit stretchable men's jeans",
    "slug": "slim-fit-stretchable-mens-jeans"
  },
  {
    "name": "tailored tapered slim fit jeans",
    "slug": "tailored-tapered-slim-fit-jeans"
  },
  {
    "name": "wrinkle-free casual slim jeans",
    "slug": "wrinkle-free-casual-slim-jeans"
  },
  {
    "name": "lightweight stretch slim fit jeans",
    "slug": "lightweight-stretch-slim-fit-jeans"
  },
  {
    "name": "breathable and stretchable men's jeans",
    "slug": "breathable-and-stretchable-mens-jeans"
  },
  {
    "name": "modern tailored casual slim jeans",
    "slug": "modern-tailored-casual-slim-jeans"
  },
  {
    "name": "versatile everyday slim fit jeans",
    "slug": "versatile-everyday-slim-fit-jeans"
  },
  {
    "name": "wrinkle-resistant tapered slim jeans",
    "slug": "wrinkle-resistant-tapered-slim-jeans"
  },
  {
    "name": "tailored casual stretchable men's jeans",
    "slug": "tailored-casual-stretchable-mens-jeans"
  },
  {
    "name": "comfortable slim tapered ankle jeans",
    "slug": "comfortable-slim-tapered-ankle-jeans"
  },
  {
    "name": "super stretch casual slim jeans",
    "slug": "super-stretch-casual-slim-jeans"
  },
  {
    "name": "flexible and durable slim jeans",
    "slug": "flexible-and-durable-slim-jeans"
  },
  {
    "name": "sleek tapered tailored men's jeans",
    "slug": "sleek-tapered-tailored-mens-jeans"
  },
  {
    "name": "relaxed fit tailored slim jeans",
    "slug": "relaxed-fit-tailored-slim-jeans"
  },
  {
    "name": "casual stretch tapered slim jeans",
    "slug": "casual-stretch-tapered-slim-jeans"
  },
  {
    "name": "breathable wrinkle-resistant slim jeans",
    "slug": "breathable-wrinkle-resistant-slim-jeans"
  },
  {
    "name": "stretch slim tailored fit jeans",
    "slug": "stretch-slim-tailored-fit-jeans"
  },
  {
    "name": "polished casual slim fit jeans",
    "slug": "polished-casual-slim-fit-jeans"
  },
  {
    "name": "lightweight tailored stretchable men's jeans",
    "slug": "lightweight-tailored-stretchable-mens-jeans"
  },
  {
    "name": "wrinkle-free flexible slim fit jeans",
    "slug": "wrinkle-free-flexible-slim-fit-jeans"
  },
  {
    "name": "modern casual slim tapered jeans",
    "slug": "modern-casual-slim-tapered-jeans"
  },
  {
    "name": "tailored fit super stretch jeans",
    "slug": "tailored-fit-super-stretch-jeans"
  },
  {
    "name": "sleek modern tailored slim jeans",
    "slug": "sleek-modern-tailored-slim-jeans"
  },
  {
    "name": "stylish wrinkle-resistant slim jeans",
    "slug": "stylish-wrinkle-resistant-slim-jeans"
  },
  {
    "name": "premium stretchable casual slim jeans",
    "slug": "premium-stretchable-casual-slim-jeans"
  },
  {
    "name": "versatile tailored casual fit jeans",
    "slug": "versatile-tailored-casual-fit-jeans"
  },
  {
    "name": "durable stretch tapered slim jeans",
    "slug": "durable-stretch-tapered-slim-jeans"
  },
  {
    "name": "everyday wrinkle-free men's jeans",
    "slug": "everyday-wrinkle-free-mens-jeans"
  },
  {
    "name": "stretchable tailored slim tapered jeans",
    "slug": "stretchable-tailored-slim-tapered-jeans"
  },
  {
    "name": "polished versatile slim fit jeans",
    "slug": "polished-versatile-slim-fit-jeans"
  },
  {
    "name": "technical fabric tapered slim jeans",
    "slug": "technical-fabric-tapered-slim-jeans"
  },
  {
    "name": "wrinkle-resistant tailored slim fit jeans",
    "slug": "wrinkle-resistant-tailored-slim-fit-jeans"
  },
  {
    "name": "sleek tailored casual slim jeans",
    "slug": "sleek-tailored-casual-slim-jeans"
  },
  {
    "name": "lightweight breathable slim tapered jeans",
    "slug": "lightweight-breathable-slim-tapered-jeans"
  },
  {
    "name": "casual modern stretch slim jeans",
    "slug": "casual-modern-stretch-slim-jeans"
  },
  {
    "name": "tailored casual versatile slim jeans",
    "slug": "tailored-casual-versatile-slim-jeans"
  },
  {
    "name": "relaxed casual slim tapered jeans",
    "slug": "relaxed-casual-slim-tapered-jeans"
  },
  {
    "name": "stretch tailored casual fit jeans",
    "slug": "stretch-tailored-casual-fit-jeans"
  },
  {
    "name": "modern tailored wrinkle-resistant jeans",
    "slug": "modern-tailored-wrinkle-resistant-jeans"
  },
  {
    "name": "lightweight stretch casual slim jeans",
    "slug": "lightweight-stretch-casual-slim-jeans"
  },
  {
    "name": "breathable wrinkle-free tailored jeans",
    "slug": "breathable-wrinkle-free-tailored-jeans"
  },
  {
    "name": "stretch durable casual slim jeans",
    "slug": "stretch-durable-casual-slim-jeans"
  },
  {
    "name": "comfortable slim stretch fit jeans",
    "slug": "comfortable-slim-stretch-fit-jeans"
  },
  {
    "name": "stylish everyday slim tapered jeans",
    "slug": "stylish-everyday-slim-tapered-jeans"
  },
  {
    "name": "sleek casual tailored slim jeans",
    "slug": "sleek-casual-tailored-slim-jeans"
  },
  {
    "name": "tailored polished casual slim jeans",
    "slug": "tailored-polished-casual-slim-jeans"
  },
  {
    "name": "premium everyday stretch slim jeans",
    "slug": "premium-everyday-stretch-slim-jeans"
  },
  {
    "name": "technical fabric casual slim jeans",
    "slug": "technical-fabric-casual-slim-jeans"
  },
  {
    "name": "wrinkle-free tailored casual slim jeans",
    "slug": "wrinkle-free-tailored-casual-slim-jeans"
  },
  {
    "name": "comfortable stretch tailored slim jeans",
    "slug": "comfortable-stretch-tailored-slim-jeans"
  },
  {
    "name": "blue slim shorts",
    "slug": "blue-slim-shorts"
  },
  {
    "name": "pale blue shorts",
    "slug": "pale-blue-shorts"
  },
  {
    "name": "dark blue shorts",
    "slug": "dark-blue-shorts"
  },
  {
    "name": "navy blue shorts",
    "slug": "navy-blue-shorts"
  },
  {
    "name": "white slim shorts",
    "slug": "white-slim-shorts"
  },
  {
    "name": "black slim shorts",
    "slug": "black-slim-shorts"
  },
  {
    "name": "grey slim shorts",
    "slug": "grey-slim-shorts"
  },
  {
    "name": "dark grey shorts",
    "slug": "dark-grey-shorts"
  },
  {
    "name": "light grey shorts",
    "slug": "light-grey-shorts"
  },
  {
    "name": "black denim shorts",
    "slug": "black-denim-shorts"
  },
  {
    "name": "grey denim shorts",
    "slug": "grey-denim-shorts"
  },
  {
    "name": "navy denim shorts",
    "slug": "navy-denim-shorts"
  },
  {
    "name": "blue denim shorts",
    "slug": "blue-denim-shorts"
  },
  {
    "name": "black casual shorts",
    "slug": "black-casual-shorts"
  },
  {
    "name": "navy casual shorts",
    "slug": "navy-casual-shorts"
  },
  {
    "name": "grey casual shorts",
    "slug": "grey-casual-shorts"
  },
  {
    "name": "dark grey shorts",
    "slug": "dark-grey-shorts"
  },
  {
    "name": "light grey shorts",
    "slug": "light-grey-shorts"
  },
  {
    "name": "blue casual shorts",
    "slug": "blue-casual-shorts"
  },
  {
    "name": "white casual shorts",
    "slug": "white-casual-shorts"
  },
  {
    "name": "black stretch shorts",
    "slug": "black-stretch-shorts"
  },
  {
    "name": "grey stretch shorts",
    "slug": "grey-stretch-shorts"
  },
  {
    "name": "navy stretch shorts",
    "slug": "navy-stretch-shorts"
  },
  {
    "name": "blue tailored shorts",
    "slug": "blue-tailored-shorts"
  },
  {
    "name": "grey tailored shorts",
    "slug": "grey-tailored-shorts"
  },
  {
    "name": "black tailored shorts",
    "slug": "black-tailored-shorts"
  },
  {
    "name": "navy tailored shorts",
    "slug": "navy-tailored-shorts"
  },
  {
    "name": "blue summer shorts",
    "slug": "blue-summer-shorts"
  },
  {
    "name": "black summer shorts",
    "slug": "black-summer-shorts"
  },
  {
    "name": "grey summer shorts",
    "slug": "grey-summer-shorts"
  },
  {
    "name": "navy summer shorts",
    "slug": "navy-summer-shorts"
  },
  {
    "name": "dark grey shorts",
    "slug": "dark-grey-shorts"
  },
  {
    "name": "light grey shorts",
    "slug": "light-grey-shorts"
  },
  {
    "name": "pale tailored shorts",
    "slug": "pale-tailored-shorts"
  },
  {
    "name": "blue tapered shorts",
    "slug": "blue-tapered-shorts"
  },
  {
    "name": "navy tapered shorts",
    "slug": "navy-tapered-shorts"
  },
  {
    "name": "grey tapered shorts",
    "slug": "grey-tapered-shorts"
  },
  {
    "name": "black tapered shorts",
    "slug": "black-tapered-shorts"
  },
  {
    "name": "navy classic shorts",
    "slug": "navy-classic-shorts"
  },
  {
    "name": "black classic shorts",
    "slug": "black-classic-shorts"
  },
  {
    "name": "white classic shorts",
    "slug": "white-classic-shorts"
  },
  {
    "name": "grey modern shorts",
    "slug": "grey-modern-shorts"
  },
  {
    "name": "navy modern shorts",
    "slug": "navy-modern-shorts"
  },
  {
    "name": "blue modern shorts",
    "slug": "blue-modern-shorts"
  },
  {
    "name": "grey lightweight shorts",
    "slug": "grey-lightweight-shorts"
  },
  {
    "name": "navy lightweight shorts",
    "slug": "navy-lightweight-shorts"
  },
  {
    "name": "blue lightweight shorts",
    "slug": "blue-lightweight-shorts"
  },
  {
    "name": "black lightweight shorts",
    "slug": "black-lightweight-shorts"
  },
  {
    "name": "white comfortable shorts",
    "slug": "white-comfortable-shorts"
  },
  {
    "name": "navy comfortable shorts",
    "slug": "navy-comfortable-shorts"
  },
  {
    "name": "black flexible shorts",
    "slug": "black-flexible-shorts"
  },
  {
    "name": "grey flexible shorts",
    "slug": "grey-flexible-shorts"
  },
  {
    "name": "navy versatile shorts",
    "slug": "navy-versatile-shorts"
  },
  {
    "name": "pale versatile shorts",
    "slug": "pale-versatile-shorts"
  },
  {
    "name": "light grey denim shorts",
    "slug": "light-grey-denim-shorts"
  },
  {
    "name": "black everyday shorts",
    "slug": "black-everyday-shorts"
  },
  {
    "name": "navy everyday shorts",
    "slug": "navy-everyday-shorts"
  },
  {
    "name": "grey everyday shorts",
    "slug": "grey-everyday-shorts"
  },
  {
    "name": "dark denim shorts",
    "slug": "dark-denim-shorts"
  },
  {
    "name": "white tailored shorts",
    "slug": "white-tailored-shorts"
  },
  {
    "name": "black premium shorts",
    "slug": "black-premium-shorts"
  },
  {
    "name": "navy premium shorts",
    "slug": "navy-premium-shorts"
  },
  {
    "name": "grey premium shorts",
    "slug": "grey-premium-shorts"
  },
  {
    "name": "pale summer shorts",
    "slug": "pale-summer-shorts"
  },
  {
    "name": "light grey tailored shorts",
    "slug": "light-grey-tailored-shorts"
  },
  {
    "name": "slim fit shorts",
    "slug": "slim-fit-shorts"
  },
  {
    "name": "tailored men's shorts",
    "slug": "tailored-mens-shorts"
  },
  {
    "name": "stretchable men's shorts",
    "slug": "stretchable-mens-shorts"
  },
  {
    "name": "comfortable fit shorts",
    "slug": "comfortable-fit-shorts"
  },
  {
    "name": "versatile men's shorts",
    "slug": "versatile-mens-shorts"
  },
  {
    "name": "lightweight men's shorts",
    "slug": "lightweight-mens-shorts"
  },
  {
    "name": "tapered fit shorts",
    "slug": "tapered-fit-shorts"
  },
  {
    "name": "stylish men's shorts",
    "slug": "stylish-mens-shorts"
  },
  {
    "name": "modern slim shorts",
    "slug": "modern-slim-shorts"
  },
  {
    "name": "premium denim shorts",
    "slug": "premium-denim-shorts"
  },
  {
    "name": "everyday men's shorts",
    "slug": "everyday-mens-shorts"
  },
  {
    "name": "casual men's shorts",
    "slug": "casual-mens-shorts"
  },
  {
    "name": "flexible fit shorts",
    "slug": "flexible-fit-shorts"
  },
  {
    "name": "wrinkle-free shorts",
    "slug": "wrinkle-free-shorts"
  },
  {
    "name": "slim tapered shorts",
    "slug": "slim-tapered-shorts"
  },
  {
    "name": "relaxed fit shorts",
    "slug": "relaxed-fit-shorts"
  },
  {
    "name": "breathable men's shorts",
    "slug": "breathable-mens-shorts"
  },
  {
    "name": "premium tailored shorts",
    "slug": "premium-tailored-shorts"
  },
  {
    "name": "flexible slim shorts",
    "slug": "flexible-slim-shorts"
  },
  {
    "name": "casual slim shorts",
    "slug": "casual-slim-shorts"
  },
  {
    "name": "stretch denim shorts",
    "slug": "stretch-denim-shorts"
  },
  {
    "name": "lightweight casual shorts",
    "slug": "lightweight-casual-shorts"
  },
  {
    "name": "stylish slim shorts",
    "slug": "stylish-slim-shorts"
  },
  {
    "name": "relaxed tailored shorts",
    "slug": "relaxed-tailored-shorts"
  },
  {
    "name": "wrinkle-resistant shorts",
    "slug": "wrinkle-resistant-shorts"
  },
  {
    "name": "sleek men's shorts",
    "slug": "sleek-mens-shorts"
  },
  {
    "name": "polished men's shorts",
    "slug": "polished-mens-shorts"
  },
  {
    "name": "super stretch shorts",
    "slug": "super-stretch-shorts"
  },
  {
    "name": "casual tailored shorts",
    "slug": "casual-tailored-shorts"
  },
  {
    "name": "functional men's shorts",
    "slug": "functional-mens-shorts"
  },
  {
    "name": "athletic fit shorts",
    "slug": "athletic-fit-shorts"
  },
  {
    "name": "stretch slim shorts",
    "slug": "stretch-slim-shorts"
  },
  {
    "name": "versatile tailored shorts",
    "slug": "versatile-tailored-shorts"
  },
  {
    "name": "technical fabric shorts",
    "slug": "technical-fabric-shorts"
  },
  {
    "name": "breathable stretch shorts",
    "slug": "breathable-stretch-shorts"
  },
  {
    "name": "wrinkle-resistant slim shorts",
    "slug": "wrinkle-resistant-slim-shorts"
  },
  {
    "name": "tailored stretch shorts",
    "slug": "tailored-stretch-shorts"
  },
  {
    "name": "flexible tapered shorts",
    "slug": "flexible-tapered-shorts"
  },
  {
    "name": "lightweight tailored shorts",
    "slug": "lightweight-tailored-shorts"
  },
  {
    "name": "slim classic shorts",
    "slug": "slim-classic-shorts"
  },
  {
    "name": "performance slim shorts",
    "slug": "performance-slim-shorts"
  },
  {
    "name": "premium casual shorts",
    "slug": "premium-casual-shorts"
  },
  {
    "name": "modern tailored shorts",
    "slug": "modern-tailored-shorts"
  },
  {
    "name": "sleek slim shorts",
    "slug": "sleek-slim-shorts"
  },
  {
    "name": "relaxed casual shorts",
    "slug": "relaxed-casual-shorts"
  },
  {
    "name": "travel-friendly shorts",
    "slug": "travel-friendly-shorts"
  },
  {
    "name": "stylish tailored shorts",
    "slug": "stylish-tailored-shorts"
  },
  {
    "name": "comfortable tailored shorts",
    "slug": "comfortable-tailored-shorts"
  },
  {
    "name": "casual everyday shorts",
    "slug": "casual-everyday-shorts"
  },
  {
    "name": "wrinkle-free tailored shorts",
    "slug": "wrinkle-free-tailored-shorts"
  },
  {
    "name": "blue slim fit denim shorts",
    "slug": "blue-slim-fit-denim-shorts"
  },
  {
    "name": "navy slim tailored casual shorts",
    "slug": "navy-slim-tailored-casual-shorts"
  },
  {
    "name": "grey stretch slim fit shorts",
    "slug": "grey-stretch-slim-fit-shorts"
  },
  {
    "name": "black tailored casual summer shorts",
    "slug": "black-tailored-casual-summer-shorts"
  },
  {
    "name": "light grey slim fit shorts",
    "slug": "light-grey-slim-fit-shorts"
  },
  {
    "name": "dark grey casual denim shorts",
    "slug": "dark-grey-casual-denim-shorts"
  },
  {
    "name": "navy comfortable tapered summer shorts",
    "slug": "navy-comfortable-tapered-summer-shorts"
  },
  {
    "name": "pale blue casual stretch shorts",
    "slug": "pale-blue-casual-stretch-shorts"
  },
  {
    "name": "black slim tapered denim shorts",
    "slug": "black-slim-tapered-denim-shorts"
  },
  {
    "name": "navy stretch comfortable fit shorts",
    "slug": "navy-stretch-comfortable-fit-shorts"
  },
  {
    "name": "blue tailored slim casual shorts",
    "slug": "blue-tailored-slim-casual-shorts"
  },
  {
    "name": "grey tapered comfortable denim shorts",
    "slug": "grey-tapered-comfortable-denim-shorts"
  },
  {
    "name": "navy stretch lightweight casual shorts",
    "slug": "navy-stretch-lightweight-casual-shorts"
  },
  {
    "name": "black modern tailored fit shorts",
    "slug": "black-modern-tailored-fit-shorts"
  },
  {
    "name": "pale summer tailored slim shorts",
    "slug": "pale-summer-tailored-slim-shorts"
  },
  {
    "name": "dark grey stretch fit shorts",
    "slug": "dark-grey-stretch-fit-shorts"
  },
  {
    "name": "navy classic comfortable fit shorts",
    "slug": "navy-classic-comfortable-fit-shorts"
  },
  {
    "name": "grey modern casual denim shorts",
    "slug": "grey-modern-casual-denim-shorts"
  },
  {
    "name": "white stretch slim tailored shorts",
    "slug": "white-stretch-slim-tailored-shorts"
  },
  {
    "name": "black casual everyday men's shorts",
    "slug": "black-casual-everyday-mens-shorts"
  },
  {
    "name": "navy modern tapered casual shorts",
    "slug": "navy-modern-tapered-casual-shorts"
  },
  {
    "name": "blue tailored casual summer shorts",
    "slug": "blue-tailored-casual-summer-shorts"
  },
  {
    "name": "grey lightweight stretch slim shorts",
    "slug": "grey-lightweight-stretch-slim-shorts"
  },
  {
    "name": "navy classic stretch fit shorts",
    "slug": "navy-classic-stretch-fit-shorts"
  },
  {
    "name": "blue premium casual tailored shorts",
    "slug": "blue-premium-casual-tailored-shorts"
  },
  {
    "name": "black stretch lightweight denim shorts",
    "slug": "black-stretch-lightweight-denim-shorts"
  },
  {
    "name": "navy stretch casual summer shorts",
    "slug": "navy-stretch-casual-summer-shorts"
  },
  {
    "name": "white slim comfortable fit shorts",
    "slug": "white-slim-comfortable-fit-shorts"
  },
  {
    "name": "dark grey premium tailored shorts",
    "slug": "dark-grey-premium-tailored-shorts"
  },
  {
    "name": "pale stretch modern casual shorts",
    "slug": "pale-stretch-modern-casual-shorts"
  },
  {
    "name": "navy classic lightweight casual shorts",
    "slug": "navy-classic-lightweight-casual-shorts"
  },
  {
    "name": "black versatile slim tailored shorts",
    "slug": "black-versatile-slim-tailored-shorts"
  },
  {
    "name": "grey tapered modern summer shorts",
    "slug": "grey-tapered-modern-summer-shorts"
  },
  {
    "name": "navy lightweight comfortable men's shorts",
    "slug": "navy-lightweight-comfortable-mens-shorts"
  },
  {
    "name": "white stretch casual tailored shorts",
    "slug": "white-stretch-casual-tailored-shorts"
  },
  {
    "name": "blue lightweight stretch slim shorts",
    "slug": "blue-lightweight-stretch-slim-shorts"
  },
  {
    "name": "navy everyday casual men's shorts",
    "slug": "navy-everyday-casual-mens-shorts"
  },
  {
    "name": "black modern casual tailored shorts",
    "slug": "black-modern-casual-tailored-shorts"
  },
  {
    "name": "grey premium slim tapered shorts",
    "slug": "grey-premium-slim-tapered-shorts"
  },
  {
    "name": "navy premium tailored casual shorts",
    "slug": "navy-premium-tailored-casual-shorts"
  },
  {
    "name": "blue tailored casual men's shorts",
    "slug": "blue-tailored-casual-mens-shorts"
  },
  {
    "name": "pale everyday stretch tailored shorts",
    "slug": "pale-everyday-stretch-tailored-shorts"
  },
  {
    "name": "light grey stretch casual shorts",
    "slug": "light-grey-stretch-casual-shorts"
  },
  {
    "name": "dark grey casual tailored shorts",
    "slug": "dark-grey-casual-tailored-shorts"
  },
  {
    "name": "navy stretch lightweight summer shorts",
    "slug": "navy-stretch-lightweight-summer-shorts"
  },
  {
    "name": "black premium tailored fit shorts",
    "slug": "black-premium-tailored-fit-shorts"
  },
  {
    "name": "navy casual stretch slim shorts",
    "slug": "navy-casual-stretch-slim-shorts"
  },
  {
    "name": "pale tailored comfortable denim shorts",
    "slug": "pale-tailored-comfortable-denim-shorts"
  },
  {
    "name": "grey classic lightweight casual shorts",
    "slug": "grey-classic-lightweight-casual-shorts"
  },
  {
    "name": "blue comfortable versatile men's shorts",
    "slug": "blue-comfortable-versatile-mens-shorts"
  },
  {
    "name": "navy tailored lightweight casual shorts",
    "slug": "navy-tailored-lightweight-casual-shorts"
  },
  {
    "name": "black stretch tapered fit shorts",
    "slug": "black-stretch-tapered-fit-shorts"
  },
  {
    "name": "grey stretch modern tapered shorts",
    "slug": "grey-stretch-modern-tapered-shorts"
  },
  {
    "name": "navy tailored casual men's shorts",
    "slug": "navy-tailored-casual-mens-shorts"
  },
  {
    "name": "blue slim lightweight casual shorts",
    "slug": "blue-slim-lightweight-casual-shorts"
  },
  {
    "name": "dark grey everyday casual shorts",
    "slug": "dark-grey-everyday-casual-shorts"
  },
  {
    "name": "black versatile casual denim shorts",
    "slug": "black-versatile-casual-denim-shorts"
  },
  {
    "name": "grey everyday tailored men's shorts",
    "slug": "grey-everyday-tailored-mens-shorts"
  },
  {
    "name": "navy summer stretch lightweight shorts",
    "slug": "navy-summer-stretch-lightweight-shorts"
  },
  {
    "name": "white casual comfortable men's shorts",
    "slug": "white-casual-comfortable-mens-shorts"
  },
  {
    "name": "slim fit stretchable men's shorts",
    "slug": "slim-fit-stretchable-mens-shorts"
  },
  {
    "name": "tapered slim tailored casual shorts",
    "slug": "tapered-slim-tailored-casual-shorts"
  },
  {
    "name": "wrinkle-free casual slim shorts",
    "slug": "wrinkle-free-casual-slim-shorts"
  },
  {
    "name": "lightweight tailored slim fit shorts",
    "slug": "lightweight-tailored-slim-fit-shorts"
  },
  {
    "name": "breathable and flexible men's shorts",
    "slug": "breathable-and-flexible-mens-shorts"
  },
  {
    "name": "modern tailored casual slim shorts",
    "slug": "modern-tailored-casual-slim-shorts"
  },
  {
    "name": "versatile everyday slim fit shorts",
    "slug": "versatile-everyday-slim-fit-shorts"
  },
  {
    "name": "wrinkle-resistant tapered slim shorts",
    "slug": "wrinkle-resistant-tapered-slim-shorts"
  },
  {
    "name": "tailored casual stretchable men's shorts",
    "slug": "tailored-casual-stretchable-mens-shorts"
  },
  {
    "name": "comfortable slim tapered fit shorts",
    "slug": "comfortable-slim-tapered-fit-shorts"
  },
  {
    "name": "stretch slim tailored men's shorts",
    "slug": "stretch-slim-tailored-mens-shorts"
  },
  {
    "name": "lightweight casual tailored men's shorts",
    "slug": "lightweight-casual-tailored-mens-shorts"
  },
  {
    "name": "wrinkle-resistant flexible slim shorts",
    "slug": "wrinkle-resistant-flexible-slim-shorts"
  },
  {
    "name": "modern stretch tailored slim shorts",
    "slug": "modern-stretch-tailored-slim-shorts"
  },
  {
    "name": "casual tailored functional men's shorts",
    "slug": "casual-tailored-functional-mens-shorts"
  },
  {
    "name": "versatile tailored slim fit shorts",
    "slug": "versatile-tailored-slim-fit-shorts"
  },
  {
    "name": "polished lightweight casual men's shorts",
    "slug": "polished-lightweight-casual-mens-shorts"
  },
  {
    "name": "super stretch casual slim shorts",
    "slug": "super-stretch-casual-slim-shorts"
  },
  {
    "name": "premium tailored casual fit shorts",
    "slug": "premium-tailored-casual-fit-shorts"
  },
  {
    "name": "comfortable casual stretch slim shorts",
    "slug": "comfortable-casual-stretch-slim-shorts"
  },
  {
    "name": "stylish wrinkle-resistant slim shorts",
    "slug": "stylish-wrinkle-resistant-slim-shorts"
  },
  {
    "name": "breathable wrinkle-free casual shorts",
    "slug": "breathable-wrinkle-free-casual-shorts"
  },
  {
    "name": "relaxed fit tailored slim shorts",
    "slug": "relaxed-fit-tailored-slim-shorts"
  },
  {
    "name": "travel-ready tailored men's shorts",
    "slug": "travel-ready-tailored-mens-shorts"
  },
  {
    "name": "functional stretch slim fit shorts",
    "slug": "functional-stretch-slim-fit-shorts"
  },
  {
    "name": "everyday wrinkle-free slim shorts",
    "slug": "everyday-wrinkle-free-slim-shorts"
  },
  {
    "name": "sleek tailored slim fit shorts",
    "slug": "sleek-tailored-slim-fit-shorts"
  },
  {
    "name": "lightweight breathable tailored shorts",
    "slug": "lightweight-breathable-tailored-shorts"
  },
  {
    "name": "polished tailored casual men's shorts",
    "slug": "polished-tailored-casual-mens-shorts"
  },
  {
    "name": "flexible and stylish slim shorts",
    "slug": "flexible-and-stylish-slim-shorts"
  },
  {
    "name": "premium tailored lightweight casual shorts",
    "slug": "premium-tailored-lightweight-casual-shorts"
  },
  {
    "name": "stretch tailored casual fit shorts",
    "slug": "stretch-tailored-casual-fit-shorts"
  },
  {
    "name": "stylish modern casual men's shorts",
    "slug": "stylish-modern-casual-mens-shorts"
  },
  {
    "name": "lightweight tailored performance shorts",
    "slug": "lightweight-tailored-performance-shorts"
  },
  {
    "name": "technical fabric stretch slim shorts",
    "slug": "technical-fabric-stretch-slim-shorts"
  },
  {
    "name": "breathable stretch tailored men's shorts",
    "slug": "breathable-stretch-tailored-mens-shorts"
  },
  {
    "name": "modern wrinkle-resistant casual shorts",
    "slug": "modern-wrinkle-resistant-casual-shorts"
  },
  {
    "name": "comfortable slim stretch tailored shorts",
    "slug": "comfortable-slim-stretch-tailored-shorts"
  },
  {
    "name": "relaxed casual tailored slim shorts",
    "slug": "relaxed-casual-tailored-slim-shorts"
  },
  {
    "name": "casual slim tapered fit shorts",
    "slug": "casual-slim-tapered-fit-shorts"
  },
  {
    "name": "tailored breathable functional men's shorts",
    "slug": "tailored-breathable-functional-mens-shorts"
  },
  {
    "name": "versatile stretch slim casual shorts",
    "slug": "versatile-stretch-slim-casual-shorts"
  },
  {
    "name": "premium casual stretch tailored shorts",
    "slug": "premium-casual-stretch-tailored-shorts"
  },
  {
    "name": "modern polished tailored slim shorts",
    "slug": "modern-polished-tailored-slim-shorts"
  },
  {
    "name": "relaxed tailored stretch slim shorts",
    "slug": "relaxed-tailored-stretch-slim-shorts"
  },
  {
    "name": "travel-friendly tailored slim shorts",
    "slug": "travel-friendly-tailored-slim-shorts"
  },
  {
    "name": "functional lightweight casual slim shorts",
    "slug": "functional-lightweight-casual-slim-shorts"
  },
  {
    "name": "wrinkle-free lightweight tailored shorts",
    "slug": "wrinkle-free-lightweight-tailored-shorts"
  },
  {
    "name": "stylish slim stretchable casual shorts",
    "slug": "stylish-slim-stretchable-casual-shorts"
  },
  {
    "name": "versatile functional tailored men's shorts",
    "slug": "versatile-functional-tailored-mens-shorts"
  },
  {
    "name": "black active half zip",
    "slug": "black-active-half-zip"
  },
  {
    "name": "navy active joggers",
    "slug": "navy-active-joggers"
  },
  {
    "name": "grey stretch active trousers",
    "slug": "grey-stretch-active-trousers"
  },
  {
    "name": "steel grey workout shorts",
    "slug": "steel-grey-workout-shorts"
  },
  {
    "name": "light grey gym joggers",
    "slug": "light-grey-gym-joggers"
  },
  {
    "name": "blue active t-shirts",
    "slug": "blue-active-t-shirts"
  },
  {
    "name": "navy quick-dry joggers",
    "slug": "navy-quick-dry-joggers"
  },
  {
    "name": "grey athletic half zip",
    "slug": "grey-athletic-half-zip"
  },
  {
    "name": "black breathable activewear shorts",
    "slug": "black-breathable-activewear-shorts"
  },
  {
    "name": "navy versatile workout trousers",
    "slug": "navy-versatile-workout-trousers"
  },
  {
    "name": "steel grey active joggers",
    "slug": "steel-grey-active-joggers"
  },
  {
    "name": "light grey performance t-shirts",
    "slug": "light-grey-performance-t-shirts"
  },
  {
    "name": "black moisture-wicking joggers",
    "slug": "black-moisture-wicking-joggers"
  },
  {
    "name": "blue stretchable active trousers",
    "slug": "blue-stretchable-active-trousers"
  },
  {
    "name": "navy sweat-wicking active shorts",
    "slug": "navy-sweat-wicking-active-shorts"
  },
  {
    "name": "grey four-way stretch joggers",
    "slug": "grey-four-way-stretch-joggers"
  },
  {
    "name": "black lightweight active trousers",
    "slug": "black-lightweight-active-trousers"
  },
  {
    "name": "navy breathable workout half zip",
    "slug": "navy-breathable-workout-half-zip"
  },
  {
    "name": "blue versatile gym shorts",
    "slug": "blue-versatile-gym-shorts"
  },
  {
    "name": "grey sweat-wicking t-shirts",
    "slug": "grey-sweat-wicking-t-shirts"
  },
  {
    "name": "black quick-dry active joggers",
    "slug": "black-quick-dry-active-joggers"
  },
  {
    "name": "navy modern activewear trousers",
    "slug": "navy-modern-activewear-trousers"
  },
  {
    "name": "grey functional active half zip",
    "slug": "grey-functional-active-half-zip"
  },
  {
    "name": "steel grey tapered joggers",
    "slug": "steel-grey-tapered-joggers"
  },
  {
    "name": "light grey durable shorts",
    "slug": "light-grey-durable-shorts"
  },
  {
    "name": "black athletic gym trousers",
    "slug": "black-athletic-gym-trousers"
  },
  {
    "name": "navy casual training joggers",
    "slug": "navy-casual-training-joggers"
  },
  {
    "name": "grey comfortable gym trousers",
    "slug": "grey-comfortable-gym-trousers"
  },
  {
    "name": "black flexible active shorts",
    "slug": "black-flexible-active-shorts"
  },
  {
    "name": "navy stretch athletic t-shirts",
    "slug": "navy-stretch-athletic-t-shirts"
  },
  {
    "name": "blue lightweight half zip",
    "slug": "blue-lightweight-half-zip"
  },
  {
    "name": "light grey gym shorts",
    "slug": "light-grey-gym-shorts"
  },
  {
    "name": "steel grey workout trousers",
    "slug": "steel-grey-workout-trousers"
  },
  {
    "name": "black tailored active joggers",
    "slug": "black-tailored-active-joggers"
  },
  {
    "name": "navy breathable slim trousers",
    "slug": "navy-breathable-slim-trousers"
  },
  {
    "name": "grey performance athletic joggers",
    "slug": "grey-performance-athletic-joggers"
  },
  {
    "name": "black versatile training half zip",
    "slug": "black-versatile-training-half-zip"
  },
  {
    "name": "blue modern active joggers",
    "slug": "blue-modern-active-joggers"
  },
  {
    "name": "navy lightweight gym shorts",
    "slug": "navy-lightweight-gym-shorts"
  },
  {
    "name": "grey moisture-wicking active trousers",
    "slug": "grey-moisture-wicking-active-trousers"
  },
  {
    "name": "steel grey slim joggers",
    "slug": "steel-grey-slim-joggers"
  },
  {
    "name": "light grey active t-shirts",
    "slug": "light-grey-active-t-shirts"
  },
  {
    "name": "navy sweat-resistant training trousers",
    "slug": "navy-sweat-resistant-training-trousers"
  },
  {
    "name": "grey functional stretch joggers",
    "slug": "grey-functional-stretch-joggers"
  },
  {
    "name": "black relaxed activewear joggers",
    "slug": "black-relaxed-activewear-joggers"
  },
  {
    "name": "navy classic performance shorts",
    "slug": "navy-classic-performance-shorts"
  },
  {
    "name": "light grey everyday joggers",
    "slug": "light-grey-everyday-joggers"
  },
  {
    "name": "grey quick-dry active shorts",
    "slug": "grey-quick-dry-active-shorts"
  },
  {
    "name": "navy breathable workout trousers",
    "slug": "navy-breathable-workout-trousers"
  },
  {
    "name": "black functional active trousers",
    "slug": "black-functional-active-trousers"
  },
  {
    "name": "activewear half zip",
    "slug": "activewear-half-zip"
  },
  {
    "name": "breathable active joggers",
    "slug": "breathable-active-joggers"
  },
  {
    "name": "stretch active trousers",
    "slug": "stretch-active-trousers"
  },
  {
    "name": "lightweight workout shorts",
    "slug": "lightweight-workout-shorts"
  },
  {
    "name": "sweat-wicking t-shirts",
    "slug": "sweat-wicking-t-shirts"
  },
  {
    "name": "quick-dry active joggers",
    "slug": "quick-dry-active-joggers"
  },
  {
    "name": "moisture-wicking activewear shorts",
    "slug": "moisture-wicking-activewear-shorts"
  },
  {
    "name": "versatile gym joggers",
    "slug": "versatile-gym-joggers"
  },
  {
    "name": "functional active trousers",
    "slug": "functional-active-trousers"
  },
  {
    "name": "comfortable active t-shirts",
    "slug": "comfortable-active-t-shirts"
  },
  {
    "name": "slim fit joggers",
    "slug": "slim-fit-joggers"
  },
  {
    "name": "flexible workout shorts",
    "slug": "flexible-workout-shorts"
  },
  {
    "name": "everyday active trousers",
    "slug": "everyday-active-trousers"
  },
  {
    "name": "breathable workout t-shirts",
    "slug": "breathable-workout-t-shirts"
  },
  {
    "name": "modern athletic joggers",
    "slug": "modern-athletic-joggers"
  },
  {
    "name": "tailored active trousers",
    "slug": "tailored-active-trousers"
  },
  {
    "name": "relaxed fit joggers",
    "slug": "relaxed-fit-joggers"
  },
  {
    "name": "durable gym shorts",
    "slug": "durable-gym-shorts"
  },
  {
    "name": "performance active joggers",
    "slug": "performance-active-joggers"
  },
  {
    "name": "four-way stretch joggers",
    "slug": "four-way-stretch-joggers"
  },
  {
    "name": "lightweight active trousers",
    "slug": "lightweight-active-trousers"
  },
  {
    "name": "sweat-resistant workout joggers",
    "slug": "sweat-resistant-workout-joggers"
  },
  {
    "name": "quick-dry training shorts",
    "slug": "quick-dry-training-shorts"
  },
  {
    "name": "slim tapered joggers",
    "slug": "slim-tapered-joggers"
  },
  {
    "name": "functional gym trousers",
    "slug": "functional-gym-trousers"
  },
  {
    "name": "versatile training t-shirts",
    "slug": "versatile-training-t-shirts"
  },
  {
    "name": "stretchable active joggers",
    "slug": "stretchable-active-joggers"
  },
  {
    "name": "breathable slim trousers",
    "slug": "breathable-slim-trousers"
  },
  {
    "name": "quick-dry performance joggers",
    "slug": "quick-dry-performance-joggers"
  },
  {
    "name": "wrinkle-resistant active trousers",
    "slug": "wrinkle-resistant-active-trousers"
  },
  {
    "name": "casual workout joggers",
    "slug": "casual-workout-joggers"
  },
  {
    "name": "gym activewear shorts",
    "slug": "gym-activewear-shorts"
  },
  {
    "name": "tapered active joggers",
    "slug": "tapered-active-joggers"
  },
  {
    "name": "relaxed workout trousers",
    "slug": "relaxed-workout-trousers"
  },
  {
    "name": "stretchable gym trousers",
    "slug": "stretchable-gym-trousers"
  },
  {
    "name": "moisture-wicking active trousers",
    "slug": "moisture-wicking-active-trousers"
  },
  {
    "name": "breathable gym joggers",
    "slug": "breathable-gym-joggers"
  },
  {
    "name": "versatile training joggers",
    "slug": "versatile-training-joggers"
  },
  {
    "name": "modern slim trousers",
    "slug": "modern-slim-trousers"
  },
  {
    "name": "tailored workout joggers",
    "slug": "tailored-workout-joggers"
  },
  {
    "name": "sweat-wicking active trousers",
    "slug": "sweat-wicking-active-trousers"
  },
  {
    "name": "comfortable workout joggers",
    "slug": "comfortable-workout-joggers"
  },
  {
    "name": "stretch slim trousers",
    "slug": "stretch-slim-trousers"
  },
  {
    "name": "durable activewear joggers",
    "slug": "durable-activewear-joggers"
  },
  {
    "name": "tailored gym trousers",
    "slug": "tailored-gym-trousers"
  },
  {
    "name": "relaxed active joggers",
    "slug": "relaxed-active-joggers"
  },
  {
    "name": "versatile athletic joggers",
    "slug": "versatile-athletic-joggers"
  },
  {
    "name": "breathable everyday joggers",
    "slug": "breathable-everyday-joggers"
  },
  {
    "name": "comfortable active trousers",
    "slug": "comfortable-active-trousers"
  },
  {
    "name": "flexible performance joggers",
    "slug": "flexible-performance-joggers"
  },
  {
    "name": "black moisture-wicking active half zip",
    "slug": "black-moisture-wicking-active-half-zip"
  },
  {
    "name": "navy lightweight breathable gym joggers",
    "slug": "navy-lightweight-breathable-gym-joggers"
  },
  {
    "name": "grey quick-dry training trousers",
    "slug": "grey-quick-dry-training-trousers"
  },
  {
    "name": "blue slim fit active joggers",
    "slug": "blue-slim-fit-active-joggers"
  },
  {
    "name": "light grey versatile active shorts",
    "slug": "light-grey-versatile-active-shorts"
  },
  {
    "name": "steel grey durable active t-shirts",
    "slug": "steel-grey-durable-active-t-shirts"
  },
  {
    "name": "black performance stretch gym joggers",
    "slug": "black-performance-stretch-gym-joggers"
  },
  {
    "name": "navy casual quick-dry trousers",
    "slug": "navy-casual-quick-dry-trousers"
  },
  {
    "name": "grey functional slim fit joggers",
    "slug": "grey-functional-slim-fit-joggers"
  },
  {
    "name": "black stretchable gym active trousers",
    "slug": "black-stretchable-gym-active-trousers"
  },
  {
    "name": "light grey sweat-wicking active shorts",
    "slug": "light-grey-sweat-wicking-active-shorts"
  },
  {
    "name": "navy four-way stretch active joggers",
    "slug": "navy-four-way-stretch-active-joggers"
  },
  {
    "name": "steel grey versatile training trousers",
    "slug": "steel-grey-versatile-training-trousers"
  },
  {
    "name": "black lightweight everyday activewear joggers",
    "slug": "black-lightweight-everyday-activewear-joggers"
  },
  {
    "name": "navy breathable four-way stretch trousers",
    "slug": "navy-breathable-four-way-stretch-trousers"
  },
  {
    "name": "grey performance tailored fit joggers",
    "slug": "grey-performance-tailored-fit-joggers"
  },
  {
    "name": "blue durable quick-dry active t-shirts",
    "slug": "blue-durable-quick-dry-active-t-shirts"
  },
  {
    "name": "navy modern versatile workout joggers",
    "slug": "navy-modern-versatile-workout-joggers"
  },
  {
    "name": "grey casual stretch gym trousers",
    "slug": "grey-casual-stretch-gym-trousers"
  },
  {
    "name": "black slim fit breathable joggers",
    "slug": "black-slim-fit-breathable-joggers"
  },
  {
    "name": "navy quick-dry active training shorts",
    "slug": "navy-quick-dry-active-training-shorts"
  },
  {
    "name": "light grey relaxed gym joggers",
    "slug": "light-grey-relaxed-gym-joggers"
  },
  {
    "name": "steel grey athletic workout half zip",
    "slug": "steel-grey-athletic-workout-half-zip"
  },
  {
    "name": "navy lightweight gym active shorts",
    "slug": "navy-lightweight-gym-active-shorts"
  },
  {
    "name": "black functional moisture-wicking joggers",
    "slug": "black-functional-moisture-wicking-joggers"
  },
  {
    "name": "grey tapered sweat-resistant active trousers",
    "slug": "grey-tapered-sweat-resistant-active-trousers"
  },
  {
    "name": "blue versatile slim fit joggers",
    "slug": "blue-versatile-slim-fit-joggers"
  },
  {
    "name": "navy durable four-way stretch trousers",
    "slug": "navy-durable-four-way-stretch-trousers"
  },
  {
    "name": "grey comfortable everyday active joggers",
    "slug": "grey-comfortable-everyday-active-joggers"
  },
  {
    "name": "black quick-dry functional active shorts",
    "slug": "black-quick-dry-functional-active-shorts"
  },
  {
    "name": "navy performance slim training joggers",
    "slug": "navy-performance-slim-training-joggers"
  },
  {
    "name": "steel grey flexible activewear trousers",
    "slug": "steel-grey-flexible-activewear-trousers"
  },
  {
    "name": "grey lightweight stretchable workout joggers",
    "slug": "grey-lightweight-stretchable-workout-joggers"
  },
  {
    "name": "black tailored breathable active trousers",
    "slug": "black-tailored-breathable-active-trousers"
  },
  {
    "name": "navy four-way stretch training shorts",
    "slug": "navy-four-way-stretch-training-shorts"
  },
  {
    "name": "light grey durable workout joggers",
    "slug": "light-grey-durable-workout-joggers"
  },
  {
    "name": "steel grey relaxed athletic trousers",
    "slug": "steel-grey-relaxed-athletic-trousers"
  },
  {
    "name": "blue quick-dry versatile gym shorts",
    "slug": "blue-quick-dry-versatile-gym-shorts"
  },
  {
    "name": "navy functional breathable slim trousers",
    "slug": "navy-functional-breathable-slim-trousers"
  },
  {
    "name": "black comfortable tailored gym joggers",
    "slug": "black-comfortable-tailored-gym-joggers"
  },
  {
    "name": "grey sweat-wicking stretchable active shorts",
    "slug": "grey-sweat-wicking-stretchable-active-shorts"
  },
  {
    "name": "navy modern breathable active trousers",
    "slug": "navy-modern-breathable-active-trousers"
  },
  {
    "name": "black moisture-wicking training gym joggers",
    "slug": "black-moisture-wicking-training-gym-joggers"
  },
  {
    "name": "steel grey performance gym active shorts",
    "slug": "steel-grey-performance-gym-active-shorts"
  },
  {
    "name": "light grey stretch comfortable active trousers",
    "slug": "light-grey-stretch-comfortable-active-trousers"
  },
  {
    "name": "navy everyday casual active joggers",
    "slug": "navy-everyday-casual-active-joggers"
  },
  {
    "name": "grey versatile quick-dry gym trousers",
    "slug": "grey-versatile-quick-dry-gym-trousers"
  },
  {
    "name": "black tailored stretch athletic joggers",
    "slug": "black-tailored-stretch-athletic-joggers"
  },
  {
    "name": "navy lightweight functional workout trousers",
    "slug": "navy-lightweight-functional-workout-trousers"
  },
  {
    "name": "blue breathable four-way stretch shorts",
    "slug": "blue-breathable-four-way-stretch-shorts"
  },
  {
    "name": "moisture-wicking activewear for men",
    "slug": "moisture-wicking-activewear-for-men"
  },
  {
    "name": "stretchable tailored fit active joggers",
    "slug": "stretchable-tailored-fit-active-joggers"
  },
  {
    "name": "quick-dry breathable active trousers",
    "slug": "quick-dry-breathable-active-trousers"
  },
  {
    "name": "lightweight and flexible gym joggers",
    "slug": "lightweight-and-flexible-gym-joggers"
  },
  {
    "name": "versatile everyday slim fit joggers",
    "slug": "versatile-everyday-slim-fit-joggers"
  },
  {
    "name": "relaxed fit active training joggers",
    "slug": "relaxed-fit-active-training-joggers"
  },
  {
    "name": "four-way stretch workout trousers",
    "slug": "four-way-stretch-workout-trousers"
  },
  {
    "name": "tailored breathable performance joggers",
    "slug": "tailored-breathable-performance-joggers"
  },
  {
    "name": "sweat-wicking modern gym trousers",
    "slug": "sweat-wicking-modern-gym-trousers"
  },
  {
    "name": "durable and flexible workout joggers",
    "slug": "durable-and-flexible-workout-joggers"
  },
  {
    "name": "wrinkle-resistant everyday active trousers",
    "slug": "wrinkle-resistant-everyday-active-trousers"
  },
  {
    "name": "breathable versatile activewear joggers",
    "slug": "breathable-versatile-activewear-joggers"
  },
  {
    "name": "slim tapered stretch gym joggers",
    "slug": "slim-tapered-stretch-gym-joggers"
  },
  {
    "name": "quick-dry training active trousers",
    "slug": "quick-dry-training-active-trousers"
  },
  {
    "name": "tailored stretchable active gym joggers",
    "slug": "tailored-stretchable-active-gym-joggers"
  },
  {
    "name": "relaxed gym tailored fit trousers",
    "slug": "relaxed-gym-tailored-fit-trousers"
  },
  {
    "name": "flexible four-way stretch joggers",
    "slug": "flexible-four-way-stretch-joggers"
  },
  {
    "name": "moisture-wicking tailored active trousers",
    "slug": "moisture-wicking-tailored-active-trousers"
  },
  {
    "name": "comfortable breathable workout joggers",
    "slug": "comfortable-breathable-workout-joggers"
  },
  {
    "name": "stretchable slim fit active trousers",
    "slug": "stretchable-slim-fit-active-trousers"
  },
  {
    "name": "tailored durable performance active joggers",
    "slug": "tailored-durable-performance-active-joggers"
  },
  {
    "name": "versatile functional gym active trousers",
    "slug": "versatile-functional-gym-active-trousers"
  },
  {
    "name": "wrinkle-resistant breathable gym joggers",
    "slug": "wrinkle-resistant-breathable-gym-joggers"
  },
  {
    "name": "slim tailored modern active joggers",
    "slug": "slim-tailored-modern-active-joggers"
  },
  {
    "name": "casual stretch four-way joggers",
    "slug": "casual-stretch-four-way-joggers"
  },
  {
    "name": "everyday lightweight active trousers",
    "slug": "everyday-lightweight-active-trousers"
  },
  {
    "name": "sweat-wicking tailored slim fit joggers",
    "slug": "sweat-wicking-tailored-slim-fit-joggers"
  },
  {
    "name": "modern stretchable functional gym trousers",
    "slug": "modern-stretchable-functional-gym-trousers"
  },
  {
    "name": "versatile slim tapered active trousers",
    "slug": "versatile-slim-tapered-active-trousers"
  },
  {
    "name": "breathable relaxed tailored workout joggers",
    "slug": "breathable-relaxed-tailored-workout-joggers"
  },
  {
    "name": "stretch durable everyday active joggers",
    "slug": "stretch-durable-everyday-active-joggers"
  },
  {
    "name": "moisture-wicking four-way gym joggers",
    "slug": "moisture-wicking-four-way-gym-joggers"
  },
  {
    "name": "tailored comfortable modern workout trousers",
    "slug": "tailored-comfortable-modern-workout-trousers"
  },
  {
    "name": "performance-focused activewear joggers",
    "slug": "performance-focused-activewear-joggers"
  },
  {
    "name": "lightweight stretchable slim fit joggers",
    "slug": "lightweight-stretchable-slim-fit-joggers"
  },
  {
    "name": "wrinkle-free tailored gym trousers",
    "slug": "wrinkle-free-tailored-gym-trousers"
  },
  {
    "name": "functional breathable slim fit joggers",
    "slug": "functional-breathable-slim-fit-joggers"
  },
  {
    "name": "versatile tailored stretch active trousers",
    "slug": "versatile-tailored-stretch-active-trousers"
  },
  {
    "name": "modern wrinkle-resistant workout joggers",
    "slug": "modern-wrinkle-resistant-workout-joggers"
  },
  {
    "name": "comfortable sweat-wicking performance joggers",
    "slug": "comfortable-sweat-wicking-performance-joggers"
  },
  {
    "name": "slim tailored breathable gym trousers",
    "slug": "slim-tailored-breathable-gym-trousers"
  },
  {
    "name": "wrinkle-resistant four-way active joggers",
    "slug": "wrinkle-resistant-four-way-active-joggers"
  },
  {
    "name": "functional everyday casual gym joggers",
    "slug": "functional-everyday-casual-gym-joggers"
  },
  {
    "name": "modern flexible tailored fit joggers",
    "slug": "modern-flexible-tailored-fit-joggers"
  },
  {
    "name": "stretchable wrinkle-resistant active trousers",
    "slug": "stretchable-wrinkle-resistant-active-trousers"
  },
  {
    "name": "relaxed casual slim fit joggers",
    "slug": "relaxed-casual-slim-fit-joggers"
  },
  {
    "name": "durable slim tapered active joggers",
    "slug": "durable-slim-tapered-active-joggers"
  },
  {
    "name": "breathable flexible workout gym joggers",
    "slug": "breathable-flexible-workout-gym-joggers"
  },
  {
    "name": "tailored wrinkle-free casual joggers",
    "slug": "tailored-wrinkle-free-casual-joggers"
  },
  {
    "name": "versatile modern active training joggers",
    "slug": "versatile-modern-active-training-joggers"
  },
  {
    "name": "men's activewear joggers",
    "slug": "mens-activewear-joggers"
  },
  {
    "name": "activewear workout trousers",
    "slug": "activewear-workout-trousers"
  },
  {
    "name": "breathable activewear shorts",
    "slug": "breathable-activewear-shorts"
  },
  {
    "name": "stretchable activewear joggers",
    "slug": "stretchable-activewear-joggers"
  },
  {
    "name": "versatile activewear t-shirts",
    "slug": "versatile-activewear-t-shirts"
  },
  {
    "name": "moisture-wicking activewear trousers",
    "slug": "moisture-wicking-activewear-trousers"
  },
  {
    "name": "slim fit activewear",
    "slug": "slim-fit-activewear"
  },
  {
    "name": "flexible activewear joggers",
    "slug": "flexible-activewear-joggers"
  },
  {
    "name": "comfortable activewear shorts",
    "slug": "comfortable-activewear-shorts"
  },
  {
    "name": "performance activewear trousers",
    "slug": "performance-activewear-trousers"
  },
  {
    "name": "tailored activewear joggers",
    "slug": "tailored-activewear-joggers"
  },
  {
    "name": "relaxed activewear trousers",
    "slug": "relaxed-activewear-trousers"
  },
  {
    "name": "everyday activewear joggers",
    "slug": "everyday-activewear-joggers"
  },
  {
    "name": "lightweight activewear shorts",
    "slug": "lightweight-activewear-shorts"
  },
  {
    "name": "quick-dry activewear t-shirts",
    "slug": "quick-dry-activewear-t-shirts"
  },
  {
    "name": "durable activewear trousers",
    "slug": "durable-activewear-trousers"
  },
  {
    "name": "gym-ready activewear shorts",
    "slug": "gym-ready-activewear-shorts"
  },
  {
    "name": "four-way activewear joggers",
    "slug": "four-way-activewear-joggers"
  },
  {
    "name": "casual activewear t-shirts",
    "slug": "casual-activewear-t-shirts"
  },
  {
    "name": "modern activewear joggers",
    "slug": "modern-activewear-joggers"
  },
  {
    "name": "sweat-resistant activewear shorts",
    "slug": "sweat-resistant-activewear-shorts"
  },
  {
    "name": "wrinkle-free activewear trousers",
    "slug": "wrinkle-free-activewear-trousers"
  },
  {
    "name": "functional activewear joggers",
    "slug": "functional-activewear-joggers"
  },
  {
    "name": "stylish activewear trousers",
    "slug": "stylish-activewear-trousers"
  },
  {
    "name": "breathable activewear t-shirts",
    "slug": "breathable-activewear-t-shirts"
  },
  {
    "name": "slim tapered activewear",
    "slug": "slim-tapered-activewear"
  },
  {
    "name": "stretch activewear trousers",
    "slug": "stretch-activewear-trousers"
  },
  {
    "name": "athletic activewear joggers",
    "slug": "athletic-activewear-joggers"
  },
  {
    "name": "sweat-wicking activewear t-shirts",
    "slug": "sweat-wicking-activewear-t-shirts"
  },
  {
    "name": "flexible activewear trousers",
    "slug": "flexible-activewear-trousers"
  },
  {
    "name": "lightweight and breathable activewear joggers",
    "slug": "lightweight-and-breathable-activewear-joggers"
  },
  {
    "name": "wrinkle-resistant tailored activewear trousers",
    "slug": "wrinkle-resistant-tailored-activewear-trousers"
  },
  {
    "name": "stretchable four-way activewear joggers",
    "slug": "stretchable-four-way-activewear-joggers"
  },
  {
    "name": "versatile quick-dry activewear trousers",
    "slug": "versatile-quick-dry-activewear-trousers"
  },
  {
    "name": "moisture-wicking casual activewear shorts",
    "slug": "moisture-wicking-casual-activewear-shorts"
  },
  {
    "name": "tailored slim fit activewear joggers",
    "slug": "tailored-slim-fit-activewear-joggers"
  },
  {
    "name": "comfortable breathable activewear t-shirts",
    "slug": "comfortable-breathable-activewear-t-shirts"
  },
  {
    "name": "slim tapered tailored activewear trousers",
    "slug": "slim-tapered-tailored-activewear-trousers"
  },
  {
    "name": "relaxed fit performance activewear joggers",
    "slug": "relaxed-fit-performance-activewear-joggers"
  },
  {
    "name": "everyday functional activewear trousers",
    "slug": "everyday-functional-activewear-trousers"
  },
  {
    "name": "four-way stretch activewear t-shirts",
    "slug": "four-way-stretch-activewear-t-shirts"
  },
  {
    "name": "modern flexible tailored activewear joggers",
    "slug": "modern-flexible-tailored-activewear-joggers"
  },
  {
    "name": "stylish wrinkle-resistant activewear trousers",
    "slug": "stylish-wrinkle-resistant-activewear-trousers"
  },
  {
    "name": "comfortable durable activewear shorts",
    "slug": "comfortable-durable-activewear-shorts"
  },
  {
    "name": "performance-focused breathable activewear joggers",
    "slug": "performance-focused-breathable-activewear-joggers"
  },
  {
    "name": "tailored wrinkle-free activewear trousers",
    "slug": "tailored-wrinkle-free-activewear-trousers"
  },
  {
    "name": "relaxed casual slim fit activewear",
    "slug": "relaxed-casual-slim-fit-activewear"
  },
  {
    "name": "durable sweat-wicking activewear trousers",
    "slug": "durable-sweat-wicking-activewear-trousers"
  },
  {
    "name": "moisture-wicking four-way activewear joggers",
    "slug": "moisture-wicking-four-way-activewear-joggers"
  },
  {
    "name": "versatile stretch tailored activewear shorts",
    "slug": "versatile-stretch-tailored-activewear-shorts"
  },
  {
    "name": "functional lightweight casual activewear joggers",
    "slug": "functional-lightweight-casual-activewear-joggers"
  },
  {
    "name": "breathable wrinkle-free activewear trousers",
    "slug": "breathable-wrinkle-free-activewear-trousers"
  },
  {
    "name": "slim fit casual activewear joggers",
    "slug": "slim-fit-casual-activewear-joggers"
  },
  {
    "name": "lightweight tailored modern activewear trousers",
    "slug": "lightweight-tailored-modern-activewear-trousers"
  },
  {
    "name": "comfortable quick-dry activewear shorts",
    "slug": "comfortable-quick-dry-activewear-shorts"
  },
  {
    "name": "flexible stretchable tailored activewear joggers",
    "slug": "flexible-stretchable-tailored-activewear-joggers"
  },
  {
    "name": "modern casual everyday activewear trousers",
    "slug": "modern-casual-everyday-activewear-trousers"
  },
  {
    "name": "premium tailored breathable activewear joggers",
    "slug": "premium-tailored-breathable-activewear-joggers"
  },
  {
    "name": "gym-ready wrinkle-resistant activewear trousers",
    "slug": "gym-ready-wrinkle-resistant-activewear-trousers"
  },
  {
    "name": "relaxed tailored fit activewear joggers",
    "slug": "relaxed-tailored-fit-activewear-joggers"
  },
  {
    "name": "casual stretch slim fit activewear",
    "slug": "casual-stretch-slim-fit-activewear"
  },
  {
    "name": "breathable moisture-wicking activewear joggers",
    "slug": "breathable-moisture-wicking-activewear-joggers"
  },
  {
    "name": "lightweight stretchable performance activewear shorts",
    "slug": "lightweight-stretchable-performance-activewear-shorts"
  },
  {
    "name": "stylish tailored four-way activewear joggers",
    "slug": "stylish-tailored-four-way-activewear-joggers"
  },
  {
    "name": "durable relaxed fit activewear trousers",
    "slug": "durable-relaxed-fit-activewear-trousers"
  },
  {
    "name": "wrinkle-free performance tailored activewear",
    "slug": "wrinkle-free-performance-tailored-activewear"
  },
  {
    "name": "everyday functional breathable activewear trousers",
    "slug": "everyday-functional-breathable-activewear-trousers"
  },
  {
    "name": "sweat-wicking stretchable activewear t-shirts",
    "slug": "sweat-wicking-stretchable-activewear-t-shirts"
  },
  {
    "name": "slim tapered wrinkle-free activewear",
    "slug": "slim-tapered-wrinkle-free-activewear"
  },
  {
    "name": "relaxed functional modern activewear joggers",
    "slug": "relaxed-functional-modern-activewear-joggers"
  },
  {
    "name": "flexible tailored stretch activewear trousers",
    "slug": "flexible-tailored-stretch-activewear-trousers"
  },
  {
    "name": "premium wrinkle-resistant activewear shorts",
    "slug": "premium-wrinkle-resistant-activewear-shorts"
  },
  {
    "name": "comfortable four-way activewear joggers",
    "slug": "comfortable-four-way-activewear-joggers"
  },
  {
    "name": "breathable modern casual activewear trousers",
    "slug": "breathable-modern-casual-activewear-trousers"
  },
  {
    "name": "stylish lightweight activewear joggers",
    "slug": "stylish-lightweight-activewear-joggers"
  },
  {
    "name": "casual tailored sweat-resistant activewear",
    "slug": "casual-tailored-sweat-resistant-activewear"
  },
  {
    "name": "gym-ready stretchable activewear trousers",
    "slug": "gym-ready-stretchable-activewear-trousers"
  },
  {
    "name": "four-way slim tailored activewear joggers",
    "slug": "four-way-slim-tailored-activewear-joggers"
  },
  {
    "name": "lightweight breathable functional activewear joggers",
    "slug": "lightweight-breathable-functional-activewear-joggers"
  },
  {
    "name": "comfortable sweat-resistant tailored activewear",
    "slug": "comfortable-sweat-resistant-tailored-activewear"
  },
  {
    "name": "casual men's clothing",
    "slug": "casual-mens-clothing"
  },
  {
    "name": "stylish men's clothing",
    "slug": "stylish-mens-clothing"
  },
  {
    "name": "modern men's clothing",
    "slug": "modern-mens-clothing"
  },
  {
    "name": "tailored men's clothing",
    "slug": "tailored-mens-clothing"
  },
  {
    "name": "everyday men's clothing",
    "slug": "everyday-mens-clothing"
  },
  {
    "name": "premium men's clothing",
    "slug": "premium-mens-clothing"
  },
  {
    "name": "versatile men's clothing",
    "slug": "versatile-mens-clothing"
  },
  {
    "name": "relaxed men's clothing",
    "slug": "relaxed-mens-clothing"
  },
  {
    "name": "functional men's clothing",
    "slug": "functional-mens-clothing"
  },
  {
    "name": "lightweight men's clothing",
    "slug": "lightweight-mens-clothing"
  },
  {
    "name": "breathable men's clothing",
    "slug": "breathable-mens-clothing"
  },
  {
    "name": "slim fit menswear",
    "slug": "slim-fit-menswear"
  },
  {
    "name": "formal mens clothing",
    "slug": "formal-mens-clothing"
  },
  {
    "name": "active men's clothing",
    "slug": "active-mens-clothing"
  },
  {
    "name": "casual menswear online",
    "slug": "casual-menswear-online"
  },
  {
    "name": "menswear tailored fit",
    "slug": "menswear-tailored-fit"
  },
  {
    "name": "stylish menswear outfits",
    "slug": "stylish-menswear-outfits"
  },
  {
    "name": "everyday mens clothing",
    "slug": "everyday-mens-clothing"
  },
  {
    "name": "performance men's clothing",
    "slug": "performance-mens-clothing"
  },
  {
    "name": "durable men's clothing",
    "slug": "durable-mens-clothing"
  },
  {
    "name": "menswear slim fit",
    "slug": "menswear-slim-fit"
  },
  {
    "name": "comfortable menswear collection",
    "slug": "comfortable-menswear-collection"
  },
  {
    "name": "wrinkle-free men's clothing",
    "slug": "wrinkle-free-mens-clothing"
  },
  {
    "name": "casual menswear brands",
    "slug": "casual-menswear-brands"
  },
  {
    "name": "menswear casual collection",
    "slug": "menswear-casual-collection"
  },
  {
    "name": "breathable slim menswear",
    "slug": "breathable-slim-menswear"
  },
  {
    "name": "modern tailored mens clothing",
    "slug": "modern-tailored-mens-clothing"
  },
  {
    "name": "premium casual menswear",
    "slug": "premium-casual-menswear"
  },
  {
    "name": "relaxed tailored menswear",
    "slug": "relaxed-tailored-menswear"
  },
  {
    "name": "lightweight stylish menswear",
    "slug": "lightweight-stylish-menswear"
  },
  {
    "name": "men's clothing collection",
    "slug": "mens-clothing-collection"
  },
  {
    "name": "classic men's clothing",
    "slug": "classic-mens-clothing"
  },
  {
    "name": "men's clothing essentials",
    "slug": "mens-clothing-essentials"
  },
  {
    "name": "tailored modern menswear",
    "slug": "tailored-modern-menswear"
  },
  {
    "name": "premium everyday men's clothing",
    "slug": "premium-everyday-mens-clothing"
  },
  {
    "name": "comfortable men's clothing",
    "slug": "comfortable-mens-clothing"
  },
  {
    "name": "versatile menswear outfits",
    "slug": "versatile-menswear-outfits"
  },
  {
    "name": "performance casual menswear",
    "slug": "performance-casual-menswear"
  },
  {
    "name": "functional stylish menswear",
    "slug": "functional-stylish-menswear"
  },
  {
    "name": "smart casual men's clothing",
    "slug": "smart-casual-mens-clothing"
  },
  {
    "name": "men's clothing online",
    "slug": "mens-clothing-online"
  },
  {
    "name": "formal men's clothing",
    "slug": "formal-mens-clothing"
  },
  {
    "name": "men's clothing store",
    "slug": "mens-clothing-store"
  },
  {
    "name": "menswear online store",
    "slug": "menswear-online-store"
  },
  {
    "name": "luxury men's clothing",
    "slug": "luxury-mens-clothing"
  },
  {
    "name": "best men's clothing",
    "slug": "best-mens-clothing"
  },
  {
    "name": "menswear for work",
    "slug": "menswear-for-work"
  },
  {
    "name": "modern menswear outfits",
    "slug": "modern-menswear-outfits"
  },
  {
    "name": "casual men's clothing",
    "slug": "casual-mens-clothing"
  },
  {
    "name": "men's clothing sale",
    "slug": "mens-clothing-sale"
  },
  {
    "name": "tailored menswear collection",
    "slug": "tailored-menswear-collection"
  },
  {
    "name": "everyday mens clothing",
    "slug": "everyday-mens-clothing"
  },
  {
    "name": "premium menswear collection",
    "slug": "premium-menswear-collection"
  },
  {
    "name": "wrinkle-resistant menswear",
    "slug": "wrinkle-resistant-menswear"
  },
  {
    "name": "lightweight men's clothing",
    "slug": "lightweight-mens-clothing"
  },
  {
    "name": "relaxed fit menswear",
    "slug": "relaxed-fit-menswear"
  },
  {
    "name": "breathable men's clothing",
    "slug": "breathable-mens-clothing"
  },
  {
    "name": "durable men's clothing",
    "slug": "durable-mens-clothing"
  },
  {
    "name": "slim fit menswear",
    "slug": "slim-fit-menswear"
  },
  {
    "name": "smart casual menswear",
    "slug": "smart-casual-menswear"
  },
  {
    "name": "versatile men's clothing",
    "slug": "versatile-mens-clothing"
  },
  {
    "name": "relaxed fit men's clothing",
    "slug": "relaxed-fit-mens-clothing"
  },
  {
    "name": "tailored modern menswear",
    "slug": "tailored-modern-menswear"
  },
  {
    "name": "functional men's clothing",
    "slug": "functional-mens-clothing"
  },
  {
    "name": "active men's clothing",
    "slug": "active-mens-clothing"
  },
  {
    "name": "stylish men's clothing",
    "slug": "stylish-mens-clothing"
  },
  {
    "name": "men's clothing essentials",
    "slug": "mens-clothing-essentials"
  },
  {
    "name": "performance men's clothing",
    "slug": "performance-mens-clothing"
  },
  {
    "name": "durable men's clothing",
    "slug": "durable-mens-clothing"
  },
  {
    "name": "breathable slim menswear",
    "slug": "breathable-slim-menswear"
  },
  {
    "name": "modern tailored men's clothing",
    "slug": "modern-tailored-mens-clothing"
  },
  {
    "name": "comfortable men's clothing",
    "slug": "comfortable-mens-clothing"
  },
  {
    "name": "lightweight stylish menswear",
    "slug": "lightweight-stylish-menswear"
  },
  {
    "name": "affordable casual menswear",
    "slug": "affordable-casual-menswear"
  },
  {
    "name": "luxury tailored men's clothing",
    "slug": "luxury-tailored-mens-clothing"
  },
  {
    "name": "fashionable men's clothing",
    "slug": "fashionable-mens-clothing"
  },
  {
    "name": "tailored fit menswear",
    "slug": "tailored-fit-menswear"
  },
  {
    "name": "classic men's clothing",
    "slug": "classic-mens-clothing"
  },
  {
    "name": "wrinkle-free men's clothing",
    "slug": "wrinkle-free-mens-clothing"
  },
  {
    "name": "timeless men's clothing",
    "slug": "timeless-mens-clothing"
  },
  {
    "name": "best menswear collection",
    "slug": "best-menswear-collection"
  },
  {
    "name": "high-quality men's clothing",
    "slug": "high-quality-mens-clothing"
  },
  {
    "name": "professional men's clothing",
    "slug": "professional-mens-clothing"
  },
  {
    "name": "premium formal menswear",
    "slug": "premium-formal-menswear"
  },
  {
    "name": "tailored casual men's clothing",
    "slug": "tailored-casual-mens-clothing"
  },
  {
    "name": "functional stylish men's clothing",
    "slug": "functional-stylish-mens-clothing"
  },
  {
    "name": "modern wrinkle-resistant menswear",
    "slug": "modern-wrinkle-resistant-menswear"
  },
  {
    "name": "comfortable casual men's clothing",
    "slug": "comfortable-casual-mens-clothing"
  },
  {
    "name": "breathable tailored men's clothing",
    "slug": "breathable-tailored-mens-clothing"
  },
  {
    "name": "stylish casual men's clothing online",
    "slug": "stylish-casual-mens-clothing-online"
  },
  {
    "name": "premium tailored fit menswear outfits",
    "slug": "premium-tailored-fit-menswear-outfits"
  },
  {
    "name": "relaxed casual everyday men's clothing",
    "slug": "relaxed-casual-everyday-mens-clothing"
  },
  {
    "name": "breathable modern tailored men's clothing",
    "slug": "breathable-modern-tailored-mens-clothing"
  },
  {
    "name": "wrinkle-free slim fit men's clothing",
    "slug": "wrinkle-free-slim-fit-mens-clothing"
  },
  {
    "name": "tailored casual versatile men's clothing",
    "slug": "tailored-casual-versatile-mens-clothing"
  },
  {
    "name": "lightweight wrinkle-free men's clothing",
    "slug": "lightweight-wrinkle-free-mens-clothing"
  },
  {
    "name": "durable stylish casual menswear collection",
    "slug": "durable-stylish-casual-menswear-collection"
  },
  {
    "name": "slim fit wrinkle-resistant menswear outfits",
    "slug": "slim-fit-wrinkle-resistant-menswear-outfits"
  },
  {
    "name": "versatile everyday stylish menswear online",
    "slug": "versatile-everyday-stylish-menswear-online"
  },
  {
    "name": "modern functional casual men's clothing",
    "slug": "modern-functional-casual-mens-clothing"
  },
  {
    "name": "premium stylish everyday men's clothing",
    "slug": "premium-stylish-everyday-mens-clothing"
  },
  {
    "name": "casual tailored slim fit men's clothing",
    "slug": "casual-tailored-slim-fit-mens-clothing"
  },
  {
    "name": "relaxed casual slim fit men's clothing",
    "slug": "relaxed-casual-slim-fit-mens-clothing"
  },
  {
    "name": "tailored fit wrinkle-free men's clothing",
    "slug": "tailored-fit-wrinkle-free-mens-clothing"
  },
  {
    "name": "professional tailored formal men's clothing",
    "slug": "professional-tailored-formal-mens-clothing"
  },
  {
    "name": "relaxed fit durable men's clothing collection",
    "slug": "relaxed-fit-durable-mens-clothing-collection"
  },
  {
    "name": "high-quality stylish casual menswear outfits",
    "slug": "high-quality-stylish-casual-menswear-outfits"
  }
];
/**
 * Obtiene una palabra de forma aleatoria del array de palabras.
 * @returns {Object} Un objeto con el nombre y slug de una palabra aleatoria.
 */
function getRandomWord() {
  const randomIndex = Math.floor(Math.random() * words.length);
  return words[randomIndex];
}

/**
 * Obtiene el slug de una palabra aleatoria.
 * @returns {String} El slug de una palabra aleatoria.
 */
function getRandomWordSlug() {
  const randomWord = getRandomWord();
  return randomWord.slug;
}

/**
 * Obtiene el nombre de una palabra aleatoria.
 * @returns {String} El nombre de una palabra aleatoria.
 */
function getRandomWordName() {
  const randomWord = getRandomWord();
  return randomWord.name;
}
// Hacer las funciones accesibles globalmente
window.getRandomWord = getRandomWord;
window.getRandomWordSlug = getRandomWordSlug;
window.getRandomWordName = getRandomWordName;